import React from "react";

import { toast } from "react-toastify";
import { isEnabled } from "utils/featureFlags";

import { push } from "connected-react-router";

import moment from "moment";

import { PAGE_TYPE, setPageTitle } from "containers/App/reducer";

import { DEFAULT_MIN_EXPLORE_SAMPLE_SIZE } from "utils/insight/insights";

import { getResponseContent } from "utils/chat/completion";

import * as BlueprintAPI from "api/BlueprintAPI";
import * as DatasetAPI from "api/DatasetAPI";
import * as ReportAPI from "api/ReportAPI";

import * as reportReducer from "containers/Report/ReportReducer";
import { updateReportR, CHART_TYPES } from "containers/Report/ReportReducer";

import * as setupReducer from "containers/Setup/reducer";
import * as foldersReducer from "containers/Folders/reducer";
import * as homeReducer from "containers/Home/reducer";
import * as projectReducer from "containers/Project/reducer";
import * as nextTransformReducer from "containers/Next/Transform/TransformReducer";
import * as nextModelsReducer from "containers/Next/Models/ModelsReducer";
import * as nextMonitoringReducer from "containers/Next/Monitoring/NextMonitoringReducer";
import * as marketReducer from "containers/Market/MarketReducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as loginReducer from "containers/Login/reducer";
import * as datasetReducer from "containers/Home/reducer";
import * as globalReducer from "containers/App/reducer";
import * as accountsReducer from "containers/Accounts/reducer";
import * as runReducer from "containers/Run/reducer";
import * as lookerSettingsReducer from "containers/LookerSettings/reducer";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as chatAppReducer from "containers/ChatApp/reducer";
import * as llmReducer from "containers/LanguageModelArtifact/reducer";
import * as contentGenerationReducer from "containers/ContentGeneration/reducer";
import * as aiServiceReducer from "containers/AiService/reducer";
import * as fineTuningReducer from "containers/FineTuning/reducer";
import * as templateReducer from "containers/Templates/reducer";

import pptxgen from "pptxgenjs";
import aibleHelix from "images/aibleHelix.png";
import aibleTransparentLogo from "images/Aible_Logo/aibleTransparentLogo.png";
import aibleCenterTransparentLogo from "images/Aible_Logo/aibleCenterTransparentLogo.png";
import aibleSmallTransparentLogo from "images/Aible_Logo/smallAibleTransparentLogo.png";

import { delay } from "utils/promise";
import * as chatDetailsReducer from "containers/ChatDetails/reducer";
import { getMessageContentReferenceData, hasOutputContent } from "types/chat_conversation";
import * as viewReducer from "containers/View/reducer";
import {
  getMinimumValueCount as getDatasetMinimumValueCount,
  getOutcome as getDatasetOutcome
} from "containers/Sense/dataset-selectors";
import { builderFromDataset, buildFilterExpression } from "@/utils/relation";
import * as relationReducer from "@/containers/Relation/reducer";
import { isColumn } from "@/utils/insight/properties";
import { AibleClientFactory } from "@/client/aible/factory";
import { getTimeSeriesFrequencyFromDate } from "@/components/Tiles/Sense/SmallDateChart";
import * as aibleAnywhereReducer from "@/containers/AibleAnywhere/reducer";

const UPDATE_BASE = "next/UPDATE_BASE";
const UPDATE_FIELD = "next/UPDATE_FIELD";
const UPDATE_FIELD_VALUE = "next/UPDATE_FIELD_VALUE";
const UPDATE_COMPARISON_OPTION = "next/UPDATE_COMPARISON_OPTION";
const UPDATE_HEX = "next/UPDATE_HEX";
const UPDATE_HOVER = "next/UPDATE_HOVER";
const RESET_ACTIONS = "next/RESET_ACTIONS";

const initialState = {};

const HEX_SIZE = 128;
const HEXAGON_RADIUS = 8;

export const BESTCHART_SIZE = 16;

export const searchTypeOptions = [
  { value: "All Insights", label: "All Insights" },
  { value: "Descriptive", label: "Descriptive" },
  { value: "Correlation", label: "Correlation" },
  { value: "ModelDriver", label: "Model Drivers" }
  //{ value: "Popularity", label: "Popularity" },

  // DISABLED NLQ, UNCOMMENT TO BRNG BACK
  //{ value: "NLQ", label: "NLQ" },
];

export const CHART_SORT_OPTIONS = [
  { value: "COUNT", label: "Count" },
  { value: "VALUE", label: "Value" }
];

export const HEXAGON_NODES = {
  FIRST_ORDER_CHART: "First Order Chart",
  SECOND_ORDER_CHART: "Second Order Chart",
  DRILL_IN: "Drill In",
  DRILL_IN_CLUSTER: "Drill In + Cluster",
  FIRST_VARIABLE: "First Variable",
  SECOND_VARIABLE: "Second Variable",
  STAT_ASSOC: "Statistical Association",
  POPULAR: "Popular",
  VOTING: "Model Drivers",
  VOTING_CHART: "Voting Chart",
  MUSCLE: "Muscle Chart",
  EXPERT: "Expert",
  CONSULTANT: "Consultant",
  ADD_JOB: "Add Job",
  TEXT: "Text",
  NONE: "None"
};

// TODO: Overridden in NextSearch component to get around LaunchDarkly init problems here
export const DASHBOARD_LAYOUT_OPTIONS = [
  { value: "REPORT", label: "Layout: Report" },
  { value: "INFO", label: "Layout: Infographic" },
  { value: "TILED", label: "Layout: Tile Dashboard" }
];

export const DIRECTION_NODES = [
  HEXAGON_NODES.FIRST_VARIABLE,
  HEXAGON_NODES.SECOND_VARIABLE,
  HEXAGON_NODES.STAT_ASSOC,
  HEXAGON_NODES.POPULAR,
  HEXAGON_NODES.VOTING
];

export const DIRECTION_NODES_SINGLE = [
  HEXAGON_NODES.DRILL_IN,
  HEXAGON_NODES.DRILL_IN_CLUSTER,
  HEXAGON_NODES.STAT_ASSOC,
  HEXAGON_NODES.POPULAR,
  HEXAGON_NODES.VOTING
];

export const DEFAULT_NARRATIVES = {
  behaviorLabel: "The behavior of",
  changeLabel: "changes when",
  relativeLabel: "relative to",
  foundLabel: "models found that",
  impactLabel: "impact on",
  relationshipLabel: "relationship",
  driverLabel: "driver",
  valueLabel: "value"
};

export const colors = [
  // "rgba(12, 169, 201, 1)",
  // "rgba(211, 78, 226, 1)",
  // "rgba(66, 177, 0, 1)",
  // "rgba(72, 135, 244, 1)",
  // "rgba(221, 83, 82, 1)",
  // "rgba(18, 191, 146, 1)",
  // "rgba(32, 202, 232, 1)",
  // "rgba(232, 121, 249, 1)",
  // "rgba(130, 210, 0, 1)",
  // "rgba(96, 165, 250, 1)",
  // "rgba(248, 113, 113, 1)",
  // "rgba(52, 211, 153, 1)",
  // "rgba(82, 220, 236, 1)",
  // "rgba(227, 150, 245, 1)",
  // "rgba(152, 232, 24, 1)",
  // "rgba(109, 185, 253, 1)",
  // "rgba(255, 142, 140, 1)",
  // "rgba(103, 226, 173, 1)",
  // "rgba(127, 230, 238, 1)",
  // "rgba(226, 171, 244, 1)",
  // "rgba(180, 244, 54, 1)",
  // "rgba(117, 197, 255, 1)",
  // "rgba(255, 164, 160, 1)",
  // "rgba(140, 237, 181, 1)",
  "rgba(60, 203, 127, 1)",
  "rgba(128, 152, 249, 1)",
  "rgba(189, 180, 254, 1)",
  "rgba(83, 177, 253, 1)",
  "rgba(246, 112, 199, 1)",
  "rgba(255, 105, 46, 1)",
  "rgba(34, 204, 238, 1)"
];

export const colors_subcolors = {
  "rgba(34, 204, 238, 1)": [
    "rgba(0, 121, 160, 1)",
    "rgba(12, 169, 201, 1)",
    "rgba(32, 202, 232, 1)",
    "rgba(127, 230, 238, 1)"
  ]
};

export const DEFAULT_FORECAST_PERIODS = 12;

export const calcInnerHexSize = (size) => size * 1.65;

export const initialNext = {
  hexSize: HEX_SIZE,
  innerHexSize: calcInnerHexSize(HEX_SIZE),
  hexagonRadius: HEXAGON_RADIUS,
  selectedHex: { x: HEXAGON_RADIUS, y: HEXAGON_RADIUS },
  hexMap: {},
  actionHexMap: {},
  savedHexMap: {},
  hiddenCharts: {},
  pinnedHex: [],
  chartType: "bar",
  isDistribution: false,
  viewIndex: 0,
  activeTab: "TRANSFORM",
  reportLabel: "My Untitled Project",
  searchInsights: [],
  bestCharts: [],
  searchOptions: [],
  savedActions: [],
  searchType: "All Insights",
  lastSearchOptions: {},
  showReplay: false,
  replayIndex: -1,
  explorationKey: 0,
  isHideSearch: true,
  isShowAllDashboard: false,
  projects: {},
  exploreProjectId: undefined,
  lookerCount: 0,
  isLookerLoading: true,
  fineTuneRows: {},
  scrollReportTitle: undefined,
  automaticFineTuningThreshold: 100
};

function nextReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_BASE:
      return {
        ...state,
        ...action.data
      };
    case UPDATE_FIELD:
      return {
        ...state,
        [action.id]: action.data
      };
    case UPDATE_FIELD_VALUE:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          [action.key]: action.data
        }
      };
    case UPDATE_COMPARISON_OPTION:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          comparisonOptions: {
            ...state[action.id]?.comparisonOptions,
            [action.key]: action.data
          }
        }
      };
    case UPDATE_HEX:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          ["selectedHex"]: action.selectedHex,
          ["actionHexMap"]: action.actionHexMap,
          ["hexMap"]: action.hexMap,
          ["viewIndex"]: action.viewIndex,
          ["selectionDirection"]: action.selectionDirection,
          ["selectedChart"]: action.selectedChart,
          ["pinnedHex"]: action.pinnedHex
        }
      };
    case UPDATE_HOVER:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          ["hoverGroup"]: action.hoverGroup,
          ["hoverRibbon"]: action.hoverRibbon,
          ["hoverNode"]: action.hoverNode
        }
      };
    case RESET_ACTIONS:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          ["pinnedHex"]: [],
          ["selectionDirection"]: undefined,
          ["selectedChart"]: undefined,
          ["selectedHex"]: undefined,
          ["isAnimateReturn"]: true,
          ["canHover"]: true
        }
      };
    default:
      return state;
  }
}

/* Selectors */
export function getBase(state) {
  return state.next;
}

export function getNextIds(state) {
  return Object.keys(getBase(state)).filter((k) => {
    return !isNaN(k) && getNext(state, k)?.id;
  });
}

export function getNext(state, id) {
  return getBase(state)?.[id] ? getBase(state)[id] : {};
}

export function getIsKPISelectionOpen(state, id) {
  return getNext(state, id)?.isKPISelectionOpen;
}

export function getSplitColumn(state, id) {
  return getNext(state, id)?.splitColumn;
}

export function getTargetColumn(state, id) {
  return getNext(state, id)?.targetColumn;
}

export function getFineTuneRows(state, id) {
  return getNext(state, id)?.fineTuneRows ?? {};
}

export function getAutomaticFineTuningThreshold(state, id) {
  const threshold = getNext(state, id)?.automaticFineTuningThreshold;
  if (threshold !== undefined && !isNaN(threshold)) {
    return Number(threshold);
  }
  return threshold;
}

// default is the currently selected model
export function getAutomaticFineTuningModelId(state, id) {
  return getNext(state, id)?.automaticFineTuningModelId ?? chatGPTReducer.getModelId(state);
}

// create the default name here
export function getAutomaticFineTuningModelName(state, id) {
  const savedName = getNext(state, id)?.automaticFineTuningModelName;

  if (savedName !== undefined) {
    return savedName;
  }
  const modelId = getAutomaticFineTuningModelId(state, id);
  const modelOptions = chatGPTReducer.getModelOptions(state);
  const retModel = modelOptions.find((o) => o.value === modelId)?.label ?? modelId;

  const chatApp = chatGPTReducer.getChatApp(state);
  const reportName = getReportLabel(state, id);

  const retReportName = chatApp?.name ?? reportName;

  return retModel + " Fine Tuned" + (retReportName ? " for " + retReportName : "");
}

export function getFineTunedModels(state, id) {
  return getNext(state, id)?.fineTunedModels ?? {};
}

export function getCurrentArtifact(state, id) {
  const currentArtifact = getNext(state, id)?.currentArtifact;
  if (currentArtifact !== undefined) {
    return currentArtifact;
  }

  const fineTuneData = llmReducer.getFineTuningDataList(state);

  if (fineTuneData !== undefined && fineTuneData.length > 0) {
    return fineTuneData?.[0];
  }

  return undefined;
}

export function getContinuousGraphDisplayType(state, id) {
  return getNext(state, id)?.continuousGraphDisplayType ?? "AVERAGE";
}

export function getMinimumValueCount(state, id) {
  return getNext(state, id).minimumValueCount ?? DEFAULT_MIN_EXPLORE_SAMPLE_SIZE;
}

export function getExploreDefaultViewMode(state) {
  if (isEnabled("chat-aible-consumer") && !isEnabled("aible-explore") && !isEnabled("aible-optimize")) {
    return "CHATGPT";
  }
  const defaultView = loginReducer.getItem(state, "aible_explore_default_view_mode");
  return defaultView ?? "DASHBOARD";
}

export function updateExploreDefaultViewMode(viewMode) {
  return (dispatch, getState) => {
    return dispatch(loginReducer.storeItem("aible_explore_default_view_mode", viewMode));
  };
}

export function getDashboardLayout(state, id) {
  return getNext(state, id)?.dashboardLayout || DASHBOARD_LAYOUT_OPTIONS?.[0];
}

export function getComparisonDashBoardSortOptions(state, id) {
  const datasetId = getDatasetId(state, id);
  const dataset = homeReducer.getDataset(state, datasetId);

  const outcome = dataset?.fields?.[dataset?.outcome];
  const datasetSuccess = getDatasetSuccess(state, id);

  const successLabel = `${outcome?.label}${datasetSuccess?.label ? ": " + datasetSuccess.label : ""}`;

  const hideChangeInBehavior = chatGPTReducer.getHideChangeInBehavior(state);
  const hideChangeInPopulation = chatGPTReducer.getHideChangeInPopulation(state);
  const hideChangeInOutcome = chatGPTReducer.getHideChangeInOutcome(state);
  const hideChangeInTotalPopulation = chatGPTReducer.getHideChangeInTotalPopulation(state);

  let retOptions = [];
  if (!hideChangeInTotalPopulation) {
    const renameTotalPopulation = chatGPTReducer.getRenameTotalPopulation(state, undefined, undefined, id);
    retOptions = retOptions.concat([
      { value: "POP_TOTAL_ACTUAL", label: `${renameTotalPopulation} (actual)` },
      { value: "POP_TOTAL", label: `${renameTotalPopulation} (%)` }
    ]);
  }

  if (!hideChangeInBehavior) {
    const renameBehavior = chatGPTReducer.getRenameBehavior(state, undefined, undefined, id);
    retOptions.push({ value: "BEHAVIOR", label: `${renameBehavior} %` });
  }

  if (!hideChangeInPopulation) {
    const renamePopulation = chatGPTReducer.getRenamePopulation(state, undefined, undefined, id);
    retOptions.push({ value: "POPULATION", label: `${renamePopulation} %` });
  }

  if (!hideChangeInOutcome) {
    const renameOutcome = chatGPTReducer.getRenameOutcome(state, undefined, undefined, id);
    retOptions = retOptions.concat([
      { value: "WIN_TOTAL_ACTUAL", label: `${renameOutcome} (actual)` },
      { value: "WIN_TOTAL", label: `${renameOutcome} (%)` }
    ]);
  }

  return retOptions;
}

export function getComparisonDashBoardSort(state, id) {
  const savedValue = getNext(state, id)?.dashboardLayout;
  if (savedValue) {
    return savedValue;
  }

  const options = getComparisonDashBoardSortOptions(state, id);
  // Use WIN_TOTAL_ACTUAL as the default sort when there is no saved value.
  const DEFAULT_SORT_VALUE = "WIN_TOTAL_ACTUAL";
  const defaultSortOption = options?.find((o) => o?.value === DEFAULT_SORT_VALUE);
  if (defaultSortOption) {
    return defaultSortOption;
  }

  return options?.[0];
}

const sortOrder = [
  { label: "Ascending", value: "ASC" },
  { label: "Descending", value: "DESC" },
  { label: "Absolute Ascending", value: "ABS_ASC" },
  { label: "Absolute Descending", value: "ABS_DESC" }
];

export function getComparisonDashboardSortOrderOptions(state, id) {
  return sortOrder;
}

export function getComparisonDashBoardSortOrder(state, id) {
  const options = getComparisonDashboardSortOrderOptions(state, id);
  return getNext(state, id)?.comparisonDashboardSortOrder || options.find((o) => o.value === "ABS_DESC") || options[0];
}

// This needs to be rewritten as a dispatch
export function getEmptyInfographicDashboard(state, id) {
  const bestCharts = getBestCharts(state, id);

  if (bestCharts === undefined || bestCharts.length === 0) {
    dispatch(nextTransformReducer.createDefaultExplore(id, undefined, true));
  }

  const datasetId = getDatasetId(state, id);
  const rankedFields = homeReducer.getRankedFields(state, datasetId);

  const searchOpts = rankedFields
    .filter((f, i) => i < 6)
    .map((f) => {
      return {
        filterField: f.label,
        filterValue: f.data?.[0]?.value,
        label: f.label + ": " + f.data?.[0]?.value,
        value: f.label + ": " + f.data?.[0]?.value
      };
    });

  return searchOpts;
}

export function getHasNext(state, id) {
  const next = getNext(state, id);

  return next && Object.keys(next).length > 0 ? true : false;
}

export function getSelectedHex(state, id) {
  const hexagonRadius = getHexagonRadius(state, id);

  return getNext(state, id).selectedHex ? getNext(state, id).selectedHex : { x: hexagonRadius, y: hexagonRadius };
}

export function getIsPowerBI(state, id) {
  return getNext(state, id).isPowerBI;
}

export function getIsLookerDashboard(state, id) {
  return getNext(state, id).isLookerDashboard;
}

export function getIsLookerLoading(state, id) {
  return getNext(state, id).isLookerLoading;
}

export function getLookerDashboardElementCount(state, id) {
  return getNext(state, id).lookerDashboardElementCount ?? 0;
}

export function getLookerCount(state, id) {
  const retId =
    id !== undefined
      ? id
      : id === undefined
        ? getCurrentNextId(state) !== undefined
          ? getCurrentNextId(state)
          : "new"
        : "new";

  return getNext(state, retId).lookerCount ?? 0;
}

export function getHexMap(state, id) {
  return getNext(state, id).hexMap ?? {};
}

export function getHexSize(state, id) {
  return getNext(state, id).hexSize ? getNext(state, id).hexSize : initialNext.hexSize;
}

export function getScrollReportTitle(state, id) {
  return getNext(state, id)?.scrollReportTitle;
}

export function getInnerHexSize(state, id) {
  return getNext(state, id).innerHexSize ? getNext(state, id).innerHexSize : initialNext.innerHexSize;
}

export function getHexagonRadius(state, id) {
  return getNext(state, id).hexagonRadius ? getNext(state, id).hexagonRadius : initialNext.hexagonRadius;
}

export function getHoverGroup(state, id) {
  return getNext(state, id).hoverGroup;
}

export function getHoverRibbon(state, id) {
  return getNext(state, id).hoverRibbon;
}

export function getPinnedHex(state, id) {
  return getNext(state, id).pinnedHex ?? [];
}

export function getPinnedHexList(state, id, isSort = true) {
  const pinnedHexList = getNext(state, id).pinnedHexList;

  const comparisonOptions = getComparisonOptions(state, id);

  if (!isSort || !pinnedHexList) {
    return pinnedHexList ?? [];
  }

  if (comparisonOptions) {
    const sortedList = pinnedHexList.sort((a, b) => {
      if (a.chart?.metadata?.properties?.length !== a.chart?.metadata?.properties?.length) {
        return a.chart?.metadata?.properties?.length - b.chart?.metadata?.properties?.length;
      }
      if (a.chart?.isSecondOrder && !b.chart?.isSecondOrder) {
        return 1;
      }
      if (b.chart?.isSecondOrder && !a.chart?.isSecondOrder) {
        return -1;
      }
      if (b.sortScore !== a.sortScore) {
        return b.sortScore - a.sortScore;
      }
      return a.chart.rank - b.chart.rank;
    });

    return sortedList;
  }

  const sortedList =
    pinnedHexList !== undefined
      ? isSort !== true
        ? pinnedHexList
        : pinnedHexList.sort((a, b) =>
            a?.sortScore > b?.sortScore
              ? 1
              : a?.sortScore < b?.sortScore
                ? -1
                : a?.chart?.scoreRank > b?.chart?.scoreRank
                  ? 1
                  : a?.chart?.scoreRank < b?.chart?.scoreRank
                    ? -1
                    : 0
          )
      : [];

  return sortedList;
}

export function getPinnedHexListWithData(state, id) {
  const fixChart = (chart) => getInsightFromMetadata(state, id, chart?.metadata, false);

  const pinnedHexList = getPinnedHexList(state, id);

  return pinnedHexList.map((p) => fixChart(p.chart));
}

export function getHasModelDrivers(state, id) {
  const projectId = getExploreProjectId(state, id);

  return projectId === undefined ? false : true;
}

export function getExploreProjectId(state, id) {
  return getNext(state, id).exploreProjectId ?? getProjectId(state, id);
}

export function getAgentAutonomyView(state, id) {
  return getNext(state, id).agentAutonomyView;
}

export function getTodoNodes(state, id) {
  const pinnedHex = getPinnedHex(state, id);
  const pinnedHexList = getPinnedHexList(state, id);

  const hexMap = getHexMap(state, id);

  const savedActions = getSavedActions(state, id);

  let todoNodes = [];

  hexMap &&
    Object.keys(hexMap).forEach((hKey) =>
      hexMap[hKey]
        .filter(
          (node) =>
            node?.type !== "Muscle Chart" &&
            pinnedHex.find((n) => n?.chart?.title === node?.chart?.title) === undefined &&
            pinnedHexList.find((n) => n?.chart?.title === node?.chart?.title) === undefined
        )
        .filter(
          (node) =>
            savedActions &&
            savedActions.find(
              (action) => action?.node?.chart?.title && action?.node?.chart?.title === node?.chart?.title
            ) === undefined
        )
        .forEach((node) => todoNodes.push(node))
    );

  return todoNodes.sort((a, b) => a?.chart?.rank - b?.chart?.rank);
}

export function getSearchInsights(state, id) {
  return getNext(state, id).searchInsights;
}

export function getSearchType(state, id) {
  /*
  return getNext(state, id).searchType === "NLQ"
    ? "All Insights"
    : getNext(state, id).searchType;
  */

  if (globalReducer.getIsGoogleMode(state)) {
    return "All Insights";
  }

  return getNext(state, id).searchType;
}

export function getBestCharts(state, id, isFixed = false) {
  return isFixed === true && getNext(state, id).bestCharts !== undefined
    ? getNext(state, id).bestCharts.map((c) => ({
        ...c,
        relatedCharts: c.relatedCharts.map((rc) => ({
          ...rc,
          ...getInsightFromMetadata(state, id, rc?.metadata, false)
        })),
        otherRelatedCharts: c.otherRelatedCharts.map((rc) => ({
          ...rc,
          ...getInsightFromMetadata(state, id, rc?.metadata, false)
        })),
        ...getInsightFromMetadata(state, id, c?.metadata, false)
      }))
    : getNext(state, id).bestCharts;
}

export function getHasExplore(state, id) {
  const datasetId = getDatasetId(state, id);
  const dataset = homeReducer.getDataset(state, datasetId);

  const bestCharts = getBestCharts(state, id);

  if (
    dataset === undefined ||
    homeReducer.getIsExploreReady(state, datasetId) !== true ||
    bestCharts === undefined ||
    bestCharts.length === 0
  ) {
    return false;
  }

  return true;
}

export function getIsExportingLooker(state, id) {
  return getNext(state, id).isExportingLooker;
}

export function getSavedNextId(state, id) {
  return getNext(state, id).savedNextId;
}

export function getIsLeftClosed(state, id) {
  const activeTab = getActiveTab(state, id);

  return getNext(state, id).isLeftClosed && activeTab === "EXPLORE";
}

export function getHexOrder(state, id) {
  return getNext(state, id).hexOrder || {};
}

export function getHasViewedList(state, id) {
  return getNext(state, id).hasViewedList || {};
}

export function getGridType(state, id) {
  return getNext(state, id).gridType;
}

export function getIsHideSearch(state, id) {
  return getNext(state, id).isHideSearch;
}

export function getIsHideLegend(state, id) {
  return getNext(state, id).isHideLegend;
}

export function getIsAngleAxis(state, id) {
  return getNext(state, id).isAngleAxis;
}

export function getDashboardSize(state, id) {
  return getNext(state, id).dashboardSize;
}

export function getLinkedComparisonFocusOptions(state, id) {
  const linkedComparisonProjects = getLinkedComparisonProjects(state, id);

  return Object.keys(linkedComparisonProjects ?? {}).map((k) => ({
    label: k === "@_Original_@" ? "All data" : k,
    value: linkedComparisonProjects?.[k],
    datasetId:
      k === "@_Original_@" && getLinkedOriginalDatasetId(state, linkedComparisonProjects[k]) !== undefined
        ? getLinkedOriginalDatasetId(state, linkedComparisonProjects[k])
        : getDatasetId(state, linkedComparisonProjects[k])
  }));
}

export function getLinkedOriginalDatasetId(state, id) {
  return getNext(state, id)?.linkedOriginalDatasetId;
}

export function getLinkedComparisonIdFromDatasetId(state, id, datasetId) {
  const linkedComparisonProjects = getLinkedComparisonProjects(state, id) ?? {};

  let retId = undefined;

  for (let i = 0; i < Object.keys(linkedComparisonProjects).length; i++) {
    const k = Object.keys(linkedComparisonProjects)[i];
    const dId = getDatasetId(state, linkedComparisonProjects[k]);

    if (k !== "@_Original_@" && dId === datasetId) {
      retId = linkedComparisonProjects[k];
    }
  }

  return retId;
}

export function getDashboardSubchartsCount(state, id) {
  return getNext(state, id).dashboardSubchartsCount ?? 5;
}

export function getLinkedComparisonOriginalId(state, id) {
  const linkedComparisonProjects = getLinkedComparisonProjects(state, id) ?? {};
  const retNextId =
    linkedComparisonProjects?.["@_Original_@"] !== undefined ? linkedComparisonProjects?.["@_Original_@"] : id;

  return retNextId;
}

export function getLinkedComparisonProjects(state, id) {
  return getNext(state, id).linkedComparisonProjects;
}

export function getIsLinkedComparisonCreating(state, id) {
  return getNext(state, id).isLinkedComparisonCreating;
}

export function getIsAutoRecommendLinkedComparison(state, id) {
  return getNext(state, id).isAutoRecommendLinkedComparison;
}

const DEFAULT_CHART_OPTIONS = {
  granularity: 5,
  normalize: true
};

export function getShowHiddenCharts(state, id) {
  return getNext(state, id).showHiddenCharts;
}

export function getHiddenCharts(state, id, isRaw) {
  // if (!isRaw && getShowHiddenCharts(state, id)) {
  //   return {};
  // }
  return getNext(state, id).hiddenCharts;
}

export function getIsChartHidden(state, id, title, isRaw) {
  const isHidden = getHiddenCharts(state, id, isRaw)?.[title];

  return Boolean(isHidden);
}

export function getComparisonChartOptions(state, id) {
  const savedOptions = getNext(state, id)?.comparisonChartOptions;

  return savedOptions ?? DEFAULT_CHART_OPTIONS;
}

export function getComparisonOptions(state, id) {
  const savedOptions = getNext(state, id)?.comparisonOptions;

  return savedOptions;
}

export function getComparisonOptionsCurrentStart(state, id, comparisonOptionsOverride) {
  const comparisonOptions = comparisonOptionsOverride ?? getComparisonOptions(state, id);
  return comparisonOptions?.currentStart;
}

export function getComparisonOptionsCurrentEnd(state, id, comparisonOptionsOverride) {
  const comparisonOptions = comparisonOptionsOverride ?? getComparisonOptions(state, id);
  return comparisonOptions?.currentEnd;
}

export function getComparisonOptionsReferenceStart(state, id, comparisonOptionsOverride) {
  const comparisonOptions = comparisonOptionsOverride ?? getComparisonOptions(state, id);
  return comparisonOptions?.referenceStart;
}

export function getComparisonOptionsReferenceEnd(state, id, comparisonOptionsOverride) {
  const comparisonOptions = comparisonOptionsOverride ?? getComparisonOptions(state, id);
  return comparisonOptions?.referenceEnd;
}

export function getIsWhatsChanged(state, id, comparisonOptionsOverride) {
  const comparisonOptions = comparisonOptionsOverride ?? getComparisonOptions(state, id);
  return comparisonOptions?.isEnabled === true || (comparisonOptions && comparisonOptions?.isEnabled === undefined);
}

export function getIsCurrentDate(state, id, val, comparisonOptionsOverride) {
  if (!comparisonOptionsOverride) {
    const isWhatsChanged = getIsWhatsChanged(state, id);
    if (!isWhatsChanged) {
      return false;
    }
  }

  const currentStart = getComparisonOptionsCurrentStart(state, id, comparisonOptionsOverride);
  const currentEnd = getComparisonOptionsCurrentEnd(state, id, comparisonOptionsOverride);

  return getIsInRange(val, currentStart, currentEnd);
}

export function getIsReferenceDate(state, id, val, comparisonOptionsOverride) {
  if (!comparisonOptionsOverride) {
    const isWhatsChanged = getIsWhatsChanged(state, id);
    if (!isWhatsChanged) {
      return false;
    }
  }

  const isCurrentPeriod = getIsCurrentDate(state, id, val, comparisonOptionsOverride);
  if (isCurrentPeriod) {
    return false;
  }

  const referenceStart = getComparisonOptionsReferenceStart(state, id, comparisonOptionsOverride);
  const referenceEnd = getComparisonOptionsReferenceEnd(state, id, comparisonOptionsOverride);

  return getIsInRange(val, referenceStart, referenceEnd);
}

export function getIsInRange(date, startDate, endDate) {
  const vDate = moment(date);
  return vDate.isSameOrAfter(startDate) && vDate.isSameOrBefore(endDate);
}

export function getIsChangeFocusColumns(state, id) {
  return getNext(state, id)?.isChangeFocusColumns;
}

export function getIsChangeFocusColumnsByIndex(state, id, index) {
  return getIsChangeFocusColumns(state, id)?.[index] ?? false;
}

export function getFocusColumns(state, id) {
  return getNext(state, id)?.focusColumns;
}

export function getFocusColumnsByIndex(state, id, index) {
  return getFocusColumns(state, id)?.[index];
}

export function getHasViewed(state, id, node) {
  const hasViewedList = getHasViewedList(state, id);

  const title = node?.title || node?.chart?.title || node?.chart?.chart?.title;

  return hasViewedList[title] === true ? true : false;
}

export function getHexOrderHex(state, id, hex) {
  if (getActiveTab(state, id) !== "EXPLORE") {
    return undefined;
  }

  const hexOrder = getHexOrder(state, id);

  return hexOrder[hex.x + "_" + hex.y];
}

export function getChartOrder(state, id) {
  const bestCharts = getBestCharts(state, id);
  const hexMap = getHexMap(state, id);
  let allCharts = [];
  Object.keys(hexMap).forEach((hKey) => {
    const nodes = hexMap[hKey];
    if (Array.isArray(nodes)) {
      nodes.forEach((n) => allCharts.push(n));
    }
  });
  let retCharts = [];

  bestCharts &&
    bestCharts.forEach((chart) => {
      const column = chart?.metadata?.properties?.[0].column;

      const firstOrderKey = allCharts.find(
        (n) => n.fields && Object.keys(n.fields).length === 1 && n.fields?.[0]?.label === column
      );

      if (firstOrderKey) {
        retCharts.push(firstOrderKey.x + "_" + firstOrderKey.y);
      }

      const secondOrderKeys = allCharts.filter((n) => n?.aParent?.chart?.scoreRank === chart?.scoreRank);

      if (secondOrderKeys) {
        secondOrderKeys.forEach((sKey) => retCharts.push(sKey.x + "_" + sKey.y));
      }
    });

  return retCharts;
}

export function getBeforeReplayHexMap(state, id) {
  return getNext(state, id).beforeReplayHexMap;
}

export function getReplayIndex(state, id) {
  return getNext(state, id).replayIndex;
}

export function getOutcome(state, id) {
  const datasetId = getDatasetId(state, id);
  const dataset = homeReducer.getDataset(state, datasetId);

  return dataset?.outcome;
}

export function getProjectId(state, id) {
  return getNext(state, id).projectId;
}

export function getIsReportExpand(state, id) {
  return getNext(state, id).isReportExpand;
}

export function getNarrativeMadlibs(state, id) {
  const madlibs = getNext(state, id).narrativeMadlibs ? getNext(state, id).narrativeMadlibs : {};

  const behaviorLabel = madlibs.behaviorLabel || DEFAULT_NARRATIVES.behaviorLabel;
  const changeLabel = madlibs.changeLabel || DEFAULT_NARRATIVES.changeLabel;
  const relativeLabel = madlibs.relativeLabel || DEFAULT_NARRATIVES.relativeLabel;
  const foundLabel = madlibs.foundLabel || DEFAULT_NARRATIVES.foundLabel;
  const impactLabel = madlibs.impactLabel || DEFAULT_NARRATIVES.impactLabel;
  const relationshipLabel = madlibs.relationshipLabel || DEFAULT_NARRATIVES.relationshipLabel;
  const driverLabel = madlibs.driverLabel || DEFAULT_NARRATIVES.driverLabel;
  const valueLabel = madlibs.valueLabel || DEFAULT_NARRATIVES.valueLabel;

  return {
    behaviorLabel,
    changeLabel,
    relativeLabel,
    foundLabel,
    impactLabel,
    relationshipLabel,
    driverLabel,
    valueLabel
  };
}

export function getAllNodeNarrativeMadlibs(state, id) {
  const madlibs = getNext(state, id).nodeNarrativeMadlibs ? getNext(state, id).nodeNarrativeMadlibs : {};

  return madlibs;
}

export function getNodeNarrativeMadlibs(state, id, nodeId) {
  const madlibs = getNext(state, id).nodeNarrativeMadlibs ? getNext(state, id).nodeNarrativeMadlibs : {};
  return madlibs[nodeId];
}

export function getNodeDescriptions(state, id) {
  const nodeDescriptions = getNext(state, id).nodeDescriptions || {};
  return nodeDescriptions;
}

export function getNodeChartTypes(state, id) {
  return getNext(state, id).nodeChartTypes;
}

export function getNodeMadlibs(state, id) {
  const nodeDescriptions = getNext(state, id).nodeMadlibs || {};
  return nodeDescriptions;
}

export function getIsOpenSaveScenarioModal(state, id) {
  return getNext(state, id).isOpenSaveScenarioModal;
}

export function getIsSavingScenario(state, id) {
  return getNext(state, id).isSavingScenario;
}

export function getIsLoadingSuggestedColumns(state, id) {
  return getNext(state, id).isLoadingSuggestedColumns;
}

export function getSuggestedColumns(state, id) {
  return getNext(state, id).suggestedColumns;
}

export function getIsDataLeakageCheck(state, id) {
  return getNext(state, id).isDataLeakageCheck;
}

export function getDataLeakageMessage(state, id) {
  return getNext(state, id).dataLeakageMessage;
}

export function getSimpleFlowStep(state, id) {
  return getNext(state, id).simpleFlowStep;
}

export function getSimpleFlowStepDisplay(state, id) {
  return getNext(state, id).simpleFlowStepDisplay ?? "BEGIN";
}

export function getDisableChatAutosave(state, id) {
  return getNext(state, id).disableChatAutosave;
}

export function getForecastPeriods(state, id) {
  return getNext(state, id)?.forecastPeriods ?? DEFAULT_FORECAST_PERIODS;
}

export function getProjects(state, id) {
  let retProjects = {};

  const report = reportReducer.getReport(state, id);

  report?.metadata?.explorations &&
    Object.keys(report.metadata.explorations).forEach((eKey) => {
      const explore = report.metadata.explorations[eKey];

      if (explore.projects) {
        retProjects = { ...retProjects, ...explore.projects };
      }
    });

  return retProjects;
}

export function getProjectsTransformed(state, id) {
  const projects = getProjects(state, id);
  let retProjects = {};

  Object.keys(projects).forEach((s) => {
    const projectId = projects[s];

    const runId = projectReducer.getRunId(state, projectId);

    const modelSteps = nextModelsReducer.getSavedHexMap(state, id)
      ? Object.keys(nextModelsReducer.getSavedHexMap(state, id)).length - 2
      : 0;
    const MAX_STEPS = 4;
    const stepsRemaining = MAX_STEPS - modelSteps;

    const selectedScenario = projectReducer.getSelectedScenario(state, projectId);
    const approvedScenario = projectReducer.getApprovedScenario(state, projectId, runId);

    const isSelectedApproved = selectedScenario?.isApproved;

    retProjects[s] = {
      projectId: projectId,
      success: s,
      isCreating: projectReducer.getIsCreatingSplit(state, projectId),
      bestModel: projectReducer.getBestModel(state, projectId),
      outcome: getOutcome(state, id),
      netImpactLabel: setupReducer.getNetImpactLabel(state, runId),
      profit: projectReducer.getProfit(state, projectId, runId),
      runId: runId,
      stepsRemaining: stepsRemaining,
      isSelectedApproved: isSelectedApproved
    };
  });

  return retProjects;
}

export function getActiveProject(state, id) {
  const projectId = getProjectId(state, id);

  const projects = getProjectsTransformed(state, id);

  const activeProject = Object.keys(projects).find((pKey) => projects[pKey].projectId === projectId);

  return activeProject ? projects[activeProject] : activeProject;
}

export function getProject(state, id) {
  const projectId = getProjectId(state, id);

  return projectReducer.getProject(state, projectId);
}

export function getActiveSegment(state, id) {
  const projectId = getProjectId(state, id);

  return projectReducer.getActiveSegment(state, projectId);
}

// UPDATE THIS WHEN CHANGE WHERE PROJECTS ARE STORED IN NEXT
export function getNextIdFromProjectId(state, id) {
  const reports = reportReducer.getReports(state);

  let nextId = undefined;

  reports.forEach((report) => {
    if (nextId === undefined && report?.metadata?.explorations) {
      Object.keys(report.metadata.explorations).map((eKey) => {
        const exploration = report.metadata.explorations[eKey];

        if (exploration.projects) {
          Object.keys(exploration.projects).forEach((pKey) => {
            if (exploration.projects[pKey] === id) {
              nextId = report.id;
            }
          });
        }
      });
    }
  });

  return nextId;
}

export function getHasBeforeReplayHexMap(state, id) {
  const hexMap = getBeforeReplayHexMap(state, id);

  return hexMap && Object.keys(hexMap).length > 0 ? true : false;
}

export function getNeighborFromPosition(state, id, x, y, sx = undefined, sy = undefined) {
  const hexagonRadius = getHexagonRadius(state, id);

  const startX = sx !== undefined ? sx : hexagonRadius;
  const startY = sy !== undefined ? sy : hexagonRadius;

  let yDelta = -1;

  if (startX % 2 !== 0) {
    yDelta = 1;
  }

  const fieldIndex =
    x === startX && y === startY - 1
      ? 0
      : x === startX + 1 && y === startY + yDelta
        ? 1
        : x === startX + 1 && y === startY
          ? 2
          : x === startX && y === startY + 1
            ? 3
            : x === startX - 1 && y === startY
              ? 4
              : x === startX - 1 && y === startY + yDelta
                ? 5
                : undefined;

  return fieldIndex;
}

export function getFieldFromPosition(state, id, x, y, sx = undefined, sy = undefined) {
  const datasetId = getDatasetId(state, id);

  const rankedFields = homeReducer.getRankedFields(state, datasetId);
  const neighborIndex = getNeighborFromPosition(state, id, x, y, sx, sy);

  return neighborIndex !== undefined && rankedFields !== undefined ? rankedFields[neighborIndex] : undefined;
}

export function getSelectedNeightbors(state, id, x, y) {
  const selectedHex = getSelectedHex(state, id);

  const hexagonRadius = getHexagonRadius(state, id);

  return selectedHex === undefined ? undefined : getFieldFromPosition(state, id, x, y, hexagonRadius, hexagonRadius);
}

export function getDoubleFieldFromPosition(state, id, x, y) {
  const hexagonRadius = getHexagonRadius(state, id);
  const currentField = getFieldFromPosition(state, id, x, y);

  return currentField
    ? undefined
    : x === hexagonRadius + 1 && y === hexagonRadius - 2
      ? [getFieldFromPosition(state, id, x - 1, y + 1), getFieldFromPosition(state, id, x, y + 1)]
      : x === hexagonRadius + 2 && y === hexagonRadius
        ? [getFieldFromPosition(state, id, x - 1, y - 1), getFieldFromPosition(state, id, x - 1, y)]
        : x === hexagonRadius + 2 && y === hexagonRadius
          ? [getFieldFromPosition(state, id, x - 1, y - 1), getFieldFromPosition(state, id, x - 1, y)]
          : x === hexagonRadius + 1 && y === hexagonRadius + 1
            ? [getFieldFromPosition(state, id, x, y - 1), getFieldFromPosition(state, id, x - 1, y)]
            : x === hexagonRadius - 1 && y === hexagonRadius + 1
              ? [getFieldFromPosition(state, id, x + 1, y), getFieldFromPosition(state, id, x, y - 1)]
              : x === hexagonRadius - 2 && y === hexagonRadius
                ? [getFieldFromPosition(state, id, x + 1, y), getFieldFromPosition(state, id, x + 1, y - 1)]
                : x === hexagonRadius - 1 && y === hexagonRadius - 2
                  ? [getFieldFromPosition(state, id, x, y + 1), getFieldFromPosition(state, id, x + 1, y + 1)]
                  : undefined;
}

export function getHexagonFields(state, id, hex) {
  const firstOrderField = getFieldFromPosition(state, id, hex.x, hex.y);
  const doubleOrderFields = undefined; //getDoubleFieldFromPosition(state, id, hex.x, hex.y);
  const selectedNeighbors = getSelectedNeightbors(state, id, hex.x, hex.y);

  const hexMap = getHexMap(state, id);
  const hKey = hex.x + "_" + hex.y;

  return hexMap[hKey]
    ? hexMap[hKey].fields
    : firstOrderField
      ? { 0: firstOrderField }
      : doubleOrderFields
        ? { 0: doubleOrderFields[0], 1: doubleOrderFields[1] }
        : selectedNeighbors
          ? { 0: selectedNeighbors }
          : {};
}

export function getChartsFromDirection(state, id, fields, direction) {
  const charts = [];

  const viewIndex = getViewIndex(state, id);

  for (let i = viewIndex; i < 30; i++) {
    if (direction === HEXAGON_NODES.FIRST_VARIABLE && Object.keys(fields).length > 0) {
      charts.push(getSecondOrder(state, id, fields[0], i));
    } else if (direction === HEXAGON_NODES.SECOND_VARIABLE && Object.keys(fields).length > 1) {
      charts.push(getSecondOrder(state, id, fields[1], i));
    } else if (direction === HEXAGON_NODES.DRILL_IN && Object.keys(fields).length > 0) {
      charts.push(getSecondOrder(state, id, fields[0], i));
    } else if (direction === HEXAGON_NODES.DRILL_IN_CLUSTER && Object.keys(fields).length > 0) {
      charts.push(getSecondOrder(state, id, fields[0], i));
    } else if (Object.keys(fields).length > 0) {
      charts.push(getRandomSecondOrder(state, id, fields[0], i));
    }
  }

  return charts;
}

export function getSecondOrder(state, id, field, index) {
  const datasetId = getDatasetId(state, id);

  const rankedFields = homeReducer.getRankedFields(state, datasetId).filter((f) => f.label !== field.label);

  const sField =
    rankedFields && rankedFields.length > index ? rankedFields[index] : rankedFields[rankedFields.length - 1];

  const retFields = { 0: field, 1: sField };

  return retFields;
}

export function getRandomSecondOrder(state, id, field, index) {
  const datasetId = getDatasetId(state, id);

  const rankedFields = homeReducer
    .getRankedFields(state, datasetId)
    .filter((f) => f.label !== field.label)
    .filter((f, i) => i < 6);

  const isFirstFieldFirst = Math.random() > 0.5;

  const sField = rankedFields[Math.floor(Math.random() * rankedFields.length)];

  const retFields = {
    0: isFirstFieldFirst ? field : sField,
    1: isFirstFieldFirst ? sField : field
  };

  return retFields;
}

function transformInsight(rankedFields, c, i, metadataOnly = true) {
  const isSecondOrder = c && c.chart && c.chart.series && c.chart.series.length === 2;

  const title = c.narrative.title;

  const column =
    c?.metadata?.type === "Correlation"
      ? c?.chart?.xAxis?.label
      : c?.metadata?.type === "Difference"
        ? (c.metadata.properties.reverse().find((x) => x.column !== undefined) || {}).column
        : (c.metadata.properties.find((x) => x.type == "column") || {}).column;

  const rank = rankedFields.findIndex((f) => f.label === column);

  const isNumeric = c.chart?.data?.some(
    (x) => !isNaN(x.name) || (typeof x.name === "string" && !isNaN(x.name.split(" to ")[1]))
  );

  const insight = {
    narrative: c.narrative,
    chart: c.chart,
    metadata: c.metadata,
    title: title,
    isNumeric: isNumeric,
    isSecondOrder: isSecondOrder,
    rank: rank,
    color: colors[rank % colors.length],
    scoreRank: i,
    score: c.score
  };

  if (metadataOnly) {
    insight.narrative = {
      title: insight.narrative.title,
      columnLabel: insight.narrative.columnLabel,
      conditionsLabel: insight.narrative.conditionsLabel,
      topText: insight.narrative.topText,
      summaryValueIndex: insight.narrative.summaryValueIndex
    };

    insight.chart = {
      xAxis: insight.chart.xAxis,
      yAxis: insight.chart.yAxis
    };
  }

  return insight;
}

export function fetchMissingInsightPivotTables(id, metadata, datasetIdOverride, comparisonOptions) {
  return (dispatch, getState) => {
    const insightFactory = getInsightFactory(getState(), id, datasetIdOverride, comparisonOptions);
    if (insightFactory === undefined) {
      console.log("Missing insight factory, resolving fetchMissingInsightPivotTables");
      // Add a fetchDataset which will also fetch pivot_tables since insightFactory can be undefined if
      // the pivot_tables was not on the dataset at all. Fixes next charts never loading in.
      if (datasetIdOverride !== undefined) {
        dispatch(homeReducer.fetchDataset(datasetIdOverride));
      }
      return Promise.resolve();
    }

    const missingSets = viewReducer.filterPivotTableSetsToNotCurrentlyPending(
      getState(),
      insightFactory.getMissingSetIds(metadata)
    );

    if (missingSets.length == 0) {
      return Promise.resolve();
    }

    const datasetId = datasetIdOverride ?? getDatasetId(getState(), id);
    const dataset = homeReducer.getDataset(getState(), datasetId);
    const pivotTables = homeReducer.getPivotTables(getState(), datasetId);
    const accountId = dataset.account_id;

    dispatch(viewReducer.addPendingPivotTables(missingSets));

    return AibleClientFactory.getInstance()
      .getAccountClient()
      .getCustomerClientFactory(accountId)
      .then((f) => f.getDatasetClient())
      .then((c) =>
        Promise.allSettled(
          missingSets.map((set) =>
            c.getDatasetPivotTablesSubset(datasetId, {
              subset_ids: [set]
            })
          )
        ).then((sets) => sets.filter((x) => x.status == "fulfilled").flatMap((x) => x.value))
      )
      .then((missingTables) => {
        getInsightFactory(getState(), id, datasetIdOverride, comparisonOptions).addTables({
          target: pivotTables.target,
          columns: pivotTables.columns,
          tables: missingTables
        });
        dispatch(viewReducer.removePendingPivotTables(missingSets));
      });
  };
}

function getInsightFactory(state, id, datasetIdOverride, comparisonOptions = undefined) {
  const datasetId = datasetIdOverride ?? getDatasetId(state, id);
  const projectId = getProjectId(state, id);

  if (comparisonOptions === undefined) {
    comparisonOptions = getComparisonOptions(state, id);
  }

  const innerId = projectReducer.getInnerId(state, projectId);

  const job = runReducer.getJob(state, innerId);

  const minimumValueCount = getMinimumValueCount(state, id);

  const successValue = getDatasetSuccess(state, id)?.value;

  return homeReducer.getInsightFactory(state, datasetId, job, successValue, comparisonOptions, minimumValueCount);
}

const COMBINATION_COUNT_CACHE = {};

export function getInsightCombinationCount(state, id, datasetIdOverride) {
  const datasetId = datasetIdOverride ?? getDatasetId(state, id);

  const dataset = homeReducer.getDataset(state, datasetId);

  if (dataset === undefined) {
    return undefined;
  }

  // Was getting a white screen from this sometimes, added nullchains
  const mapping = dataset?.mappings?.[dataset.target_index];

  let lastComboResult = undefined;

  if (mapping !== undefined) {
    lastComboResult = mapping[2].combination_count;
  }

  if (lastComboResult) {
    return lastComboResult;
  }

  if (!homeReducer.getIsExploreReady(state, datasetId)) {
    return undefined;
  }

  // We add the last updated time to the key to allow for changes from users modifying datasets
  const lastUpdated = dataset?.updated_date;

  const key = id + "_" + datasetId + "_" + lastUpdated;

  // We're caching multiple counts for different datasets and projects
  if (COMBINATION_COUNT_CACHE[key]) {
    return COMBINATION_COUNT_CACHE[key];
  }

  const combinationCount = getInsightFactory(state, id, datasetId).getCombinationCount();

  // We only cache existing combination counts
  if (combinationCount) {
    COMBINATION_COUNT_CACHE[key] = combinationCount;
  }

  return combinationCount;
}

export function getTreemapData(state, id) {
  const comparisonMetadata = getComparisonMetaData(state, id);

  const comparisonOptions = getComparisonOptions(state, id);

  if (!comparisonOptions || !comparisonMetadata) {
    return undefined;
  }

  const dateField = comparisonOptions.dateField;

  let gridColumns = undefined;

  const currGrid = getHexMap(state, id);

  Object.keys(currGrid).forEach((gKey) => {
    currGrid[gKey]?.forEach((cHex) => {
      const fields = cHex?.fields ?? cHex?.chart?.fields;
      if (fields) {
        Object.keys(fields).forEach((fKey) => {
          const cField = fields[fKey];
          if (cField?.label !== undefined && cField?.label !== dateField) {
            if (gridColumns === undefined) {
              gridColumns = {};
            }
            gridColumns[cField.label] = true;
          }
        });
      }
    });
  });

  if (!gridColumns) {
    return [];
  }

  const filteredData = comparisonMetadata.filter((d) => {
    const fields = d?.metadata?.properties;

    return Boolean(
      fields?.find((f) => {
        const cField = f?.column;
        return gridColumns[cField];
      })
    );
  });

  return filteredData;
}

export function getComparisonChartsByColumn(
  state,
  id,
  columns,
  forceDatasetId,
  skipHideMissingOtherCheck = false,
  properties
) {
  const nextId = forceDatasetId !== undefined ? "DATASET_" + forceDatasetId : id;
  const datasetId = forceDatasetId !== undefined ? forceDatasetId : getDatasetId(state, nextId);
  const comparisonOptions = getComparisonOptions(state, nextId);

  const comparisonMetadata = getComparisonMetaData(
    state,
    nextId,
    undefined,
    datasetId,
    skipHideMissingOtherCheck,
    properties
  );

  let differences = {};
  comparisonMetadata?.forEach((d) => {
    const column = d?.metadata?.properties?.find((p) => p?.column !== comparisonOptions?.dateField)?.column;
    if (!column) {
      return;
    }

    if (columns) {
      if (!columns.includes(column)) {
        return;
      }
    }

    if (!differences[column]) {
      differences[column] = {
        column: column,
        total: 0,
        popTotal: 0,
        behaviorTotal: 0,
        winsChangeTotal: 0,
        winsChangeActualTotal: 0,
        popChangeTotal: 0,
        popChangeActualTotal: 0,
        charts: []
      };
    }
    const currDiff = differences[column];
    const currTotal = d.sortScore ?? 0;
    const winsChange = d.differenceRawData?.winsChange ?? 0;
    const winsChangeActual = d.differenceRawData?.winsChangeActual ?? 0;
    const popChange = d.differenceRawData?.popChange ?? 0;
    const popChangeActual = d.differenceRawData?.popChangeActual ?? 0;
    const currPopTotal = d.differenceRawData?.countChange ?? 0;
    const currBehaviorTotal = d.differenceRawData?.difference ?? 0;

    currDiff.total += currTotal;
    currDiff.popTotal += currPopTotal;
    currDiff.behaviorTotal += currBehaviorTotal;
    currDiff.winsChangeTotal += winsChange;
    currDiff.winsChangeActualTotal += winsChangeActual;
    currDiff.popChangeTotal += popChange;
    currDiff.popChangeActualTotal += popChangeActual;
    currDiff.charts.push({
      ...d,
      total: currTotal,
      popTotal: currPopTotal,
      behaviorTotal: currBehaviorTotal,
      winsChange: winsChange,
      winsChangeActual: winsChangeActual,
      popChange: popChange,
      popChangeActual: popChangeActual
    });
  });

  const colArr = Object.values(differences).sort((a, b) => b.total - a.total);

  return colArr;
}

var COMPARISONMETADATA_CACHE = undefined;
var COMPARISONMETADATA_KEY = undefined;
var COMPARISONMETADATA_SKIPCHECK_KEY = undefined;
var COMPARISONMETADATA_SKIPCHECK_CACHE = undefined;
// Now that skipHideMissingOtherCheck has been added so that comparison dashboard
// charts are filtered in getComparisonDashboardCharts() depending on hideOtherInCharts and hideMissingInCharts,
// added another cache value for getComparisonMetaData() depending on skipHideMIssingOtherCheck.
export function getComparisonMetaData(
  state,
  id,
  comparisonOptionsOverride,
  datasetIdOverride,
  skipHideMissingOtherCheck = false,
  properties = undefined
) {
  const datasetId = datasetIdOverride ?? getDatasetId(state, id);

  const comparisonOptions = comparisonOptionsOverride ?? getComparisonOptions(state, id);
  const hideOtherInCharts = chatGPTReducer.getHideOtherInCharts(state);
  const hideMissingInCharts = chatGPTReducer.getHideMissingInCharts(state);

  if (!homeReducer.getIsExploreReady(state, datasetId) || !comparisonOptions) {
    return undefined;
  }

  const successValue = getDatasetSuccess(state, id)?.value;
  const cache_key =
    id +
    "_" +
    datasetId +
    "_" +
    successValue +
    "_" +
    JSON.stringify(comparisonOptions) +
    "_" +
    hideOtherInCharts +
    " " +
    hideMissingInCharts;

  if (!properties) {
    // Return correct cache based on skipHideMissingOtherCheck and process new metadata if the cache is falsy
    if (skipHideMissingOtherCheck && cache_key === COMPARISONMETADATA_SKIPCHECK_KEY) {
      return COMPARISONMETADATA_SKIPCHECK_CACHE;
    }
    if (!skipHideMissingOtherCheck && cache_key === COMPARISONMETADATA_KEY) {
      return COMPARISONMETADATA_CACHE;
    }
  }

  const dateField = comparisonOptions.dateField;
  if (dateField === undefined || comparisonOptions?.currentStart === undefined) {
    return [];
  }

  // const insight = getInsightFactory(state, id).getInsight(metadata);

  const filters = {};

  const rawInsights = getRelatedInsights(
    state,
    id,
    [dateField],
    filters,
    undefined,
    "Difference",
    { limit: 10000 },
    undefined,
    datasetIdOverride,
    comparisonOptions,
    properties
  );
  const insights = rawInsights
    .map((c) => {
      const fields = getFieldsFromChart(state, id, c);

      return {
        ...c,
        fields
      };
    })
    .map((c) => {
      const newChart = getInsightFromMetadata(
        state,
        id,
        c?.metadata,
        false,
        comparisonOptionsOverride,
        datasetIdOverride
      );

      if (!newChart) {
        return;
      }

      const metrics = getMetricsFromChartData(newChart?.chart?.data, comparisonOptions);

      newChart.difference = metrics.difference * metrics.countChange;
      // newChart.difference = metrics.difference
      newChart.differenceRawData = metrics;
      newChart.sortScore = Math.abs(newChart.difference);
      newChart.score = c.score;
      newChart.color = newChart?.color ?? "#A4A6B7";

      return newChart;
    })
    .filter((c) => {
      if (!skipHideMissingOtherCheck) {
        if (hideOtherInCharts && (c?.metadata?.properties ?? []).find((p) => p?.value === "{Other}")) {
          return false;
        }
        if (
          hideMissingInCharts &&
          (c?.metadata?.properties ?? []).find((p) => p?.value === "{Missing}" || p?.type === "missing")
        ) {
          return false;
        }
      }
      return true;
    });

  if (!properties) {
    // Only updating the correct cache based on skipHidemissingOtherCheck
    if (!skipHideMissingOtherCheck) {
      COMPARISONMETADATA_KEY = cache_key;
      COMPARISONMETADATA_CACHE = insights;
    } else {
      COMPARISONMETADATA_SKIPCHECK_KEY = cache_key;
      COMPARISONMETADATA_SKIPCHECK_CACHE = insights;
    }
  }

  return insights;
}

export function getMetricsFromChartData(cData = [], comparisonOptions, keyOverride) {
  let metrics = {
    previousCount: 0,
    previousPursued: 0,
    previousWins: 0,
    previousTotalWins: 0,
    newCount: 0,
    newPursued: 0,
    newWins: 0,
    newTotalWins: 0,
    currentDateBuckets: 0,
    referenceDateBuckets: 0
  };

  const DEFAULT_KEYS = {
    name: "name",
    label: "label",
    otherLabel: "otherLabel",
    y: "y",
    otherY: "otherY",
    yCount: "yCount",
    otherYCount: "otherYCount",
    summary: "summary",
    otherSummary: "otherSummary"
  };

  const getDataKey = (key) => {
    return keyOverride?.[key] ?? DEFAULT_KEYS[key];
  };

  const summaryKey = getDataKey("summary");
  const otherSummaryKey = getDataKey("otherSummary");
  const yCountKey = getDataKey("yCount");
  const otherYCountKey = getDataKey("otherYCount");

  const dateField = comparisonOptions?.dateField;

  const getSum = (summary) => {
    if (typeof summary?.getSum === "function") {
      return summary.getSum();
    }
    return summary?.sum;
  };

  const currentState = moment(comparisonOptions.currentStart);
  const currentEnd = moment(comparisonOptions.currentEnd);
  const referenceState = moment(comparisonOptions.referenceStart);
  const referenceEnd = moment(comparisonOptions.referenceEnd);

  for (let i = 0; i < cData?.length; i++) {
    const currData = cData[i];
    const cDate = moment(currData?.name);
    const isCurrentDate = getIsInRange(cDate, currentState, currentEnd);
    const isReferenceDate = !isCurrentDate && getIsInRange(cDate, referenceState, referenceEnd);
    if (comparisonOptions?.currentStart && (isReferenceDate || isCurrentDate)) {
      const cCount = getSum(currData?.[summaryKey]);
      const cTotalCount = getSum(currData?.[summaryKey]) + getSum(currData?.[otherSummaryKey]);
      const cPursued = currData?.[yCountKey];
      const cTotal = currData?.[otherYCountKey];
      if (isCurrentDate) {
        metrics.currentDateBuckets += 1;
        if (!isNaN(cTotal)) {
          if (metrics.newCount === undefined) {
            metrics.newCount = 0;
          }
          metrics.newCount += cTotal || 0;
        }
        if (!isNaN(cPursued)) {
          if (metrics.newPursued === undefined) {
            metrics.newPursued = 0;
          }
          metrics.newPursued += cPursued || 0;
        }
        if (!isNaN(cCount)) {
          if (metrics.newWins === undefined) {
            metrics.newWins = 0;
          }
          metrics.newWins += cCount || 0;
        }
        if (!isNaN(cTotalCount)) {
          if (metrics.newTotalWins === undefined) {
            metrics.newTotalWins = 0;
          }
          metrics.newTotalWins += cTotalCount || 0;
        }
      } else if (isReferenceDate) {
        metrics.referenceDateBuckets += 1;
        if (!isNaN(cTotal)) {
          if (metrics.previousCount === undefined) {
            metrics.previousCount = 0;
          }
          metrics.previousCount += cTotal || 0;
        }
        if (!isNaN(cPursued)) {
          if (metrics.previousPursued === undefined) {
            metrics.previousPursued = 0;
          }
          metrics.previousPursued += cPursued || 0;
        }
        if (!isNaN(cCount)) {
          if (metrics.previousWins === undefined) {
            metrics.previousWins = 0;
          }
          metrics.previousWins += cCount || 0;
        }
        if (!isNaN(cTotalCount)) {
          if (metrics.previousTotalWins === undefined) {
            metrics.previousTotalWins = 0;
          }
          metrics.previousTotalWins += cTotalCount || 0;
        }
      }
    }
  }

  const winsChangeActual = metrics.newWins - metrics.previousWins;
  metrics.winsChangeActual = winsChangeActual;
  const winsChange = winsChangeActual / (metrics.previousWins || 1);
  metrics.winsChange = Number((winsChange * 100).toFixed(2));

  const popChangeActual = metrics.newPursued - metrics.previousPursued;
  metrics.popChangeActual = popChangeActual;

  const popChange = popChangeActual / (metrics.previousPursued || 1);
  metrics.popChange = Number((popChange * 100).toFixed(2));

  const previousWinRate = metrics.previousWins / metrics.previousPursued || 0;
  const newWinRate = metrics.newWins / metrics.newPursued || 0;

  const previousAdjustedWinRate = metrics.previousWins / metrics.previousTotalWins || 0;
  const newAdjustedWinRate = metrics.newWins / (metrics.newTotalWins || 1) || 0;

  metrics.previousWinRate = Number((previousWinRate * 100).toFixed(2));
  metrics.newWinRate = Number((newWinRate * 100).toFixed(2));

  metrics.previousAdjustedWinRate = Number((previousAdjustedWinRate * 100).toFixed(2));
  metrics.newAdjustedWinRate = Number((newAdjustedWinRate * 100).toFixed(2));

  const difference = (newAdjustedWinRate - previousAdjustedWinRate) * 100;
  const winrateChange = (newWinRate - previousWinRate) * 100;

  metrics.difference = difference;
  metrics.winrateChange = winrateChange;

  const previousCountPercentage = metrics.previousPursued / metrics.previousCount || 0;
  const newCountPercentage = metrics.newPursued / metrics.newCount || 0;

  metrics.newCountPercentage = Number((newCountPercentage * 100).toFixed(2));
  metrics.previousCountPercentage = Number((previousCountPercentage * 100).toFixed(2));

  const countChange = (newCountPercentage - previousCountPercentage) * 100;

  metrics.countChange = countChange;

  const previousTotalCount = metrics.previousCount || 0;
  const newTotalCount = metrics.newCount || 0;

  const totalCountChange = (newTotalCount - previousTotalCount) / (previousTotalCount || 1);

  metrics.totalCountChange = Number((totalCountChange * 100).toFixed(2));

  return metrics;
}

export function getChartByTitle(state, id, title) {
  const datasetId = getDatasetId(state, id);
  const dataset = homeReducer.getDataset(state, datasetId);
  const comparisonOptions = getComparisonOptions(state, id);

  if (title === undefined) {
    return undefined;
  }

  if (comparisonOptions?.dateField) {
    // Initialize Metadata
    const metadata = {
      type: "Difference",
      properties: []
    };

    // If column level chart
    if (dataset?.fields?.[title]) {
      metadata.properties = [
        {
          type: "column",
          column: title
        }
      ];
    } else {
      // Initialize metadata property
      const property = {};

      // Find Column in title
      const colSplit = title.split(" is ");
      let col = colSplit[0];
      let valIndex = 1;
      for (; !dataset?.fields?.[col] && valIndex < colSplit.length; valIndex++) {
        col += " is " + colSplit[valIndex];
      }
      property.column = col;

      // Find Values in title
      const value = colSplit.slice(valIndex).join(" is ");
      property.value = value;
      property.type = "text";

      if (dataset?.fields?.[col]?.type !== undefined && dataset?.fields?.[col]?.type !== "categorical") {
        property.type = dataset?.fields?.[col]?.type;
        const valSplit = value.split(" to ");
        if (valSplit.length === 2) {
          if (property.type === "number") {
            property.type = "interval";
          }
          delete property.value;
          const valStart = valSplit[0].replace(/[^0-9.]/g, "");
          const valEnd = valSplit[1].replace(/[^0-9.]/g, "");
          property.start = Number(valStart);
          property.end = Number(valEnd);
        }
      }

      // Create Metadata properties
      metadata.properties = [
        {
          type: "column",
          column: comparisonOptions.dateField
        },
        property
      ];
    }

    return getInsightFromMetadata(state, id, metadata, false);
  }

  const wSplit = title.split(" when ");
  const mainColumn = wSplit?.[0];

  let vSplit = wSplit?.[1] !== undefined ? wSplit?.[1].split(" is ") : undefined;
  let valColumn = vSplit !== undefined ? vSplit?.[0] : undefined;
  let valValue = vSplit !== undefined ? vSplit?.[1] : undefined;

  let metadata =
    mainColumn === undefined
      ? undefined
      : {
          type: "Descriptive",
          properties: [{ type: "column", column: mainColumn }]
        };

  if (metadata !== undefined && valColumn !== undefined && valValue !== undefined) {
    const property = {
      type:
        dataset?.fields?.[valColumn]?.type === "categorical"
          ? "text"
          : dataset?.fields?.[valColumn]?.type !== undefined
            ? dataset?.fields?.[valColumn]?.type
            : "text",
      column: valColumn,
      value: valValue
    };

    metadata.properties.push(property);
  }

  return getInsightFromMetadata(state, id, metadata, false);
}

var INSIGHTFROMMETADATA_CACHE = {};
var INSIGHTFROMMETADATA_CACHE_ID = undefined;
var INSIGHTFROMMETADATA_KEY = undefined;
export function getInsightFromMetadata(
  state,
  id,
  metadata,
  metadataOnly = true,
  comparisonOptionsOverride,
  datasetIdOverride
) {
  const datasetId = datasetIdOverride ?? getDatasetId(state, id);

  if (!homeReducer.getIsExploreReady(state, datasetId)) {
    return undefined;
  }

  const insightFactory = getInsightFactory(state, id, datasetIdOverride, comparisonOptionsOverride);

  if (metadata?.properties?.length) {
    const validProperties = insightFactory.getValidProperties(metadata?.properties);

    if (validProperties.length !== metadata.properties.length) {
      return undefined;
    }
  }

  const rankedFields = homeReducer.getRankedFields(state, datasetId);

  const insight = insightFactory.getInsight(metadata);

  if (insight === undefined) {
    return undefined;
  }

  const transformedInsight = transformInsight(rankedFields, insight, 0, metadataOnly);

  //TODO: Unhackify this
  const comparisonOptions = comparisonOptionsOverride ?? getComparisonOptions(state, id);
  const successValue = getDatasetSuccess(state, id)?.value;
  const cacheKey = id + "_" + datasetId + "_" + successValue + "_" + JSON.stringify(comparisonOptions);
  const cacheRef = metadataOnly + "_" + JSON.stringify(metadata);
  if (comparisonOptions) {
    if (INSIGHTFROMMETADATA_KEY !== cacheKey) {
      INSIGHTFROMMETADATA_KEY = cacheKey;
      INSIGHTFROMMETADATA_CACHE = {};
    }
    const cached = INSIGHTFROMMETADATA_CACHE[cacheRef];
    if (cached) {
      return cached;
    }
  }
  if (comparisonOptions && metadata?.properties?.length === 1) {
    const targetColumn = metadata?.properties?.find((m) => m.column !== comparisonOptions?.dateField)?.column;

    const rawChildCharts = getRelatedInsights(
      state,
      id,
      [comparisonOptions.dateField, targetColumn],
      {},
      undefined,
      "Difference",
      { limit: 5000 },
      undefined,
      datasetIdOverride
    );

    const childCharts = rawChildCharts
      .filter((c) => {
        if (c?.metadata?.properties?.length < 2) {
          return false;
        }
        return true;
      })
      .map((c) => {
        const fields = getFieldsFromChart(state, id, c, datasetIdOverride);

        return {
          ...c,
          fields
        };
      });

    const subCharts = childCharts.map((childChart) => {
      const currMetadata = childChart?.metadata;
      const currInsight = getInsightFactory(state, id, datasetIdOverride).getInsight(currMetadata);

      const currTransformedInsight = transformInsight(rankedFields, currInsight, 0, metadataOnly);
      return currTransformedInsight;
    });

    const seriesData = {};

    const subSeries = subCharts.map((cInsight, i) => {
      const cSeries = {
        dataKey: "y_" + i,
        labelKey: "label_" + i,
        label: cInsight?.narrative?.conditionsLabel,
        type: "Line",
        isFirstOrder: true,
        modifierIndex: i
      };

      cInsight?.chart?.data?.forEach((d) => {
        if (d?.name) {
          if (!seriesData[d.name]) {
            seriesData[d.name] = {
              name: d.name
            };
          }
          seriesData[d.name]["y_" + i] = d?.y;
          seriesData[d.name]["label_" + i] = d?.label;

          seriesData[d.name]["yCount_" + i] = d?.yCount;
          seriesData[d.name]["otherY_" + i] = d?.otherY;
          seriesData[d.name]["otherLabel_" + i] = d?.otherLabel;
          seriesData[d.name]["otherYCount_" + i] = d?.otherYCount;

          seriesData[d.name]["summary_" + i] = d?.summary;
          seriesData[d.name]["otherSummary_" + i] = d?.otherSummary;
        }
      });

      return cSeries;
    });

    const combinedData = Object.values(seriesData).sort((a, b) => {
      moment(a?.name).isBefore(b?.name) ? -1 : 1;
    });

    const outcome = homeReducer.getOutcome(state, datasetId);

    const successLabel = `${outcome}${successValue ? ": " + successValue : ""}`;

    transformedInsight.isFirstOrder = true;
    transformedInsight.chart.data = combinedData;

    transformedInsight.chart.xAxis = {
      dataKey: "name",
      label: comparisonOptions?.dateField,
      type: "category"
    };

    transformedInsight.chart.yAxis = {
      label: "% of Total " + successLabel
    };

    transformedInsight.chart.series = subSeries;

    if (INSIGHTFROMMETADATA_CACHE_ID !== datasetId) {
      INSIGHTFROMMETADATA_CACHE_ID = datasetId;
      INSIGHTFROMMETADATA_CACHE = {};
    }

    INSIGHTFROMMETADATA_CACHE[cacheRef] = transformedInsight;
  }

  const hideOtherInCharts = chatGPTReducer.getHideOtherInCharts(state);
  const hideMissingInCharts = chatGPTReducer.getHideMissingInCharts(state);

  if (hideOtherInCharts === true || hideMissingInCharts === true) {
    const retChart = {
      ...(transformedInsight ?? {}),
      chart: {
        ...(transformedInsight?.chart ?? {}),
        data: [
          ...(transformedInsight?.chart?.data ?? []).filter((d) => {
            if (hideOtherInCharts && d?.name === "{Other}") {
              return false;
            }
            if (hideMissingInCharts && d?.name === "{Missing}") {
              return false;
            }
            return true;
          })
        ]
      }
    };

    return retChart;
  }

  return transformedInsight;
}

export function getInsightAndRelatedFromMetadata(state, id, metadata, metadataOnly = true) {
  const fInsight = getInsightFromMetadata(state, id, metadata, metadataOnly);

  return fInsight === undefined
    ? getInsightsFromMetadata(state, id, metadata, metadataOnly)
    : [fInsight].concat(getInsightsFromMetadata(state, id, metadata, metadataOnly));
}

export function getInsightsFromMetadata(state, id, metadata, metadataOnly = true) {
  const datasetId = getDatasetId(state, id);

  if (!homeReducer.getIsExploreReady(state, datasetId)) {
    return [];
  }

  const rankedFields = homeReducer.getRankedFields(state, datasetId);

  const insights = getInsightFactory(state, id).getInsights(metadata);

  const nextCharts = insights.map((c, i) => transformInsight(rankedFields, c, i, metadataOnly));

  return nextCharts;
}

export function getRelatedInsights(
  state,
  id,
  column,
  filters = {},
  filterColumn,
  type,
  options,
  metadataOnly = true,
  datasetIdOverride,
  comparisonOptions,
  properties
) {
  //console.log("GET getRelatedInsights", id, column, filters, filterColumn, type, options);

  const datasetId = datasetIdOverride ?? getDatasetId(state, id);

  if (!homeReducer.getIsExploreReady(state, datasetId)) {
    return [];
  }

  const rankedFields = homeReducer.getRankedFields(state, datasetId);

  const factory = getInsightFactory(state, id, datasetIdOverride, comparisonOptions);

  const metadata = {
    type: type,
    properties: properties ?? []
  };

  const queryColumns = [column].flat().filter((x) => x !== undefined);

  for (let c of queryColumns) {
    const hasColumn = metadata.properties.find((p) => isColumn(p) && p.column == c);

    if (!hasColumn) {
      metadata.properties.push({ column: c });
    }
  }

  if (properties === undefined) {
    Object.entries(filters).forEach(([column, value]) => {
      metadata.properties.push({ column, value });
    });

    if (filterColumn) {
      const { columns } = factory.getPropertyMetadata();

      for (let { column, values } of columns) {
        if (column.column == filterColumn) {
          for (let value of values) {
            metadata.properties.push(value);
          }
        } else {
          metadata.properties.push(column);
        }
      }
    }
  }

  const insights = factory.getInsights(metadata, options);

  if (metadata.type == "ModelDriver") {
    const insight = factory.getInsight(metadata);

    insights.unshift(insight);
  }

  const dataset = homeReducer.getDataset(state, datasetId);
  const fields = dataset?.labels;

  const retInsights = insights
    .map((c, i) => transformInsight(rankedFields, c, i, metadataOnly))
    .filter((insight) => {
      let hasInvalidColumn = false;
      insight?.metadata?.properties?.forEach((p) => {
        if (!fields.includes(p.column) && fields.find((f) => f + "_diff" === p.column)) {
          hasInvalidColumn = true;
        }
      });
      if (hasInvalidColumn) {
        return false;
      }
      return true;
    });

  return retInsights;
}

export function refreshHexNode(state, id, node) {
  if (node?.chart) {
    if (node?.chart?.metadata === undefined) {
      return node;
    }

    const chart = getInsightFromMetadata(state, id, node.chart.metadata, true);

    if (chart === undefined) {
      return node;
    }

    chart.scoreRank = node.chart.scoreRank ?? chart?.scoreRank;

    node = {
      node,
      chart: chart
    };

    if (node.fields) {
      const fields = {};
      for (let key of Object.keys(node.fields)) {
        if (node.fields[key]) {
          fields[key] = getTransformedField(state, id, node.fields[key].label) ?? node.fields[key];
        }
      }

      node.fields = fields;
    }
  }

  return node;
}

export function getHexNodes(state, id, hex) {
  const hexMap = getHexMap(state, id);
  const actionHexMap = getActionHexMap(state, id);
  const hexagonRadius = getHexagonRadius(state, id);

  const hKey = hex.x + "_" + hex.y;

  const selectedHex = getSelectedHex(state, id);

  const isNotCenter = selectedHex.x !== hexagonRadius || selectedHex.y !== hexagonRadius;

  if (actionHexMap[hKey] && hexMap[hKey]) {
    const aNode = actionHexMap[hKey];
    return [hexMap[hKey], { aNode, isAction: true, isFromActionMap: true }].map((node) =>
      refreshHexNode(state, id, node)
    );
  }

  if (actionHexMap[hKey] && isNotCenter) {
    return [{ ...actionHexMap[hKey], isAction: true, isFromActionMap: true }].map((node) =>
      refreshHexNode(state, id, node)
    );
  }

  if (hexMap[hKey]) {
    return hexMap[hKey].map((node) => refreshHexNode(state, id, node));
  }
}

export function getHexNode(state, id, hex) {
  const hexMap = getHexMap(state, id);
  const actionHexMap = getActionHexMap(state, id);
  const hexagonRadius = getHexagonRadius(state, id);

  const hKey = hex.x + "_" + hex.y;

  const selectedHex = getSelectedHex(state, id);

  const isNotCenter = selectedHex.x !== hexagonRadius || selectedHex.y !== hexagonRadius;

  if (actionHexMap[hKey] && isNotCenter) {
    const aNode = actionHexMap[hKey];
    return refreshHexNode(state, id, {
      aNode,
      isAction: true,
      isFromActionMap: true,
      x: hex.x,
      y: hex.y
    });
  }

  if (hexMap[hKey]) {
    return refreshHexNode(state, id, hexMap[hKey][0]);
  }

  return { type: HEXAGON_NODES.NONE, fields: {} };

  /*
  const directionType = isDirection
    ? selectedHex &&
      selectedHex.fields &&
      Object.keys(selectedHex.fields).length === 1
      ? DIRECTION_NODES_SINGLE[fieldIndex]
      : DIRECTION_NODES[fieldIndex]
    : DIRECTION_NODES.NONE;

  const fields = getHexagonFields(
    state,
    id,
    isDirection || isChosenDirection ? selectedHex : hex
  );

  const retFields =
    isChosenDirection !== true
      ? fields
      : selectedHex.direction === HEXAGON_NODES.FIRST_VARIABLE
      ? getSecondOrder(state, id, fields[0], fieldIndex)
      : selectedHex.direction === HEXAGON_NODES.SECOND_VARIABLE
      ? getSecondOrder(state, id, fields[1] ? fields[1] : fields[0], fieldIndex)
      : selectedHex.direction === HEXAGON_NODES.STAT_ASSOC
      ? getRandomSecondOrder(state, id, fields[0])
      : selectedHex.direction === HEXAGON_NODES.POPULAR
      ? getRandomSecondOrder(state, id, fields[0])
      : selectedHex.direction === HEXAGON_NODES.VOTING
      ? getRandomSecondOrder(state, id, fields[0])
      : fields;

  //selectedHex.direction !== undefined && console.log(retFields);

  return {
    type: directionType,
    fields: retFields,
  };
  */
}

export function getMuscleMatrix(state, id) {
  const datasetId = getDatasetId(state, id);
  const dataset = homeReducer.getDataset(state, datasetId);
  const rankedFields = homeReducer.getRankedFields(state, datasetId);

  if (dataset === undefined || dataset.fields === undefined) {
    return undefined;
  }

  return undefined;

  const leakageInfo =
    dataset &&
    dataset.outcome &&
    dataset.fields &&
    dataset.fields[dataset.outcome] &&
    dataset.fields[dataset.outcome].leakage_info
      ? dataset.fields[dataset.outcome].leakage_info
      : {};

  const data = dataset.interaction_scores_lookup ?? {};

  const bestFieldsUnfiltered = (rankedFields ?? []).map((field, i) => ({
    label: field.label,
    color: colors[i % colors.length]
  }));

  const scores = dataset.field_scores ?? {};

  const bestFields = bestFieldsUnfiltered.filter(({ label }) => scores[label] > 0);

  const muscleMatrix = bestFields.map((fieldOne) => {
    return bestFields.map((fieldTwo) => {
      const currKeys = [fieldOne.label, fieldTwo.label];
      return {
        value: data?.[fieldOne.label]?.[fieldTwo.label] ?? 0,
        currKeys: currKeys,
        sText:
          fieldOne.label === fieldTwo.label ? fieldOne.label + " by itself" : fieldOne.label + " to " + fieldTwo.label,
        color: fieldTwo.color
      };
    });
  });

  const searchCharts = getSearchDashboardChart(state, id);

  return muscleMatrix
    .filter((m, i) => {
      if (searchCharts === undefined || searchCharts.length === 0) {
        return true;
      } else {
        const mColumn = m?.[0]?.currKeys?.[0];

        return searchCharts.find((sChart) => sChart?.mainChart?.metadata?.properties?.[0]?.column === mColumn) !==
          undefined
          ? true
          : false;
      }
    })
    .filter((m, i) => i < BESTCHART_SIZE);
}

export function getSearchDashboardChart(state, id) {
  const searchInsights = getSearchInsights(state, id);
  const searchOptions = getSearchOptions(state, id);
  const searchType = getSearchType(state, id);

  if (
    (searchType === "All Insights" && (searchOptions === undefined || searchOptions.length === 0)) ||
    searchInsights === undefined ||
    searchInsights.length === 0
  ) {
    return undefined;
  }
  let allCharts = [];

  let retChart = [];
  let retColors = [];
  let subCharts = [];

  let detailChart = [];
  let detailColors = [];

  const datasetId = getDatasetId(state, id);
  const rankedFields = homeReducer.getRankedFields(state, datasetId);

  const fixChart = (chart) => getInsightFromMetadata(state, id, chart?.metadata, false);

  const mainKey = searchOptions?.[0]?.filterField;

  searchInsights
    .filter((c) => c.metadata.properties.length === 2 && c.metadata.type !== "ModelDriver")
    .forEach((c) => {
      const fChart = fixChart(c);
      subCharts.push(fChart);
    });

  let topCharts = {};

  const fMainChart = subCharts.find((s) => s?.metadata?.properties?.[0]?.column === mainKey);

  if (fMainChart === undefined) {
    const mData = {
      type: "Descriptive",
      properties: [{ column: mainKey, type: "column" }]
    };
    subCharts.push(getInsightFromMetadata(state, id, mData, false));
  }

  const otherDetailKey = subCharts?.[0]?.metadata?.properties?.[1]?.column;
  let detailSubCharts = [];

  searchInsights
    .filter((c) => searchType === "NLQ" || c?.metadata?.properties?.[1]?.column === otherDetailKey)
    .forEach((c) => {
      const fChart = fixChart(c);

      detailSubCharts.push(fChart);
    });

  subCharts.forEach((mChart, mIndex) => {
    retChart = [];
    retColors = [];

    const mainChart = getInsightFromMetadata(
      state,
      id,
      {
        type: mChart?.metadata?.type,
        properties: [mChart?.metadata?.properties?.[0]]
      },
      false
    );

    if (mainChart !== undefined) {
      const mColumn = mainChart?.metadata?.properties?.[0]?.column;

      if (topCharts[mColumn] === undefined) {
        retColors.push(mainChart?.color);

        topCharts[mColumn] = true;
        mainChart.chart.data.forEach((xBucket, xIndex) => {
          let nextCol = {
            name: xBucket.name,
            count: xBucket.summary?.getTotalN(),
            column: mainChart?.metadata?.properties?.[0]?.column,
            min: xBucket.min,
            max: xBucket.max
          };

          nextCol["Average " + mColumn] = xBucket.y;

          subCharts
            .filter(
              (sChart) =>
                sChart?.metadata?.properties?.[0]?.column &&
                sChart?.metadata?.properties?.[0]?.column === mColumn &&
                sChart?.narrative?.conditionsLabel !== ""
            )
            .forEach((line) => {
              if (xIndex === 0 && nextCol[line?.narrative?.conditionsLabel] === undefined) {
                const otherKey = line?.metadata?.properties.filter(
                  (m) => mColumn !== undefined && m.column !== mColumn
                )?.[0]?.column;

                const fIndex = rankedFields.findIndex((f) => f.label === otherKey);

                retColors.push(colors[fIndex % colors.length] ?? "gray");
              }

              nextCol[line?.narrative?.conditionsLabel] = line?.chart?.data?.[xIndex]?.y || 0;
            });

          retChart.push(nextCol);
        });

        mainChart?.chart?.data.forEach((xBucket, xIndex) => {
          let nextCol = {
            name: xBucket.name,
            count: xBucket.summary?.getTotalN(),
            column: mainChart?.metadata?.properties?.[0]?.column,
            min: xBucket.min,
            max: xBucket.max
          };

          nextCol["Average " + mColumn] = xBucket.y;

          detailSubCharts
            .filter(
              (sChart) =>
                sChart?.metadata?.properties?.[0]?.column &&
                sChart?.metadata?.properties?.[0]?.column === mColumn &&
                sChart?.narrative?.conditionsLabel !== ""
            )
            .forEach((line) => {
              if (xIndex === 0 && nextCol[line?.narrative?.conditionsLabel] === undefined) {
                const otherKey = line?.metadata?.properties.filter(
                  (m) => mainKey !== undefined && m.column !== mainKey
                )?.[0]?.column;

                const fIndex = rankedFields.findIndex((f) => f.label === otherKey);

                detailColors.push(colors[fIndex % colors.length] ?? "gray");
              }

              nextCol[line?.narrative?.conditionsLabel] = line?.chart?.data?.[xIndex]?.y || 0;
            });

          detailChart.push(nextCol);
        });

        let topText = {};
        subCharts
          .filter((subC) => subC?.narrative?.columnLabel === mColumn)
          .forEach((subC) => {
            topText[subC?.narrative?.conditionsLabel] = subC?.narrative?.topText;
          });

        const otherCharts = getRelatedInsights(state, id, undefined, {}, mColumn, "Descriptive");

        const secondaryCharts = otherCharts
          .filter(
            (oChart) =>
              oChart?.metadata?.properties?.[0]?.column === mainKey ||
              oChart?.metadata?.properties?.[1]?.column === mainKey
          )
          .map((oChart) => ({
            ...fixChart(oChart),
            fields: getFieldsFromChart(state, id, oChart)
          }));

        const detailChartRank = subCharts.filter(
          (sChart) =>
            sChart?.metadata?.properties?.[0]?.column &&
            sChart?.metadata?.properties?.[0]?.column === mColumn &&
            sChart?.narrative?.conditionsLabel !== ""
        )?.[0]?.scoreRank;

        if (
          searchType === "NLQ" ||
          secondaryCharts.length > 0 ||
          mainKey === mainChart?.metadata?.properties?.[0]?.column
        ) {
          allCharts.push({
            data: retChart,
            colors: retColors,
            title: mainChart?.narrative?.title,
            rightTitle: mainChart?.narrative?.title + " : " + otherDetailKey,
            mainChart: mainChart,
            secondaryCharts: secondaryCharts,
            detailColors: retColors,
            detailData: retChart,
            detailChartRank: detailChartRank,
            firstChild: {
              ...detailSubCharts?.[0],
              fields: getFieldsFromChart(state, id, detailSubCharts?.[0])
            },
            topText: topText,
            subCharts: subCharts
          });
        }
      }
    }
  });

  return allCharts.sort((a, b) => a?.mainChart?.scoreRank - b?.mainChart?.scoreRank);
}

export function getComparisonDashboardCharts(
  state,
  id,
  forceResults = false,
  searchOptionsOverride,
  properties,
  showOnlyHiddenCharts
) {
  const CHART_LIMIT = 6;
  const SORT_KEY_LOOKUP = {
    IMPACT: "total",
    BEHAVIOR: "behaviorTotal",
    POPULATION: "popTotal",
    WIN_TOTAL: "winsChange",
    WIN_TOTAL_ACTUAL: "winsChangeActual",
    POP_TOTAL: "popChange",
    POP_TOTAL_ACTUAL: "popChangeActual"
  };

  const allCharts = {
    colCharts: [],
    charts: []
  };

  const activeTab = getActiveTab(state, id);

  if (activeTab === "DASHBOARD" || forceResults) {
    const comparisonOptions = getComparisonOptions(state, id);

    const columnCharts = getComparisonChartsByColumn(state, id, undefined, undefined, true, properties);

    const bestCharts = [...(getBestCharts(state, id) ?? []), ...(getSearchInsights(state, id) ?? [])];

    const sortOption = getComparisonDashBoardSort(state, id);
    const sortKey = SORT_KEY_LOOKUP[sortOption?.value ?? "BEHAVIOR"];

    const sortOrder = getComparisonDashBoardSortOrder(state, id);
    const retSort = sortOrder?.value;

    const hideOtherInCharts = chatGPTReducer.getHideOtherInCharts(state);
    const hideMissingInCharts = chatGPTReducer.getHideMissingInCharts(state);

    const handleSort = (chartOne, chartTwo) => {
      // const chartOneMetrics = getMetricsFromChartData(chartOne?.data, comparisonOptions);
      // const chartTwoMetrics = getMetricsFromChartData(chartTwo?.data, comparisonOptions);

      const valueOne = chartOne[sortKey];
      const valueTwo = chartTwo[sortKey];

      let retOne = valueOne;
      let retTwo = valueTwo;
      if (retSort === "ABS_DESC" || retSort === "ABS_ASC") {
        retOne = Math.abs(valueOne);
        retTwo = Math.abs(valueTwo);
      }

      const valComparison = retTwo - retOne;

      if (retSort === "ABS_ASC" || retSort === "ASC") {
        return -1 * valComparison;
      }

      return valComparison;
    };

    if (sortOption?.value && sortOption.value !== "IMPACT") {
      columnCharts.sort((c1, c2) => handleSort(c1, c2));
    }

    const searchOptions = searchOptionsOverride ?? getSearchOptions(state, id);

    // Removed filtering out to columns matching best chart columns
    const validColumns = columnCharts
      .filter((c) => {
        const chartColumn = c?.column;

        if (chartColumn === undefined) {
          return false;
        }
        return true;
      })
      .map((c) => {
        const chartColumn = c?.column;
        const mainChart = bestCharts.find((bc) =>
          bc?.metadata?.properties?.find((p) => p.column !== comparisonOptions?.dateField && p.column === chartColumn)
        );

        // Fallback for if charts did not populate from columnCharts
        let relatedCharts =
          c?.charts ??
          mainChart.relatedCharts
            ?.map((chart) => getInsightFromMetadata(state, id, chart?.metadata, false))
            ?.map((c) => {
              return {
                ...c,
                column: chartColumn,
                total: c.sortScore,
                popTotal: c.differenceRawData?.countChange ?? 0,
                behaviorTotal: c.differenceRawData?.difference ?? 0,
                winsChange: c.differenceRawData?.winsChange ?? 0,
                winsChangeActual: c.differenceRawData?.winsChangeActual ?? 0,
                popChange: c.differenceRawData?.popChange ?? 0,
                popChangeActual: c.differenceRawData?.popChangeActual ?? 0
              };
            });

        // Adding filter {Missing} and {Other} logic here so that charts are hidden but do not affect sorting logic.
        if (hideOtherInCharts || hideMissingInCharts) {
          relatedCharts = relatedCharts.filter((c) => {
            if (hideOtherInCharts && (c?.metadata?.properties ?? []).find((p) => p?.value === "{Other}")) {
              return false;
            }
            if (
              hideMissingInCharts &&
              (c?.metadata?.properties ?? []).find((p) => p?.value === "{Missing}" || p?.type === "missing")
            ) {
              return false;
            }
            return true;
          });
        }

        return {
          ...mainChart,
          column: chartColumn,
          relatedCharts: relatedCharts,
          popTotal: c.popTotal,
          behaviorTotal: c.behaviorTotal,
          total: c.total
        };
      });

    allCharts.colCharts = validColumns
      .filter((c) => {
        // const isHidden = getIsChartHidden(state, id, c?.title);
        // const hideChart = (!showOnlyHiddenCharts && isHidden) || (showOnlyHiddenCharts && !isHidden);
        // if (hideChart) {
        //   return false;
        // }

        if (searchOptions?.length) {
          const chartColumn = c.column;
          if (searchOptions.find((o) => o.filterField === chartColumn)) {
            return true;
          }
          return false;
        }

        return true;
      })
      .slice(0, CHART_LIMIT);

    const charts = allCharts.colCharts.flatMap((c) => {
      return c.relatedCharts ?? [];
    });

    let retCharts = charts;

    if (searchOptions?.length) {
      retCharts = retCharts.filter((c) => {
        const chartProp = c?.metadata?.properties?.find((p) => p.column !== comparisonOptions?.dateField);

        const propColumn = chartProp?.column;

        //TODO: Fix 'keys' of our charts and search options to prevent string
        let propValue =
          chartProp?.type === "text"
            ? chartProp?.column + " is " + chartProp?.value
            : chartProp?.type === "missing"
              ? chartProp?.column + " is {Missing}"
              : chartProp?.end !== undefined
                ? chartProp?.column + " is >" + chartProp?.start + " to " + chartProp?.end
                : chartProp?.value;

        if (
          searchOptions.find(
            (o) =>
              o.filterValue === propValue ||
              o.filterField + " is " + o.filterValue === c?.narrative?.title ||
              (o.filterField === propColumn &&
                o.filterValue === undefined) /* Special case for manual column checking */
          )
        ) {
          return true;
        }

        return false;
      });
    }

    const hiddenCharts = getHiddenCharts(state, id);
    if (hiddenCharts && Object.keys(hiddenCharts)?.length > 0) {
      retCharts = retCharts.filter((c) => {
        const isHidden = getIsChartHidden(state, id, c?.title);
        const hideChart = (!showOnlyHiddenCharts && isHidden) || (showOnlyHiddenCharts && !isHidden);
        if (hideChart) {
          return false;
        }

        return true;
      });
    }

    retCharts.sort((c1, c2) => handleSort(c1, c2));

    allCharts.charts = retCharts;
  }

  return allCharts;
}

let allDashboardChartsCache;
let allDashboardChartsCacheAll;
let allDashboardChartsKey;
let allDashboardChartsKeyAll;
export function getAllDashboardCharts(state, id, isAllCharts = false) {
  const datasetId = getDatasetId(state, id);
  if (!homeReducer.getIsExploreReady(state, datasetId)) {
    return [];
  }

  let retCharts = [];
  const activeTab = getActiveTab(state, id);
  const bestCharts = getBestCharts(state, id) ?? [];
  const bestChartsList = bestCharts.map((c) => c?.title).join(",");

  // Seperate the cache for isAllCharts and add additional keys to prevent false cache hits
  const key = id + "_" + datasetId + "_" + activeTab + "_" + bestChartsList;

  if (!isAllCharts && key === allDashboardChartsKey) {
    return allDashboardChartsCache;
  }

  if (isAllCharts && key === allDashboardChartsKeyAll) {
    return allDashboardChartsCacheAll;
  }

  if (activeTab === "DASHBOARD" || activeTab === "CHATGPT") {
    for (let i = 0; i < BESTCHART_SIZE; i++) {
      const dashboardChart = getDashboardChart(state, id, i, isAllCharts);

      if (dashboardChart !== undefined) {
        retCharts.push(dashboardChart);
      }
    }
  }

  // THE BANDAID OF THE BANDAIDS
  // Don't cache when empty
  if (retCharts?.length) {
    if (isAllCharts === true) {
      allDashboardChartsCacheAll = retCharts;
      allDashboardChartsKeyAll = key;
    } else {
      allDashboardChartsCache = retCharts;
      allDashboardChartsKey = key;
    }
  }

  return retCharts;
}

export function getAllDashboardPopulationCharts(state, id, isAllCharts = false) {
  let retCharts = [];

  const activeTab = getActiveTab(state, id);

  if (activeTab === "DASHBOARD") {
    for (let i = 0; i < BESTCHART_SIZE; i++) {
      const dashboardChart = getComparisonDashBoardPopulationChart(state, id, i, isAllCharts);

      if (dashboardChart !== undefined) {
        retCharts.push(dashboardChart);
      }
    }
  }

  return retCharts;
}

export function getComparisonDashBoardPopulationChart(state, id, rankIndex = 0, skipIsInReport = false) {
  const datasetId = getDatasetId(state, id);

  const comparisonOptions = getComparisonOptions(state, id);

  const columnCharts = getComparisonChartsByColumn(state, id);

  const popColumns = columnCharts.sort((a, b) => {
    return b.popTotal - a.popTotal;
  });

  const mainChart = popColumns?.[rankIndex];

  const bestCharts = getBestCharts(state, id);

  const mainChartCol = mainChart?.column;
  const mainBestChart = bestCharts.find((c) => c?.metadata?.properties?.find((p) => p.column === mainChartCol));
  if (!mainBestChart) {
    return;
  }

  const retMainChart = {
    ...mainBestChart,
    popTotal: mainChart?.popTotal
  };

  return retMainChart;
}

export function getComparisonDashBoardChart(state, id, rankIndex = 0, skipIsInReport = false) {
  let retChart = [];
  let detailChart = [];
  let detailColors = [];
  let retColors = [];

  const fixChart = (chart) => getInsightFromMetadata(state, id, chart?.metadata, false);

  const datasetId = getDatasetId(state, id);

  const comparisonOptions = getComparisonOptions(state, id);

  const columnCharts = getComparisonChartsByColumn(state, id);

  const bestCharts = getBestCharts(state, id);

  const mainChart = bestCharts?.[rankIndex];

  const isShowAllDashboard = getIsShowAllDashboard(state, id);

  if (mainChart === undefined) {
    return undefined;
  }

  const mainChartCol = mainChart?.metadata?.properties?.find((p) => p.column !== comparisonOptions?.dateField)?.column;
  const mainColumnChart = columnCharts?.find((c) => c.column === mainChartCol);

  if (mainColumnChart === undefined) {
    return undefined;
  }

  const relatedCharts = mainChart?.relatedCharts?.map((chart) => {
    return getInsightFromMetadata(state, id, chart?.metadata, false);
  });

  const retMainChart = {
    ...mainChart,
    relatedCharts: relatedCharts,
    popTotal: mainColumnChart?.popTotal
  };

  return retMainChart;
}

export function getDashboardChart(state, id, rankIndex = 0, skipIsInReport = false) {
  let retChart = [];
  let detailChart = [];
  let detailColors = [];
  let retColors = [];

  const fixChart = (chart) => getInsightFromMetadata(state, id, chart?.metadata, false);

  const datasetId = getDatasetId(state, id);

  const comparisonOptions = getComparisonOptions(state, id);
  if (comparisonOptions) {
    return getComparisonDashBoardChart(state, id, rankIndex, skipIsInReport);
  }

  const rankedFields = homeReducer.getRankedFields(state, datasetId);

  const bestCharts = getBestCharts(state, id);

  const mainChart = bestCharts?.[rankIndex] ? fixChart(bestCharts[rankIndex]) : undefined;

  const isShowAllDashboard = getIsShowAllDashboard(state, id);

  if (
    mainChart === undefined ||
    (skipIsInReport === false && isShowAllDashboard !== true && getIsInReport(state, id, { chart: mainChart }) !== true)
  ) {
    return undefined;
  }

  let subCharts = [];

  if (mainChart) {
    retColors.push(mainChart?.color);
    detailColors.push(mainChart?.color);
  }

  const mainKey = mainChart?.metadata?.properties?.[0]?.column;

  let childCharts = [
    ...(bestCharts?.[rankIndex]?.relatedCharts || []),
    ...(bestCharts?.[rankIndex]?.otherRelatedCharts || [])
  ];

  const isAnyChildInReport = childCharts.find((c) => getIsInReport(state, id, { chart: c }));

  childCharts
    .filter(
      (c) => true || isShowAllDashboard || isAnyChildInReport === undefined || getIsInReport(state, id, { chart: c })
    )
    .forEach((c) => {
      const fChart = fixChart(c);
      subCharts.push(fChart);
    });

  let detailChildCharts = {};

  const otherDetailKey = childCharts?.[0]?.metadata?.properties?.[1]?.column;

  let detailSubCharts = [];
  let childKeys = [];

  childCharts
    .filter(
      (c) => true || isShowAllDashboard || isAnyChildInReport === undefined || getIsInReport(state, id, { chart: c })
    )
    .filter((c) => c?.metadata?.properties?.[1]?.column === otherDetailKey)
    .forEach((c) => {
      const fChart = fixChart(c);

      detailSubCharts.push(fChart);
    });

  subCharts.forEach((line) => {
    childKeys.push({
      otherKey: line?.narrative?.conditionsLabel.split(" is ")[0],
      otherValue: line?.narrative?.conditionsLabel.split(" is ")[1]
    });
  });

  if (mainChart?.chart?.data) {
    mainChart?.chart?.data.forEach((xBucket, xIndex) => {
      let nextCol = {
        name: xBucket.name,
        ["Average " + mainKey]: xBucket.y,
        count: xBucket.summary?.getTotalN(),
        column: mainChart?.metadata?.properties?.[0]?.column,
        min: xBucket.min,
        max: xBucket.max
      };

      subCharts.forEach((line) => {
        if (xIndex === 0 && nextCol[line?.narrative?.conditionsLabel] === undefined) {
          const otherKey = line?.metadata?.properties.filter((m) => mainKey !== undefined && m.column !== mainKey)?.[0]
            ?.column;

          const fIndex = rankedFields.findIndex((f) => f.label === otherKey);

          retColors.push(colors[fIndex % colors.length] ?? "gray");
        }

        nextCol[line?.narrative?.conditionsLabel] = line?.chart?.data?.[xIndex]?.y || 0;
      });

      retChart.push(nextCol);
    });

    mainChart?.chart?.data.forEach((xBucket, xIndex) => {
      let nextCol = {
        name: xBucket.name,
        ["Average " + mainKey]: xBucket.y,
        count: xBucket.summary?.getTotalN(),
        column: mainChart?.metadata?.properties?.[0]?.column,
        min: xBucket.min,
        max: xBucket.max
      };

      detailSubCharts.forEach((line) => {
        if (xIndex === 0 && nextCol[line?.narrative?.conditionsLabel] === undefined) {
          const otherKey = line?.metadata?.properties.filter((m) => mainKey !== undefined && m.column !== mainKey)?.[0]
            ?.column;

          const fIndex = rankedFields.findIndex((f) => f.label === otherKey);

          detailColors.push(colors[fIndex % colors.length] ?? "gray");
        }

        nextCol[line?.narrative?.conditionsLabel] = line?.chart?.data?.[xIndex]?.y || 0;
      });

      detailChart.push(nextCol);
    });
  }

  const otherCharts = getRelatedInsights(state, id, undefined, {}, mainKey, "Descriptive");

  const isAnyOtherInReport = otherCharts.find((c) => getIsInReport(state, id, { chart: c }));

  const detailChartRank = childCharts[0]?.scoreRank;

  let topText = {};
  subCharts.forEach((subC) => {
    topText[subC?.narrative?.conditionsLabel] = subC?.narrative?.topText;
  });

  return {
    data: retChart.sort((a, b) => (b.name < a.name ? 1 : b.name > a.name ? -1 : 0)),
    childKeys: childKeys,
    colors: retColors,
    detailColors: detailColors,
    detailData: detailChart.sort((a, b) => (b.name < a.name ? 1 : b.name > a.name ? -1 : 0)),
    title: mainKey,
    rightTitle: mainKey + " : " + otherDetailKey,
    mainChart: {
      ...mainChart,
      fields: getFieldsFromChart(state, id, mainChart)
    },
    secondaryCharts: otherCharts
      .filter(
        (c) =>
          // TODO: Do we filter secondaryCharts in base or search cases?
          isShowAllDashboard || isAnyOtherInReport === undefined || getIsInReport(state, id, { chart: c })
      )
      .map((oChart) => ({
        ...fixChart(oChart),
        fields: getFieldsFromChart(state, id, oChart)
      })),
    firstChild: {
      ...detailSubCharts?.[0],
      fields: getFieldsFromChart(state, id, detailSubCharts?.[0])
    },
    detailChartRank: detailChartRank,
    topText: topText
  };
}

export function getInfoChart(state, id, field, value) {
  const hideOtherInCharts = chatGPTReducer.getHideOtherInCharts(state);
  const hideMissingInCharts = chatGPTReducer.getHideMissingInCharts(state);

  const metadata = {
    type: "Descriptive",
    properties: [{ column: field, value: value }]
  };

  const sInsights = getInsightAndRelatedFromMetadata(state, id, metadata, false).map((c) => ({
    ...c,
    fields: getFieldsFromChart(state, id, c),
    chart: {
      ...(c?.chart ?? {}),
      data: [
        ...(c?.chart?.data ?? []).filter((d) => {
          if ((hideOtherInCharts && d?.name === "{Other}") || (hideMissingInCharts && d?.name === "{Missing}")) {
            return false;
          }
          return true;
        })
      ]
    }
  }));

  const bestCharts = getBestCharts(state, id);

  const fixChart = (chart) => getInsightFromMetadata(state, id, chart?.metadata, false);

  const bChart =
    bestCharts !== undefined ? bestCharts.find((c) => c?.metadata?.properties?.[0]?.column === field) : undefined;

  // If the chart doesn't exist in best charts cuz its not a bestie, we have to construct a metadata object to fetch it
  const fChart = bChart
    ? fixChart(bChart)
    : fixChart({ metadata: { type: "Descriptive", properties: [{ type: "column", column: field }] } });

  const dataSlice =
    fChart?.chart?.data !== undefined
      ? fChart.chart.data.find((d) => d.name === value) || fChart.chart.data.find((d) => d.name.indexOf(value) !== -1)
      : undefined;

  const retChart = {
    id: id,
    field: field,
    value: value,
    insights: (sInsights ?? []).filter((c) => {
      if (hideOtherInCharts || hideMissingInCharts) {
        if (hideOtherInCharts && (c?.metadata?.properties ?? []).find((p) => p?.value === "{Other}")) {
          return false;
        }
        if (
          hideMissingInCharts &&
          (c?.metadata?.properties ?? []).find((p) => p?.value === "{Missing}" || p?.type === "missing")
        ) {
          return false;
        }
      }
      return true;
    }),
    base: bChart !== undefined ? bChart : undefined,
    fixedBase: fChart,
    dataSlice: dataSlice
  };

  return retChart;
}

export function getIsInPath(state, id, hex) {
  const hexMap = getHexMap(state, id);
  const actionHexMap = getActionHexMap(state, id);
  const hexagonRadius = getHexagonRadius(state, id);

  return hex.x === hexagonRadius && hex.y === hexagonRadius
    ? false
    : actionHexMap && actionHexMap[hex.x + "_" + hex.y]
      ? false
      : hexMap && hexMap[hex.x + "_" + hex.y] && hexMap[hex.x + "_" + hex.y].isPath
        ? true
        : false;
}

export function getIsInStory(state, id, node) {
  const hexMap = getHexMap(state, id);

  let isFound = false;

  Object.keys(hexMap).forEach((k) => {
    const nodes = hexMap[k];

    nodes.forEach((n) => {
      if (n?.chart?.title === node?.title && n?.chart?.metadata?.type === node?.metadata?.type) {
        isFound = true;
      }
    });
  });

  return isFound;
}

export function getFirstField(state, id, hex) {
  const firstOrderField = getFieldFromPosition(state, id, hex.x, hex.y);
  const doubleOrderFields = getDoubleFieldFromPosition(state, id, hex.x, hex.y);
  const selectedNeighbors = getSelectedNeightbors(state, id, hex.x, hex.y);

  return firstOrderField
    ? firstOrderField
    : doubleOrderFields
      ? doubleOrderFields[0]
      : selectedNeighbors
        ? selectedNeighbors
        : undefined;
}

export function getSecondField(state, id, hex) {
  const doubleOrderFields = getDoubleFieldFromPosition(state, id, hex.x, hex.y);

  return doubleOrderFields ? doubleOrderFields[1] : undefined;
}

export function getChartLabelKey(state, id, hex) {
  const node = getHexNode(state, id, hex);

  const fields = node ? node.fields : undefined;

  return fields === undefined
    ? "None"
    : Object.keys(fields).length === 2 && fields[0] && fields[1]
      ? fields[0].label + " and " + fields[1].label
      : Object.keys(fields).length === 1 && fields[0]
        ? fields[0].label
        : undefined;
}

export function getChartType(state, id) {
  return getNext(state, id).chartType;
}

export function getIsShowAllDashboard(state, id) {
  return getNext(state, id).isShowAllDashboard;
}

export function getIsHeatmapGlobalScale(state, id) {
  return getNext(state, id).isHeatmapGlobalScale;
}

export function getActiveTab(state, id) {
  const projectId = getProjectId(state, id);
  const activeTab = getNext(state, id).activeTab;
  if (projectReducer.getIsForecastProject(state, projectId) && activeTab === "MODELS") {
    return "FORECASTING";
  }
  return activeTab;
}

export function getPreviousTabView(state, id) {
  return getNext(state, id)?.previousTabView;
}

export function getIsDistribution(state, id) {
  return getNext(state, id).isDistribution;
}

export function getSavedHexMap(state, id) {
  return getNext(state, id).savedHexMap;
}

export function getActionHexMap(state, id) {
  return getNext(state, id).actionHexMap ?? {};
}

export function getSelectionDirection(state, id) {
  return getNext(state, id).selectionDirection;
}

export function getHideLines(state, id) {
  return getNext(state, id).hideLines || {};
}

export function getDashboardChartOptions(state, id) {
  return getNext(state, id).dashboardChartOptions || {};
}

export function getViewIndex(state, id) {
  return getNext(state, id).viewIndex;
}

export function getRefreshRate(state, id) {
  return getNext(state, id).refreshRate;
}

export function getTotalChartCount(state, id) {
  return getNext(state, id).totalChartCount;
}

export function getTempDatasetId(state, id) {
  return getNext(state, id).tempDatasetId;
}

export function getChartsCount(state, id) {
  const charts = getPinnedHexList(state, id, true);

  return charts !== undefined ? charts.length : 0;
}

export function getLastMoveChart(state, id) {
  return getNext(state, id).lastMoveChart;
}

export function getIsLastMoveChart(state, id, node) {
  const lastMoveChart = getLastMoveChart(state, id);

  return (
    lastMoveChart?.chart?.narrative?.title !== undefined &&
    lastMoveChart?.chart?.narrative?.title === node?.chart?.narrative?.title
  );
}

export function getSelectionDirectionCharts(state, id) {
  return getNext(state, id).selectionDirectionCharts;
}

export function getHoverNode(state, id) {
  return getNext(state, id).hoverNode;
}

export function getCanHover(state, id) {
  return getNext(state, id).canHover === undefined ? true : getNext(state, id).canHover;
}

export function getIsAnimateReturnForce(state, id) {
  return getNext(state, id).isAnimateReturn === true;
}

export function getIsAnimateReturn(state, id) {
  return getNext(state, id).isAnimateReturn === true;
}

export function getIsFewShotEnabled(state, id) {
  return getNext(state, id).isFewShotEnabled === true;
}

export function getAutoAddFewShot(state, id) {
  return getNext(state, id).autoAddFewShot === true;
}

export function getIsOpenFewShotModal(state, id) {
  return getNext(state, id).isOpenFewShotModal;
}

export function getFewShotViewMode(state, id) {
  return getNext(state, id).fewShotViewMode ?? "ALL";
}

export function getSelectedFewShotIndex(state, id) {
  return getNext(state, id).selectedFewShotIndex;
}

export function getIgnoredFewShots(state, id) {
  return getNext(state, id).ignoredFewShots ?? {};
}

export function getFewShotExample(state, id) {
  const fewShotExamples = getFewShotExamples(state, id);
  const chatTone = chatGPTReducer.getChatTone(state);

  const exampleKeys = Object.keys(fewShotExamples).filter((a) => fewShotExamples[a]?.chat_tone === chatTone);

  return exampleKeys.length === 0
    ? undefined
    : exampleKeys.reduce((a, b) => a + fewShotExamples[b]?.output_text + ", ", "");
}

export function getFewShotExample_Better(state, id) {
  const fewShotExamples = getFewShotExamples(state, id);
  const ignoredFewShots = getIgnoredFewShots(state, id);
  const chatType = chatGPTReducer.getChatType(state);

  const promptAugment_fewShot =
    chatType === "AIBLE"
      ? "I will give some Examples of a Question with an associated DATA_JSON_OBJECT followed by an excellent Response" +
        " for you to learn from. Try to match the way the Example Response handles the question in your Real Response! " +
        "\n\nThanks!\n\n"
      : "I will give some Examples of a Question followed by an excellent Response" +
        " for you to learn from. Try to match the way the Example Response handles the question in your Real Response! " +
        "\n\nThanks!\n\n";

  const examples = Object.keys(fewShotExamples).filter((f) => ignoredFewShots?.[f] !== true);

  const retExamples =
    chatType === "AIBLE"
      ? examples.reduce(
          (a, b) =>
            a +
            "Example\nQuestion:\n" +
            fewShotExamples[b]?.prompt +
            "\n\nDATA_JSON_OBJECT:\n" +
            fewShotExamples[b]?.data_json_object +
            "\n\nResponse:\n" +
            fewShotExamples[b]?.response +
            "\n\n",
          ""
        )
      : examples.reduce(
          (a, b) =>
            a +
            "Example\nQuestion:\n" +
            fewShotExamples[b]?.prompt +
            "\n\nResponse:\n" +
            fewShotExamples[b]?.response +
            "\n\n",
          ""
        );

  return promptAugment_fewShot + retExamples + "Real Example\nQuestion:\n";
}

export function getFewShotExamples(state, id) {
  return getNext(state, id).fewShotExamples ?? {};
}

export function getFewShotExamplesCount(state, id) {
  const fewShotExamples = getFewShotExamples(state, id);
  return Object.keys(fewShotExamples)?.length ?? 0;
}

export function messageHasFewShotExamples(state, nextId, index) {
  const fewShotExamples = getFewShotExamples(state, nextId);

  for (const key in fewShotExamples) {
    const fewShot = fewShotExamples[key];
    if (fewShot.message_index === index) {
      return true;
    }
  }
  return false;
}

export function fetchFewShot(nextId) {
  return (dispatch, getState) => {
    const currFewShots = getFewShotExamples(getState(), nextId);
    // This check is removed because we don't need to fetch the conversation to get the few shot
    // const currReport = reportReducer.getReport(getState(), nextId);
    // const currConvo = currReport?.metadata?.chatGPTConvo?.chatType;
    if (!Object.keys(currFewShots ?? {})?.length) {
      return dispatch(reportReducer.fetchReport(nextId));
    }
    return Promise.resolve();
  };
}

export function addFewShotsToTrainingData(nextId, artifactId, ignoredFewShotsOverride) {
  return (dispatch, getState) => {
    const fewShots = getFewShotExamples(getState(), nextId);
    const ignoredFewShots = ignoredFewShotsOverride ?? getIgnoredFewShots(getState(), nextId);

    const trainingData = llmReducer.getFineTuningData(getState(), artifactId);
    const fewShotList = Object.keys(fewShots ?? {})
      .filter((k) => !ignoredFewShots[k])
      .map((k) => {
        const cFewShot = fewShots[k];

        const question = `${cFewShot?.prompt}${cFewShot?.data_json_object ? `\n\nDATA_JSON_OBJECT:\n${cFewShot?.data_json_object}` : ""}`;
        const response = cFewShot?.response;
        return {
          input_text: question,
          output_text: response
        };
      });

    return dispatch(llmReducer.addFineTuningData(trainingData, fewShotList));
  };
}

export function getDatasetId(state, id) {
  return getNext(state, id).datasetId;
}

export function getDatasetAccountId(state, id) {
  const datasetId = getDatasetId(state, id);
  const datasetAccountId = homeReducer.getDatasetAccountId(state, datasetId);
  return datasetAccountId;
}

export function getDatasetSuccess(state, id) {
  const next = getNext(state, id);

  if (next?.success?.value !== undefined) {
    return next.success;
  }

  const datasetId = getDatasetId(state, id);

  if (homeReducer.getOutcomeType(state, datasetId) === "number") {
    return undefined;
  }

  const targetValue = homeReducer.getTargetValue(state, datasetId);

  const projectId = getProjectId(state, id);

  const innerId = projectReducer.getInnerId(state, projectId) ?? "new";
  const success = setupReducer.getSuccess(state, innerId);

  const value = success?.value ?? targetValue;

  return {
    value: value,
    rawValue: success?.rawValue,
    label: value
  };
}

export function getSelectedChart(state, id) {
  const selectedChart = getNext(state, id).selectedChart;

  return selectedChart?.chart?.metadata !== undefined
    ? {
        ...selectedChart,
        chart: getInsightFromMetadata(state, id, selectedChart?.chart?.metadata, false)
      }
    : selectedChart;
}

export function getReportLabel(state, id, defaultLabel = "My Untitled Project") {
  return getNext(state, id).reportLabel ?? defaultLabel;
}

export function getIsSavingReport(state, id) {
  return getNext(state, id).isSavingReport;
}

export function getSearchOptions(state, id) {
  return getNext(state, id).searchOptions;
}

export function getTableauDataId(state, id) {
  return getNext(state, id).tableauDataId;
}

export function getSavedActions(state, id) {
  return getNext(state, id).savedActions ?? [];
}

export function getAutosaveId(state, id) {
  return getNext(state, id)?.autosaveId;
}

export function getIgnoreDelta(state, id) {
  return getNext(state, id).ignoreDelta;
}

export function getIgnoreInfoChartField(state, id) {
  return getNext(state, id).ignoreInfoChartField;
}

export function getExtraCount(state, id) {
  return getNext(state, id).extraCount;
}

export function getIsReplay(state, id) {
  return getNext(state, id).isReplay;
}

export function getShowReplay(state, id) {
  return getNext(state, id).showReplay;
}

export function getIsComment(state, id) {
  return getNext(state, id).isComment;
}

export function getIsTasks(state, id) {
  return getNext(state, id).isTasks;
}

export function getSearchTimeline(state, id) {
  return getNext(state, id).searchTimeline || [];
}

export function getNodeAssign(state, id) {
  return getNext(state, id).nodeAsssign || {};
}

export function getComments(state, id) {
  return getNext(state, id).comments || {};
}

export function getTimelineSearchOptions(state, id) {
  const hexMap = getHexMap(state, id);
  const savedHexMap = getSavedHexMap(state, id);

  let options = {};

  Object.keys(hexMap).forEach((nodesKey) => {
    const nodes = hexMap[nodesKey];

    nodes.forEach((node) => {
      const metadata = node?.chart?.metadata?.properties;

      if (node?.chart?.title !== undefined) {
        options[node?.chart?.title] = true;
      }

      if (metadata) {
        metadata.forEach((property) => {
          if (property?.column !== undefined) {
            options[property?.column] = true;
          }
        });
      }
    });
  });

  const retOptions = Object.keys(options).map((oKey) => ({
    label: oKey,
    value: oKey
  }));

  return retOptions;
}

export function getStopAnimation(state, id) {
  const explorationKey = getExplorationKey(state, id) || 0;

  return reportReducer.getStopAnimation(state, id, explorationKey);
}

export function getReplayStopAfterAdd(state, id) {
  return getNext(state, id).replayStopAfterAdd;
}

export function getDragHex(state, id) {
  return getNext(state, id).dragHex;
}

export function getLastSearchOptions(state, id) {
  return getNext(state, id).lastSearchOptions ? getNext(state, id).lastSearchOptions : {};
}

export function getLastPinnedHex(state, id) {
  return getNext(state, id).lastPinnedHex ? getNext(state, id).lastPinnedHex : {};
}

export function getExplorationKey(state, id) {
  return getNext(state, id).explorationKey;
}

export function getIsUpdatingProject(state, id) {
  return getNext(state, id).isUpdatingProject;
}

export function getIsDomainMin(state, id) {
  return getNext(state, id).isDomainMin;
}

export function getCurrentNextId(state) {
  return getNext(state, "misc").currentNextId;
}

export function getIsPinned(state, id, hex, nodeToCheck) {
  const pinnedHex = getPinnedHex(state, id);

  const actionHexMap = getActionHexMap(state, id);

  if (Object.keys(actionHexMap).length > 0) {
    let isFound = false;
    const node = actionHexMap[hex.x + "_" + hex.y];

    if (node) {
      pinnedHex.forEach((pinnedNode) => {
        if (node?.chart?.title && pinnedNode?.chart?.title && node?.chart?.title === pinnedNode?.chart?.title) {
          isFound = true;
        }
      });
    }

    return isFound;
  }
  if (pinnedHex && pinnedHex.length > 0) {
    const result = pinnedHex.find((individualPinnedHex) => {
      return (
        nodeToCheck?.chart?.title &&
        individualPinnedHex?.chart?.title &&
        nodeToCheck?.chart?.title === individualPinnedHex?.chart?.title
      );
    });
    return result !== undefined ? true : false;
  }
  return pinnedHex[hex.x + "_" + hex.y] === undefined ? false : true;
}

export function getIsInReport(state, id, node) {
  const pinnedHexList = getPinnedHexList(state, id);

  return (
    pinnedHexList.find(
      (pNode) =>
        pNode?.chart?.narrative?.title === node?.chart?.narrative?.title &&
        (pNode?.chart?.metadata?.type === node?.chart?.metadata?.type || node?.chart?.metadata?.type === "Correlation")
    ) !== undefined
  );
}

export function getIsInHexMap(state, id, node) {
  const hexMap = getHexMap(state, id);

  let fNode = undefined;

  node &&
    (node.isAction || node.isSearch) &&
    Object.keys(hexMap).forEach((hKey) => {
      const foundNode = hexMap[hKey].find(
        (n) =>
          n &&
          n.chart &&
          n.chart.title &&
          n.chart.title === node?.chart?.title &&
          (n?.chart?.metadata?.type === node?.chart?.metadata?.type || node?.chart?.metadata?.type === "Correlation")
      );

      if (foundNode) {
        fNode = foundNode;
      }
    });

  const pinnedHex = getPinnedHex(state, id);
  if (pinnedHex && pinnedHex.length > 0) {
    pinnedHex.forEach((pNode) => {
      if (
        pNode?.chart?.title === node?.chart?.title &&
        (pNode?.chart?.metadata?.type === node?.chart?.metadata?.type || node?.chart?.metadata?.type === "Correlation")
      ) {
        fNode = pNode;
      }
    });
  }

  return fNode ? true : false;
}

export function getHasPins(state, id) {
  const pinnedHex = getPinnedHex(state, id);

  return pinnedHex.length > 0 ? true : false;
}

export function getHasActions(state, id) {
  const actionHexMap = getActionHexMap(state, id);

  return Object.keys(actionHexMap).length > 0 && getIsAnimateReturn(state, id) !== true ? true : false;
}

export function getIsHighlight(state, id, hex, node) {
  const hoverNode = getHoverNode(state, id);
  const selectedHex = getSelectedHex(state, id);
  const selectedChart = getSelectedChart(state, id);
  const selectionDirection = getSelectionDirection(state, id);

  if (node?.type === HEXAGON_NODES.CONSULTANT) {
    if (node?.text === hoverNode?.text) {
      return true;
    } else {
      return false;
    }
  }

  if (
    hoverNode &&
    hoverNode.parent &&
    hoverNode.parent.x === hex.x &&
    hoverNode.parent.y === hex.y &&
    selectionDirection === undefined
  ) {
    return true;
  }

  if (node && hoverNode && node?.chart?.title && node?.chart?.title === hoverNode?.chart?.title) {
    return true;
  }

  if (node && hoverNode && hoverNode?.chart?.title === undefined && node?.type && node?.type === hoverNode?.type) {
    return true;
  }

  if (
    selectedHex &&
    hex &&
    selectedHex.x === hex.x &&
    selectedHex.y === hex.y &&
    selectedHex?.chart !== undefined &&
    node?.chart?.narrative?.title === selectedHex?.chart?.narrative?.title
  ) {
    return true;
  }

  if (selectedChart && selectedChart.hKey && hex && hex.x !== undefined && selectedChart.hKey === hex.x + "_" + hex.y) {
    return true;
  }

  if (
    selectedChart &&
    hex?.x === undefined &&
    node &&
    selectedChart?.chart?.title !== undefined &&
    selectedChart?.chart?.title === node?.chart?.title
  ) {
    return true;
  }

  return false;
}

export function getIsSelectedActionHex(state, id, hex, node) {
  const actionHexMap = getActionHexMap(state, id);
  const selectedHex = getSelectedHex(state, id);

  return (
    selectedHex.x === hex.x &&
    selectedHex.y === hex.y &&
    Object.keys(actionHexMap).length > 0 &&
    node?.chart?.title === selectedHex?.chart?.title
  );
}

export function getRelatedExplorations(state, id) {
  const datasetId = getDatasetId(state, id);

  const explores = reportReducer.getReports(state, id);

  return explores.filter((e) => e?.metadata?.next?.datasetId === datasetId);
}

/* Actions */
export function updateNext(id, next, skipLoading = false) {
  return (dispatch, getState) => {
    if (next === undefined && !skipLoading) {
      dispatch(globalReducer.updateIsNextLoading(undefined));
    }

    return dispatch({ type: UPDATE_FIELD, id: id, data: next });
  };
}

export function updateIsKPISelectionOpen(id, val) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "isKPISelectionOpen",
    data: val
  };
}

export function updateSplitColumn(id, col) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "splitColumn",
    data: col
  };
}

export function updateIsShowAllDashboard(id, isShowAllDashboard) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "isShowAllDashboard",
    data: isShowAllDashboard
  };
}

export function updateIsFewShotEnabled(id, isFewShotEnabled) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "isFewShotEnabled",
    data: isFewShotEnabled
  };
}

export function updateAutoAddFewShot(id, autoAddFewShot) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "autoAddFewShot",
    data: autoAddFewShot
  };
}

export function updateIgnoredFewShots(id, ignoredFewShots) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "ignoredFewShots",
    data: ignoredFewShots
  };
}

export function updateSelectedFewShotIndex(id, selectedFewShotIndex) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "selectedFewShotIndex",
    data: selectedFewShotIndex
  };
}

export function addFewShotExample(id, fewShotExample) {
  return (dispatch, getState) => {
    const fewShotExamples = getFewShotExamples(getState(), id);
    dispatch(
      updateFewShotExamples(id, {
        ...fewShotExamples,
        [Object.keys(fewShotExamples).length]: fewShotExample
      })
    );

    //return dispatch(saveNext(id, "", false));
  };
}

export function resetFewShotExamples(id) {
  return (dispatch, getState) => {
    const chatTone = chatGPTReducer.getChatTone(getState());
    const fewShotExamples = getFewShotExamples(getState(), id);

    Object.keys(fewShotExamples)
      .filter((a) => fewShotExamples[a].chat_tone === chatTone || fewShotExamples[a].chat_tone === undefined)
      .forEach((a) => {
        delete fewShotExamples[a];
      });

    dispatch(updateIgnoredFewShots(id, {}));

    return dispatch(
      updateFewShotExamples(id, {
        // ...fewShotExamples,
      })
    );
  };
}

export function ignoreAllFewShotExamples(id) {
  return (dispatch, getState) => {
    const fewShotExamples = getFewShotExamples(getState(), id);

    let retFewshots = {};
    Object.keys(fewShotExamples).forEach((fewshotKey) => {
      retFewshots[fewshotKey] = true;
    });

    return dispatch(updateIgnoredFewShots(id, retFewshots));
  };
}

export function removeLastFewShot(id) {
  return (dispatch, getState) => {
    const fewShotExamples = getFewShotExamples(getState(), id);
    const ignoredFewShots = getIgnoredFewShots(getState(), id);
    const retExamples = { ...fewShotExamples };
    const retIgnored = { ...ignoredFewShots };
    const retKeys = Object.keys(retExamples);
    const lastKey = retKeys[retKeys?.length - 1];

    if (retKeys?.length > 0) {
      if (retIgnored[lastKey] === true) {
        delete retIgnored[lastKey];
        dispatch(updateIgnoredFewShots(id, retIgnored));
      }
      delete retExamples[lastKey];
      return dispatch(updateFewShotExamples(id, retExamples));
    }
    return;
  };
}

export function checkMessageForFewShot(state, id, index) {
  const fewShotExamples = getFewShotExamples(state, id);

  for (const key in fewShotExamples) {
    const fewShot = fewShotExamples[key];
    if (fewShot.message_index === index) {
      return true;
    }
  }
  return false;
}

export function updateFewShotExamples(id, fewShotExamples) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "fewShotExamples",
    data: fewShotExamples
  };
}

export function updateIsOpenFewShotModal(id, isOpenFewShotModal) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "isOpenFewShotModal",
    data: isOpenFewShotModal
  };
}

export function updateFewShotViewMode(id, fewShotViewMode) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "fewShotViewMode",
    data: fewShotViewMode
  };
}

export function updateTargetColumn(id, col) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "targetColumn",
    data: col
  };
}

export function updateAutomaticFineTuningThreshold(id, val) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "automaticFineTuningThreshold",
    data: val !== undefined && !isNaN(val) ? Number(val) : val
  };
}

export function updateAutomaticFineTuningModelId(id, val) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "automaticFineTuningModelId",
    data: val
  };
}

export function updateAutomaticFineTuningModelName(id, val) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "automaticFineTuningModelName",
    data: val
  };
}

export function updateFineTunedModels(id, fineTunedModels) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "fineTunedModels",
    data: fineTunedModels
  };
}

export function handleTrainFineTuning(id, exampleSet) {
  return async (dispatch, getState) => {
    let retId = id;
    if (id === undefined) {
      retId = getCurrentNextId(getState());
    }

    const modelName = getAutomaticFineTuningModelName(getState(), retId);
    const modelId = getAutomaticFineTuningModelId(getState(), retId);
    const foundModel = chatGPTReducer.getAiServiceModel(getState(), modelId);
    if (foundModel) {
      const isGeminiModel = foundModel && String(foundModel?.external_id).startsWith("gemini");

      let newModelOptions = {};
      if (isGeminiModel) {
        newModelOptions = {
          type: "VERTEX_AI_GEMINI",
          epoch_count: 4,
          learning_rate_multiplier: 1,
          adapter_size: "ADAPTER_SIZE_ONE"
        };
      }
      const payload = {
        base_model_version_id: foundModel?.version_id,
        example_set_id: exampleSet?.id,
        name: modelName,
        type: "TRAINING",
        parameters: newModelOptions
      };
      const newModel = await dispatch(fineTuningReducer.trainFineTuningExecution(payload));

      const retFineTunedModels = { ...(getFineTunedModels(getState(), retId) ?? {}), [newModel?.id]: true };

      dispatch(updateFineTunedModels(retId, retFineTunedModels));

      dispatch(saveNext(retId, "", false));

      return newModel;
    }
  };
}

export function checkAutomaticFineTuningThreshold(id) {
  return async (dispatch, getState) => {
    const automaticFineTuningThreshold = getAutomaticFineTuningThreshold(getState(), id);

    if (!automaticFineTuningThreshold) {
      return Promise.resolve();
    }

    const totalLikes = chatGPTReducer.getConversationResultFeedbackCount(getState(), id, ["LIKE", "DISLIKE"]);

    // Detect whether there's enough feedback. We only trigger in the instances where the count is a multiple of the threshold
    // This is potentially fragile, but should prevent duplicate triggers
    // (except in the case where multiple people open the same project because why are we doing this in the UI in the first place...)
    if (totalLikes >= automaticFineTuningThreshold && totalLikes % automaticFineTuningThreshold === 0) {
      const likedDetails = chatDetailsReducer.getReportLikedChatDetails(getState(), id);
      const reportName = getReportLabel(getState(), id);
      const chatApp = chatGPTReducer.getChatApp(getState());
      const folderId = foldersReducer.getSelectedFolder(getState());
      const retReportName = reportName === "My Untitled Project" ? chatApp.name : reportName;
      const newModelName = getAutomaticFineTuningModelName(getState(), id);

      const currentDate = new Date().toLocaleString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true
      });

      const trainingDataName = newModelName + " Training Data - " + currentDate;

      const exampleSetCreate = {
        name: trainingDataName,
        description: "",
        metadata: {},
        folder_id: folderId
      };

      const executionIds = likedDetails.flatMap((d) => {
        if (d.results?.length) {
          return d.results.flatMap((r) => {
            if (r?.data?.input && r?.data?.output) {
              return r.id;
            }
            return [];
          });
        }
        return [];
      });

      const newExampleset = await dispatch(contentGenerationReducer.createExampleSet(exampleSetCreate));
      await dispatch(contentGenerationReducer.addExecutionsToExampleSet(newExampleset?.id, executionIds)).finally(
        (res) => {
          try {
            if (chatApp?.id && newExampleset?.id) {
              dispatch(chatAppReducer.addTrainingDatasetToChatApp(chatApp.id, newExampleset.id));
            }
          } catch (e) {
            console.log(e);
          }
          return res;
        }
      );

      const modelId = getAutomaticFineTuningModelId(getState(), id);
      const foundModel = chatGPTReducer.getAiServiceModel(getState(), modelId);
      if (foundModel) {
        const isGeminiModel = foundModel && String(foundModel?.external_id).startsWith("gemini");

        let newModelOptions = {};
        if (isGeminiModel) {
          newModelOptions = {
            type: "VERTEX_AI_GEMINI",
            epoch_count: 4,
            learning_rate_multiplier: 1,
            adapter_size: "ADAPTER_SIZE_ONE"
          };
        }
        try {
          const payload = {
            base_model_version_id: foundModel?.version_id,
            example_set_id: newExampleset?.id,
            name: newModelName,
            type: "TRAINING",
            parameters: newModelOptions
          };

          await dispatch(fineTuningReducer.trainFineTuningExecution(payload));

          toast(
            <div>
              <span>{`${foundModel?.name} is being automatically improved. Once the new intern is available it will be tested to validate the improvements.`}</span>
              <div>
                <span>
                  <a
                    style={{ color: "#FFFFFF", textDecoration: "underline" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      dispatch(push("/"));
                      dispatch(viewReducer.updateModelViewType("TRAINING_JOBS"));
                      dispatch(viewReducer.updateType(viewReducer.VIEW_TYPE.ARTIFACTS));
                    }}
                  >
                    {"View the model improvement progress"}
                  </a>
                </span>
              </div>
            </div>,
            {
              type: toast.TYPE.SUCCESS,
              position: toast.POSITION.TOP_CENTER,
              autoClose: 15000
            }
          );
        } catch (e) {
          console.log(e);
        }
      }
    }
    return Promise.resolve();
  };
}

export function updateMinimumValueCount(id, val) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "minimumValueCount",
    data: val
  };
}

export function updateHideLine(id, hideValue, isHidden) {
  return (dispatch, getState) => {
    let retHideLines = { ...getHideLines(getState(), id) };

    retHideLines[hideValue] = isHidden;

    return dispatch(updateHideLines(id, retHideLines));
  };
}

export function updateHideLines(id, hideLines) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "hideLines",
    data: hideLines
  };
}

export function updateDashboardChartOptions(id, dashboardChartOptions) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "dashboardChartOptions",
    data: dashboardChartOptions
  };
}

export function updateIsDomainMin(id, isDomainMin) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "isDomainMin",
    data: isDomainMin
  };
}

export function updateIsDeployed(id, val) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "isDeployed",
    data: val
  };
}

export function updateRefreshRate(id, refreshRate) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "refreshRate",
    data: refreshRate
  };
}

export function checkAndUpdateProjectTargetAndSubgroup(id) {
  return (dispatch, getState) => {
    const datasetId = getDatasetId(getState(), id);
    const projectId = getProjectId(getState(), id);

    const targetColumn = homeReducer.getOutcome(getState(), datasetId);
    const splitColumn = projectReducer.getSplitColumn(getState(), projectId);

    if (targetColumn !== getTargetColumn(getState(), id)) {
      dispatch(updateTargetColumn(id, targetColumn));
    }
    if (splitColumn !== getSplitColumn(getState(), id)) {
      dispatch(updateSplitColumn(id, splitColumn));
    }
  };
}

export function updateHexSize(id, hexSize) {
  return (dispatch, getState) => {
    const next = getNext(getState(), id);

    dispatch({
      type: UPDATE_FIELD,
      id: id,
      data: {
        ...next,
        hexMap: { ...next.hexMap },
        hexSize: hexSize,
        innerHexSize: calcInnerHexSize(hexSize)
      }
    });

    const selectedHex = getSelectedHex(getState(), id);

    //selectedHex && setTimeout(() => centerHex(selectedHex), 500);

    return Promise.resolve();
  };
}

export function updateHexagonRadius(id, hexagonRadius) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: hexagonRadius,
    key: "hexagonRadius"
  };
}

export function updateChartType(id, chartType) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: chartType,
    key: "chartType"
  };
}

export function updateIgnoreDelta(id, ignoreDelta) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: ignoreDelta,
    key: "ignoreDelta"
  };
}

export function updateExtraCount(id, extraCount) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: extraCount,
    key: "extraCount"
  };
}

export function updateIgnoreInfoChartField(id, ignoreInfoChartField) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: ignoreInfoChartField,
    key: "ignoreInfoChartField"
  };
}

export function updateIsHeatmapGlobalScale(id, isHeatmapGlobalScale) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: isHeatmapGlobalScale,
    key: "isHeatmapGlobalScale"
  };
}

export function updateActiveTab(id, activeTab, isSkipLinkedComparison = false) {
  return async (dispatch, getState) => {
    const currentActiveTab = getActiveTab(getState(), id);
    const previousTabView = getPreviousTabView(getState(), id) ?? "EXPLORE";

    const targetTab =
      activeTab === "PREVIOUS_VIEW"
        ? currentActiveTab === "EXPLORE" ||
          currentActiveTab === "DASHBOARD" ||
          currentActiveTab === "CHATGPT" ||
          currentActiveTab === "NLQ Dashboard"
          ? currentActiveTab
          : previousTabView
        : activeTab;

    if (currentActiveTab === "EXPLORE" && targetTab !== "EXPLORE") {
      dispatch(resetActions(id));
    }

    const explorationKey = getExplorationKey(getState(), id) || 0;

    dispatch(updateHexSize(id, targetTab === "EXPLORE" ? 100 : 128));

    if (targetTab === "EXPLORE" && reportReducer.getStopAnimation(getState(), id, explorationKey) !== true) {
      setTimeout(() => dispatch(reportReducer.updateStopAnimation(id, explorationKey, true)), 3000);
    }

    if (targetTab === "EXPLORE") {
      const hexagonRadius = getHexagonRadius(getState(), id);

      setTimeout(() => {
        centerHex({ x: hexagonRadius, y: hexagonRadius });
      }, 500);
    }

    if (
      currentActiveTab === "EXPLORE" ||
      currentActiveTab === "DASHBOARD" ||
      currentActiveTab === "CHATGPT" ||
      currentActiveTab === "NLQ Dashboard"
    ) {
      dispatch({
        type: UPDATE_FIELD_VALUE,
        id: id,
        data: currentActiveTab,
        key: "previousTabView"
      });
    }

    // TODO: @Robert
    //       Add a limiter so we don't DDOS the cloud account (split out part of the fetchReportChatMessageDetails?)
    //       Add a state in the reducer so only call this once to prevent duplicate fetches
    if (targetTab === "NLQ Dashboard") {
      const conversation = chatGPTReducer.getConversation(getState());
      const conversationOrder = chatGPTReducer.getConversationOrder(getState());
      conversationOrder.forEach((c) => {
        const message = conversation?.[c] || {};
        if (message.chatType === "SQL") {
          dispatch(chatDetailsReducer.fetchMessageChatMessageDetails(message));
        }
      });
    }

    const linkedComparisonProjects = getLinkedComparisonProjects(getState(), id) ?? {};
    if (Object.keys(linkedComparisonProjects)?.length > 0 && isSkipLinkedComparison !== true) {
      const originalId = getLinkedComparisonOriginalId(getState(), id);
      const linkedDatasetId = getDatasetId(getState(), id);

      if ((targetTab === "CHATGPT" || targetTab === "NLQ Dashboard") && id !== originalId) {
        await dispatch(openComparisonProject(originalId, true));

        dispatch(globalReducer.updateIsOpeningComparison(true));

        dispatch(updateDatasetId(originalId, linkedDatasetId));

        dispatch({
          type: UPDATE_FIELD_VALUE,
          id: originalId,
          data: targetTab,
          key: "activeTab"
        });

        dispatch(globalReducer.updateIsOpeningComparison(false));
      } else if (targetTab !== "CHATGPT" && targetTab !== "NLQ Dashboard") {
        const nId = getLinkedComparisonIdFromDatasetId(getState(), id, linkedDatasetId);

        if (nId !== undefined && nId !== id) {
          await dispatch(openComparisonProject(nId, true));

          return dispatch({
            type: UPDATE_FIELD_VALUE,
            id: nId,
            data: targetTab,
            key: "activeTab"
          });
        }
      }
    }

    // This is causing duplicate messages probably from switching tabs and then adding the chat message
    // if (targetTab === "CHATGPT" || targetTab === "NLQ Dashboard") {
    //   const conversation = chatGPTReducer.getConversation(getState());
    //   if (!conversation?.length) {
    //     dispatch(chatGPTReducer.addNewChatMessage());
    //   }
    // }

    return dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: targetTab,
      key: "activeTab"
    });
  };
}

export function updateProjectId(id, projectId) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: projectId,
    key: "projectId"
  };
}

export function updateProjects(id, projects) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: projects,
    key: "projects"
  };
}

export function updateReplayStopAfterAdd(id, replayStopAfterAdd) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: replayStopAfterAdd,
    key: "replayStopAfterAdd"
  };
}

export function updateDragHex(id, dragHex) {
  return (dispatch, getState) => {
    const cDragHex = getDragHex(getState(), id);

    if (cDragHex === undefined || cDragHex?.x !== dragHex?.x || cDragHex?.y !== dragHex?.y) {
      return dispatch({
        type: UPDATE_FIELD_VALUE,
        id: id,
        data: dragHex,
        key: "dragHex"
      });
    }

    return Promise.resolve();
  };
}

export function createExplorationKey(id) {
  return (dispatch, getState) => {
    const explorations = reportReducer.getExplorations(getState(), id);

    //dispatch(initGrid(id, {}));
    dispatch(updateReplayIndex(id, -1));
    dispatch(updateSavedActions(id, []));

    return dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: Object.keys(explorations).length,
      key: "explorationKey"
    });
  };
}

export function updateExplorationKey(id, explorationKey, skipKeys) {
  return (dispatch, getState) => {
    let retExplorations = { ...reportReducer.getExplorations(getState(), id) };

    const currNext = getNext(getState(), id);
    const keepNext = {};
    if (currNext && skipKeys && skipKeys.length) {
      skipKeys.forEach((currKey) => {
        if (currNext[currKey] !== undefined) {
          keepNext[currKey] = currNext[currKey];
        }
      });
    }

    const nNext = {
      ...(retExplorations?.[explorationKey] || {}),
      explorationKey: explorationKey,
      ...keepNext
    };

    return dispatch(updateNext(id, nNext));
  };
}

export function updateSearchType(id, searchType, shouldSearch = true) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: searchType,
      key: "searchType"
    });

    if (shouldSearch !== true) {
      return Promise.resolve();
    }

    const searchOptions = getSearchOptions(getState(), id);

    return dispatch(handleSearchInsights(id, searchOptions));
  };
}

export function updateLastSearchOptions(id, lastSearchOptions) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: lastSearchOptions,
    key: "lastSearchOptions"
  };
}

export function updateSavedNextId(id, savedNextId) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: savedNextId,
    key: "savedNextId"
  };
}

export function resetActions(id, isAnimate = false, saveReplay = true, isInstant = false) {
  return (dispatch, getState) => {
    saveReplay === true &&
      dispatch(
        addSavedAction(id, {
          type: "RESET_ACTIONS",
          isVisible: false,
          isInstant: isInstant
        })
      );

    const selectedHex = getSelectedHex(getState(), id);
    const actionHexMap = getActionHexMap(getState(), id);
    const pinnedHex = getPinnedHex(getState(), id);
    const selectedChart = getSelectedChart(getState(), id);

    const recentPin = (pinnedHex?.length > 0 && pinnedHex[pinnedHex.length - 1]) || selectedChart;

    if (selectedHex && Object.keys(actionHexMap).length > 0 && isAnimate === true) {
      /*
      dispatch({
        type: UPDATE_FIELD_VALUE,
        id: id,
        key: "isAnimateReturn",
        data: true,
      });
      */

      dispatch({ type: RESET_ACTIONS, id: id });
    } else {
      dispatch({ type: RESET_ACTIONS, id: id });
    }
  };
}

export function getHoverFromNode(state, node) {
  const fields = node && node.fields;

  const isDouble = fields && Object.keys(fields).length === 2;

  let hoverRibbon = undefined;

  if (isDouble && fields && fields[0] && fields[1]) {
    hoverRibbon = 0;

    const first = fields[0].rank;
    const second = fields[1].rank;

    if (second === 0) {
      hoverRibbon = first;
    } else {
      for (let i = 0; i < first; i++) {
        hoverRibbon += 5 - i;
      }

      hoverRibbon += second;
    }
  }

  if (isNaN(hoverRibbon)) {
    hoverRibbon = undefined;
  }

  const hoverGroup =
    node && node.chart && node.chart.rank
      ? node.chart.rank
      : fields && Object.keys(fields).length > 0 && fields[0]
        ? fields[0].rank
        : undefined;

  const retHover = {
    hoverGroup: hoverGroup,
    hoverRibbon: hoverRibbon,
    hoverNode: node
  };

  return retHover;
}

export function updateHover(id, node) {
  return (dispatch, getState) => {
    const selectedHex = getSelectedHex(getState(), id);
    const canHover = getCanHover(getState(), id);
    const isAnimateReturn = getIsAnimateReturnForce(getState(), id);

    if (canHover !== true) {
      return Promise.resolve();
    }

    const fields = node && node.fields;

    const isDouble = fields && Object.keys(fields).length === 2;

    let hoverRibbon = undefined;

    if (isDouble && fields && fields[0] && fields[1]) {
      hoverRibbon = 0;

      const first = fields[0].rank;
      const second = fields[1].rank;

      if (second === 0) {
        hoverRibbon = first;
      } else {
        for (let i = 0; i < first; i++) {
          hoverRibbon += 5 - i;
        }

        hoverRibbon += second;
      }
    }

    if (isNaN(hoverRibbon)) {
      hoverRibbon = undefined;
    }

    const hoverGroup =
      node && node.chart && node.chart.rank
        ? node.chart.rank
        : fields && Object.keys(fields).length > 0 && fields[0]
          ? fields[0].rank
          : undefined;

    return dispatch({
      type: UPDATE_HOVER,
      id: id,
      hoverGroup: hoverGroup,
      hoverRibbon: hoverRibbon,
      hoverNode: node
    });
  };
}

export function updateBase(base) {
  return {
    type: UPDATE_BASE,
    data: base
  };
}

export function updateContinuousGraphDisplayType(id, type) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: type,
    key: "continuousGraphDisplayType"
  };
}

export function updateCurrentNextId(currentNextId) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: "misc",
    data: currentNextId,
    key: "currentNextId"
  };
}

export function updateHoverGroup(id, hoverGroup) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: hoverGroup,
    key: "hoverGroup"
  };
}

export function updateHoverRibbon(id, hoverRibbon) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: hoverRibbon,
    key: "hoverRibbon"
  };
}

export function updateIsDistribution(id, isDistribution) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: isDistribution,
    key: "isDistribution"
  };
}

export function updateIsLeftClosed(id, isLeftClosed) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: isLeftClosed,
    key: "isLeftClosed"
  };
}

export function updateIsSavingReport(id, isSavingReport) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: isSavingReport,
    key: "isSavingReport"
  };
}

export function updateReportLabel(id, reportLabel) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: reportLabel,
    key: "reportLabel"
  };
}

export function updateHasViewedList(id, hasViewedList) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: hasViewedList,
    key: "hasViewedList"
  };
}

export function updateIsUpdatingProject(id, isUpdatingProject) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: isUpdatingProject,
    key: "isUpdatingProject"
  };
}

export function resetPinnedHex(id) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: [],
    key: "pinnedHex"
  };
}

export function updateNodeNarrativeMadlib(id, nodeId, madlibs) {
  return (dispatch, getState) => {
    const currentMadlibs = getAllNodeNarrativeMadlibs(getState(), id);
    if (currentMadlibs[nodeId] === undefined) currentMadlibs[nodeId] = { ...madlibs };
    else {
      currentMadlibs[nodeId] = { ...madlibs[currentMadlibs], ...madlibs };
    }
    return dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: currentMadlibs,
      key: "nodeNarrativeMadlibs"
    });
  };
}

export function updateNarrativeMadlib(id, madlib) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: madlib,
    key: "narrativeMadlibs"
  };
}

export function updateNodeDescription(id, nodeId, description) {
  return (dispatch, getState) => {
    const currentNodeDescriptions = getNodeDescriptions(getState(), id);
    currentNodeDescriptions[nodeId] = description;
    return dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: currentNodeDescriptions,
      key: "nodeDescriptions"
    });
  };
}

export function updateNodeChartType(id, nodeId, type) {
  return (dispatch, getState) => {
    const currentChartTypes = getNodeChartTypes(getState(), id);
    currentChartTypes[nodeId] = type;
    return dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: currentChartTypes,
      key: "nodeChartTypes"
    });
  };
}

export function updateNodeMadlibs(id, nodeId, madlibs) {
  return (dispatch, getState) => {
    const currentNodeMadlibs = getNodeMadlibs(getState(), id);
    currentNodeMadlibs[nodeId] = madlibs;
    return dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: currentNodeMadlibs,
      key: "nodeMadlibs"
    });
  };
}

export function updateIsReplay(id, isReplay) {
  return (dispatch, getState) => {
    const activeTab = getActiveTab(getState(), id);

    if (activeTab === "MODELS") {
      return dispatch(nextModelsReducer.updateIsReplay(id, isReplay));
    }

    if (isReplay === false) {
      if (window.replayTimeouts) {
        window.replayTimeouts.forEach((timeout) => clearTimeout(timeout));
      }
    }

    return dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: isReplay,
      key: "isReplay"
    });
  };
}

export function updateShowReplay(id, showReplay) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: showReplay,
    key: "showReplay"
  };
}

export function updateLastPinnedHex(id, lastPinnedHex) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: lastPinnedHex,
    key: "lastPinnedHex"
  };
}

export function updateBeforeReplayHexMap(id, beforeReplayHexMap) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: beforeReplayHexMap,
    key: "beforeReplayHexMap"
  };
}

export function updateReplayIndex(id, replayIndex) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: replayIndex,
    key: "replayIndex"
  };
}

export function updateIsReportExpand(id, isReportExpand, node) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: isReportExpand,
      key: "isReportExpand"
    });

    if (isReportExpand === false) {
      setTimeout(() => centerHex({ x: 8, y: 8 }), 100);
    }

    if (node !== undefined) {
      setTimeout(() => dispatch(scrollReportByTitle(id, node), 100));
    }
  };
}

export function updatePinnedHexList(id, pinnedHexList) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: pinnedHexList,
    key: "pinnedHexList"
  };
}

export function updateNodeCompleted(id, node) {
  return (dispatch, getState) => {
    let pinnedHexList = getPinnedHexList(getState(), id);

    pinnedHexList.push(node);

    return dispatch(updatePinnedHexList(id, pinnedHexList));
  };
}

export function addToPinnedHexList(id, node) {
  return (dispatch, getState) => {
    const isReplay = getIsReplay(getState(), id);

    isReplay !== true &&
      dispatch(
        addSavedAction(id, {
          type: "ADD_TO_PINNED_HEX_LIST",
          node: stripNodeOfData(node)
        })
      );

    let pinnedHexList = getPinnedHexList(getState(), id);
    pinnedHexList.push({ ...node });

    dispatch(updatePinnedHexList(id, pinnedHexList));

    dispatch(updateSelectedChart(id, undefined));

    return setTimeout(() => {
      dispatch(scrollReportByTitle(id, node));
    }, 200);
  };
}

export function addNode(id, node) {
  return (dispatch, getState) => {
    const retNode = {
      ...node,
      isSearch: true
    };

    return dispatch(updatePinnedHex(id, {}, retNode));
  };
}

export function updatePinnedHex(id, hex, rNode, saveReplay = true, isTodo = false) {
  return (dispatch, getState) => {
    const node = {
      ...rNode,
      sortScore: rNode?.parentSortScore !== undefined ? rNode?.parentSortScore + 1 : 999999
    };

    saveReplay === true &&
      dispatch(
        addSavedAction(id, {
          type: "UPDATE_PINNED_HEX",
          hex: hex,
          node: {
            ...stripNodeOfData(node),
            isAction: false,
            x: node?.parent?.x,
            y: node?.parent?.y,
            aParent: { ...stripNodeOfData(node) },
            parent: { ...stripNodeOfData(node) }
          },
          isTodo: isTodo,
          isStopAdvance: isTodo === true ? true : undefined
        })
      );

    const hKey = hex.x + "_" + hex.y;
    const oPinnedHex = getPinnedHex(getState(), id) ? getPinnedHex(getState(), id) : {};

    const pinnedHex = [
      ...oPinnedHex,
      {
        ...hex,
        ...node,
        sortIndex: Object.keys(oPinnedHex).length,
        isTodo: isTodo
      }
    ];

    dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: undefined,
      key: "selectedChart"
    });

    dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: pinnedHex,
      key: "pinnedHex"
    });

    let eFound = undefined;

    // Addnig from search
    if (node.isSearch === true) {
      const hexMap = getHexMap(getState(), id);

      Object.keys(hexMap).forEach((h) => {
        const nodes = hexMap[h];

        nodes.forEach((node) => {
          const neighbors = getNeighborLocationEmpty(getState(), id, node.x, node.y);

          if (neighbors && neighbors.length > 0) {
            eFound = neighbors[0];
          }
        });
      });

      if (eFound !== undefined) {
        let retHexMap = { ...getHexMap(getState(), id) };

        retHexMap[eFound.x + "_" + eFound.y] = [
          {
            ...node,
            ...eFound,
            fields: node?.fields ? { ...node.fields } : getFieldsFromChart(getState(), id, node),
            isSearch: undefined
          }
        ];

        if (isTodo === false) {
          let pinnedHexList = getPinnedHexList(getState(), id);
          pinnedHexList.push({
            ...node,
            x: eFound ? eFound.x : node?.parent?.x,
            y: eFound ? eFound.y : node?.parent?.y,
            aParent: { ...stripNodeOfData(node) },
            parent: { ...stripNodeOfData(node) }
          });
          dispatch(updatePinnedHexList(id, pinnedHexList));
        }

        dispatch(updateHexMap(id, retHexMap));
        setTimeout(() => centerHex(eFound), 100);

        return setTimeout(() => {
          dispatch(scrollReportByTitle(id, node));
        }, 200);
      }
    }

    if (isTodo === false) {
      let pinnedHexList = getPinnedHexList(getState(), id);
      pinnedHexList.push({
        ...node,
        x: eFound ? eFound.x : node?.parent?.x,
        y: eFound ? eFound.y : node?.parent?.y,
        aParent: { ...stripNodeOfData(node) },
        parent: { ...stripNodeOfData(node) }
      });
      dispatch(updatePinnedHexList(id, pinnedHexList));
    }

    /*
    toast(
      <div>
        {"Chart " +
          node?.chart?.title +
          " has been added to your " +
          (isTodo ? " to do list." : "report.")}
      </div>,
      {
        type: toast.TYPE.SUCCESS,
        position: toast.POSITION.TOP_CENTER,
        autoClose: 7500,
      }
    );
    */

    return setTimeout(() => {
      dispatch(scrollReportByTitle(id, node));
    }, 200);
  };
}

export function showMore(id) {
  return (dispatch, getState) => {
    const viewIndex = getViewIndex(getState(), id);
    const totalChartCount = getTotalChartCount(getState(), id);

    if (viewIndex < totalChartCount) {
      dispatch(updateViewIndex(id, viewIndex + 6));

      const comparisonOptions = getComparisonOptions(getState(), id);

      if (comparisonOptions) {
        const selectedHex = getSelectedHex(getState(), id);
        dispatch(updateSelectedHex(id, selectedHex, selectedHex, undefined, false));
        dispatch(updateSelectedHex(id, selectedHex, selectedHex));
        return dispatch(updateViewIndex(id, viewIndex + 6));
      } else {
        const selectionDirection = getSelectionDirection(getState(), id);
        return dispatch(updateSelectionDirection(id, selectionDirection, undefined, true));
      }
    }
  };
}

export function showLess(id) {
  return (dispatch, getState) => {
    const viewIndex = getViewIndex(getState(), id);

    if (viewIndex - 6 >= 0) {
      dispatch(updateViewIndex(id, viewIndex - 6));

      const comparisonOptions = getComparisonOptions(getState(), id);

      if (comparisonOptions) {
        const selectedHex = getSelectedHex(getState(), id);
        dispatch(updateSelectedHex(id, selectedHex, selectedHex, undefined, false));
        dispatch(updateSelectedHex(id, selectedHex, selectedHex));
        return dispatch(updateViewIndex(id, viewIndex - 6));
      } else {
        const selectionDirection = getSelectionDirection(getState(), id);
        return dispatch(updateSelectionDirection(id, selectionDirection, undefined, true));
      }
    }
  };
}

export function updateTotalChartCount(id, totalChartCount) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: totalChartCount,
    key: "totalChartCount"
  };
}

export function updateSelectionDirectionCharts(id, selectionDirectionCharts) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: selectionDirectionCharts,
    key: "selectionDirectionCharts"
  };
}

export function updateLastMoveChart(id, lastMoveChart) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: lastMoveChart,
    key: "lastMoveChart"
  };
}

export function updateViewIndex(id, viewIndex) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: viewIndex,
    key: "viewIndex"
  };
}

export function updateSavedActions(id, savedActions) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: savedActions,
    key: "savedActions"
  };
}

export function updateAutosaveId(id, autosaveId) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: autosaveId,
    key: "autosaveId"
  };
}

export function updateIsHideSearch(id, isHideSearch) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: isHideSearch,
    key: "isHideSearch"
  };
}

export function updateIsHideLegend(id, isHideLegend) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: isHideLegend,
    key: "isHideLegend"
  };
}

export function updateIsAngleAxis(id, isAngleAxis) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: isAngleAxis,
    key: "isAngleAxis"
  };
}

export function updateDashboardLayout(id, dashboardLayout) {
  return (dispatch, getState) => {
    return dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: dashboardLayout,
      key: "dashboardLayout"
    });
  };
}

export function updateComparisonDashboardSortOrder(id, dashboardLayout) {
  return (dispatch, getState) => {
    return dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: dashboardLayout,
      key: "comparisonDashboardSortOrder"
    });
  };
}

export function updateDashboardSubchartsCount(id, dashboardSubchartsCount) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: dashboardSubchartsCount,
    key: "dashboardSubchartsCount"
  };
}

export function updateDashboardSize(id, dashboardSize) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: dashboardSize,
    key: "dashboardSize"
  };
}

export function updateLinkedOriginalDatasetId(id, linkedOriginalDatasetId) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: linkedOriginalDatasetId,
    key: "linkedOriginalDatasetId"
  };
}

export function updateLinkedComparisonProjects(id, linkedComparisonProjects) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: linkedComparisonProjects,
    key: "linkedComparisonProjects"
  };
}

export function updateIsLinkedComparisonCreating(id, isLinkedComparisonCreating) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: isLinkedComparisonCreating,
    key: "isLinkedComparisonCreating"
  };
}

export function updateIsAutoRecommendLinkedComparison(id, isAutoRecommendLinkedComparison) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: isAutoRecommendLinkedComparison,
    key: "isAutoRecommendLinkedComparison"
  };
}

export function updateShowHiddenCharts(id, showHiddenCharts) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: showHiddenCharts,
    key: "showHiddenCharts"
  };
}

export function updateHiddenCharts(id, hiddenCharts) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: hiddenCharts,
    key: "hiddenCharts"
  };
}

export function updateIsChartHidden(id, title, value) {
  return (dispatch, getState) => {
    const hiddenCharts = getHiddenCharts(getState(), id) ?? {};

    const retHiddenCharts = {
      ...hiddenCharts
    };
    if (value) {
      retHiddenCharts[title] = value;
    } else {
      delete retHiddenCharts[title];
    }

    return dispatch(updateHiddenCharts(id, retHiddenCharts));
  };
}

export function updateComparisonChartOptions(id, comparisonChartOptions) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: comparisonChartOptions,
    key: "comparisonChartOptions"
  };
}

export function updateComparisonOptions(id, comparisonOptions) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: comparisonOptions,
    key: "comparisonOptions"
  };
}

export function updateComparisonOptionsValue(id, key, value) {
  return {
    type: UPDATE_COMPARISON_OPTION,
    id: id,
    key: key,
    data: value
  };
}

export function updateIsComment(id, isComment) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "isComment",
    data: isComment
  };
}

export function updateIsTasks(id, isTasks) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "isTasks",
    data: isTasks
  };
}

/*
if (isStopPropagation) {
  e.stopPropagation();
}
*/

export function updateIsOpenSaveScenarioModal(id, isOpenSaveScenarioModal) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "isOpenSaveScenarioModal",
    data: isOpenSaveScenarioModal
  };
}

export function updateIsSavingScenario(id, isSavingScenario) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "isSavingScenario",
    data: isSavingScenario
  };
}

export function updateIsChangeFocusColumns(id, isChangeFocusColumns) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "isChangeFocusColumns",
    data: isChangeFocusColumns
  };
}

export function updateIsChangeFocusColumnsByIndex(id, index, val) {
  return (dispatch, getState) => {
    const isChangeFocusColumns = getIsChangeFocusColumns(getState(), id);
    const update = {
      ...isChangeFocusColumns,
      [index]: val
    };

    dispatch(updateIsChangeFocusColumns(id, update));
  };
}

export function updateFocusColumns(id, focusColumns) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "focusColumns",
    data: focusColumns
  };
}

export function updateFocusColumnsByIndex(id, index, val) {
  return (dispatch, getState) => {
    const focusColumns = getFocusColumns(getState(), id);
    const update = {
      ...focusColumns,
      [index]: val
    };

    dispatch(updateFocusColumns(id, update));
  };
}

/*
export function simpleChangeOutcome(datasetId, outcome) {
  return async (dispatch, getState => {
    console.log("simpleChangeOutcome", datasetId, outcome);

    dispatch(init());
    dispatch(globalReducer.updateIsSkipChatGPTInit(true));
    dispatch(push("/next/new/new"));

    dispatch(updateIsAsking(true));

    const newChatMessage: Message = {
      user: "Aible",
      date: new Date(),
    };

    newChatMessage.userText = "Evaluating new Outcome: " + outcome?.label;
    dispatch(addMessageConversation(newChatMessage));

    const outcomeSuccess = outcome?.data?.[0]?.value;

    await dispatch(
      homeReducer.changeDatasetTarget(
        datasetId,
        outcome?.label,
      )
    );

    dispatch(waitForDatasetComplete(datasetId));
  }
}

export function waitForDatasetComplete(datasetId) {
  return async (dispatch, getState) => {
    const dataset = homeReducer.getDataset(getState(), datasetId);

    if(dataset?.status_name !== "DONE") {
      return setTimeout(() => dispatch(waitForDatasetComplete(datasetId)), 1500);
    } else {
      dispatch(addMessageConversation({
        user: "Aible",
        date: new Date(),
        userText: dataset?.outcome + " evaluation complete"
      }));

      return dispatch(simpleDataLeakageCheck(datasetId));
    }
  }
}
*/

export function updateIsLoadingSuggestedColumns(id, isLoadingSuggestedColumns) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "isLoadingSuggestedColumns",
    data: isLoadingSuggestedColumns
  };
}

export function updateSuggestedColumns(id, suggestedColumns) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "suggestedColumns",
    data: suggestedColumns
  };
}

export function updateIsDataLeakageCheck(id, isDataLeakageCheck) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "isDataLeakageCheck",
    data: isDataLeakageCheck
  };
}

export function updateDataLeakageMessage(id, dataLeakageMessage) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "dataLeakageMessage",
    data: dataLeakageMessage
  };
}

export function updateSimpleFlowStep(id, simpleFlowStep) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "simpleFlowStep",
    data: simpleFlowStep
  };
}

export function updateSimpleFlowStepDisplay(id, simpleFlowStepDisplay) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "simpleFlowStepDisplay",
    data: simpleFlowStepDisplay
  };
}

export function updateDisableChatAutosave(id, disableChatAutosave) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "disableChatAutosave",
    data: disableChatAutosave
  };
}

export function updateForecastPeriods(id, forecastPeriods) {
  let retForecastPeriods = forecastPeriods;

  if (isNaN(Number(forecastPeriods))) {
    retForecastPeriods = DEFAULT_FORECAST_PERIODS;
  }

  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "forecastPeriods",
    data: retForecastPeriods
  };
}

export function suggestedColumnsCheck(nextId, datasetId) {
  return async (dispatch, getState) => {
    dispatch(updateIsLoadingSuggestedColumns(nextId, true));
    const suggestedColumns = await dispatch(chatGPTReducer.askLLMForDatasetOutcomes(datasetId));
    dispatch(updateSuggestedColumns(nextId, suggestedColumns?.kpi_columns));
    dispatch(updateIsLoadingSuggestedColumns(nextId, false));
    return Promise.resolve();
  };
}

export function dataLeakageCheckWaiter(nextId, datasetId, retries = 0, skipStepUpdate = false) {
  return (dispatch, getState) => {
    const dataset = homeReducer.getDataset(getState(), datasetId);
    const leakage = dataset?.fields[dataset?.outcome]?.leakage_info;
    if (dataset?.status_name === "ERROR" || retries >= 3) {
      toast("There was an error evaluating the selected KPI.", {
        type: toast.TYPE.ERROR,
        position: toast.POSITION.TOP_CENTER,
        autoClose: 7500
      });
      return Promise.resolve();
    }
    if (!leakage) {
      let newRetries = retries;
      if (dataset?.status_name !== "RUNNING") {
        newRetries = retries + 1;
      }
      return delay(5000).then(() => dispatch(dataLeakageCheckWaiter(nextId, datasetId, newRetries)));
    }
    if (!skipStepUpdate) {
      dispatch(updateSimpleFlowStep(nextId, "INSIGHT_CHECK"));
    }
    dispatch(updateSimpleFlowStepDisplay(nextId, "INSIGHT_CHECK"));
    return dispatch(simpleDataLeakageCheck(nextId, datasetId));
  };
}

export function simpleDataLeakageCheck(nextId, datasetId) {
  return async (dispatch, getState) => {
    const dataset = homeReducer.getDataset(getState(), datasetId);

    const leakageInfo = JSON.stringify({
      target: dataset?.outcome,
      leakage_info: dataset?.fields[dataset?.outcome]?.leakage_info
    });

    const sPrompt = chatGPTReducer.getLeakageCheckSystemPrompt(getState());

    let leakageJSON = [];
    let leakageMessages = [];

    dispatch(updateIsDataLeakageCheck(nextId, true));

    try {
      leakageMessages.push({ role: "system", content: sPrompt });
      leakageMessages.push({ role: "user", content: leakageInfo });

      const leakageCompleteResponse = await dispatch(
        chatGPTReducer.doCompletionDefault({
          messages: leakageMessages
        })
      );

      console.log("complete response", leakageCompleteResponse);

      const leakageComplete = getResponseContent(leakageCompleteResponse) ?? "";
      const leakageCompleteFix = leakageComplete.replace("```json", "").replace("```", "");
      leakageJSON = JSON.parse(leakageCompleteFix);

      console.log("Response JSON", leakageJSON, leakageMessages);
    } catch (e) {
      console.log("Leakage check error", e);
    }

    dispatch(
      updateDataLeakageMessage(nextId, {
        date: new Date(),
        userText: "Insight quality check (Remove problematic predictors)",
        leakageJSON: leakageJSON,
        datasetId: datasetId
      })
    );

    dispatch(updateIsDataLeakageCheck(nextId, false));

    if (!leakageJSON?.length) {
      dispatch(updateSimpleFlowStep(nextId, "DONE"));
      dispatch(updateSimpleFlowStepDisplay(nextId, "DONE"));

      dispatch(updateSimpleFlowStep(nextId, "EXPLORE"));

      const chatType = chatGPTReducer.getChatType(getState());
      if (chatType !== "AIBLE") {
        dispatch(chatGPTReducer.selectBlueprint(chatGPTReducer.CHATAIBLE_BLUEPRINTS.CHATAIBLE_ANALYTICS.id));
      }
      dispatch(updateSimpleFlowStepDisplay("EXPLORE"));
    }
  };
}

export function updateSearchChart(id, hex, node) {
  return (dispatch, getState) => {
    const hexMap = getHexMap(getState(), id);

    let fNode = undefined;

    Object.keys(hexMap).forEach((hKey) => {
      const foundNode = hexMap[hKey].find((n) => n?.chart?.title === node?.chart?.title);

      if (foundNode) {
        fNode = foundNode;
      }
    });

    if (fNode && fNode.x && fNode.y) {
      centerHex(fNode);
    }

    return dispatch(updateSelectedChart(id, hex, node));
  };
}

export function getNodeByTitle(state, id, title) {
  const hexMap = getHexMap(state, id);

  let node = undefined;

  Object.keys(hexMap).forEach((hKey) => {
    const nodes = hexMap[hKey];

    const foundNode = nodes.find((n) => n?.chart?.title === title);

    if (foundNode) {
      node = foundNode;
    }
  });

  return node;
}

export function checkAndSetDateField(datasetId, runId) {
  return (dispatch, getState) => {
    const datasetRankedFields = homeReducer.getRankedFields(getState(), datasetId);

    const dateFieldOptions =
      datasetRankedFields !== undefined
        ? datasetRankedFields
            .filter((f) => f.type === "date")
            .map((f) => ({
              value: f.label,
              label: f.label
            }))
        : [];

    // set date field
    if (dateFieldOptions.length > 0) {
      const dateField = dateFieldOptions?.[0];
      const retDateField = dateField?.value;
      const comparisonOptions = setupReducer.getComparisonOptions(getState(), runId);

      const retComparisonOptions = {
        ...comparisonOptions,
        dateField: retDateField
      };

      if (dateField) {
        const dates = dateField?.data ?? [];
        const filteredDates = dates?.filter((d) => d?.value !== "{Missing}");

        const lastIndex = Math.max(0, filteredDates.length - 1);
        const secondLastIndex = Math.max(0, filteredDates.length - 2);

        const missingDateRange =
          !retComparisonOptions.referenceStart ||
          !retComparisonOptions.referenceEnd ||
          !retComparisonOptions.currentStart ||
          !retComparisonOptions.currentEnd;

        if (missingDateRange) {
          // If missing any dates, use the default state
          const dataset = homeReducer.getDataset(getState(), datasetId);
          const datasetTimeBucket = dataset?.options?.kpi_analysis?.time_bucket;

          const { refStart, refEnd, currStart, currEnd } = chatGPTReducer.getDefaultDateIndices(
            filteredDates,
            datasetTimeBucket
          );

          retComparisonOptions.referenceStart = filteredDates[refStart]?.value;
          retComparisonOptions.referenceEnd = filteredDates[refEnd]?.value;
          retComparisonOptions.currentStart = filteredDates[currStart]?.value;
          retComparisonOptions.currentEnd = filteredDates[currEnd]?.value;
        }
      }

      dispatch(setupReducer.updateComparisonOptions(runId, retComparisonOptions));
    }
  };
}

export function checkValidComparisonOptions(comparisonOptions, dates) {
  const newComparisonOptions = {
    ...comparisonOptions
  };
  const KEYS_TO_CHECK = ["referenceStart", "referenceEnd", "currentStart", "currentEnd"];
  const dateFormat = getTimeSeriesFrequencyFromDate(dates?.[0]);
  KEYS_TO_CHECK.forEach((k) => {
    const currValue = newComparisonOptions[k];
    const valFormat = getTimeSeriesFrequencyFromDate(currValue);
    if (valFormat !== dateFormat) {
      const retVal = dates?.find((d) => moment(d).isSameOrAfter(currValue));
      newComparisonOptions[k] = retVal;
    }
  });
  return newComparisonOptions;
}

export function openDataset(datasetId, outcomeValue) {
  return (dispatch, getState) => {
    dispatch(init("new", datasetId)).then((e) => {
      dispatch(globalReducer.updateIsSkipNextInit(true));
      dispatch(push("/next/" + datasetId + "/new"));

      const success = {
        ...outcomeValue?.value,
        label: outcomeValue?.value?.value
      };
      dispatch(setupReducer.updateSuccess("new", success));
      dispatch(updateDatasetSuccess("new", success));
    });
  };
}

export function openExploration(
  datasetId,
  outcomeValue,
  comparisonOptions,
  minimumValueCount,
  isChatGPT = false,
  allowSkipSecuritySettings = false,
  selectedBlueprint,
  skipRedirect = false,
  nextIdOverride = undefined,
  skipUpdateActiveTab = false,
  forceChatTab = false,
  skipAskIntro = false
) {
  return async (dispatch, getState) => {
    const nextId = nextIdOverride ?? "new";

    if (isEnabled("chat-aible-consumer") && !isEnabled("aible-explore") && !isEnabled("aible-optimize")) {
      isChatGPT = true;
    }

    let lookerSDK = loginReducer.getLookerAPIClient(getState());

    let isNotRedirected = false;
    if (
      !globalReducer.getIsGoogleMode(getState()) &&
      !(lookerSDK !== undefined || globalReducer.getIsTableauMode(getState()))
    ) {
      dispatch(globalReducer.updateIsSkipNextInit(true));
      isNotRedirected = true;
      if (!skipRedirect) {
        dispatch(push(`/next/${datasetId}/${nextId}`, skipAskIntro ? { skipAskIntro } : undefined));
      }
    }

    let timeout = 0;
    const isNotRedirectedCheck = () => {
      isNotRedirected = globalReducer.getIsSkipNextInit(getState());
      if (isNotRedirected && timeout < 24) {
        timeout++;
        return delay(500).then(() => isNotRedirectedCheck());
      }
      return Promise.resolve();
    };

    await isNotRedirectedCheck();

    if (!skipUpdateActiveTab) {
      dispatch({
        type: UPDATE_FIELD_VALUE,
        id: nextId,
        data: undefined,
        key: "activeTab"
      });
    }

    await dispatch(
      init(
        nextId,
        datasetId,
        undefined,
        undefined,
        undefined,
        isChatGPT,
        selectedBlueprint,
        undefined,
        undefined,
        true,
        undefined,
        forceChatTab,
        skipAskIntro
      )
    );

    const retComparisonOptions =
      comparisonOptions?.dateField === undefined || comparisonOptions?.currentStart === undefined
        ? undefined
        : comparisonOptions;

    if (retComparisonOptions?.dateField) {
      minimumValueCount = 0;
    }

    lookerSDK = loginReducer.getLookerAPIClient(getState());

    if (datasetId && datasetId !== "new") {
      const dataset = datasetReducer.getDataset(getState(), datasetId);
      const newLabel = `Exploring ${dataset?.outcome !== undefined ? dataset.outcome + " in " : ""}${dataset.label}`;
      dispatch(updateReportLabelAndContentGenerationCollection(nextId, newLabel));

      await dispatch(
        nextTransformReducer.createDefaultExplore(
          nextId,
          retComparisonOptions,
          true,
          minimumValueCount,
          isChatGPT,
          allowSkipSecuritySettings,
          false,
          skipAskIntro,
          selectedBlueprint
        )
      );
    }

    const defaultView = !isChatGPT && !comparisonOptions ? getExploreDefaultViewMode(getState()) : undefined;

    dispatch(globalReducer.updateIsSkipNextInit(true));
    if (globalReducer.getIsGoogleMode(getState())) {
      dispatch(push("/google/" + datasetId));
    } else if (lookerSDK !== undefined || globalReducer.getIsTableauMode(getState())) {
      dispatch(push(`/project_next/${nextId}`));
    } else {
      dispatch(globalReducer.updateIsSkipNextInit(undefined));
    }

    if (isChatGPT) {
      if (!skipUpdateActiveTab) {
        const chatApp = chatGPTReducer.getChatApp(getState());
        if (chatApp?.wizard?.startInDashboard === true) {
          await dispatch(updateActiveTab(nextId, "NLQ Dashboard"));
        } else {
          await dispatch(updateActiveTab(nextId, "CHATGPT"));
        }
      }
    } else if (comparisonOptions) {
      const blueprint = blueprintReducer.getBlueprint(getState(), selectedBlueprint);
      if (!skipUpdateActiveTab) {
        await dispatch(updateActiveTab(nextId, blueprint?.wizard?.appStartViewType ?? "DASHBOARD"));
      }

      if (chatGPTReducer.getChatType(getState()) !== "WHATS_CHANGED") {
        dispatch(chatGPTReducer.selectBlueprint(`CHATAIBLE_WHATS_CHANGED`));
        if (isEnabled("chat-aible")) {
          dispatch(chatGPTReducer.addNewChatMessage(true));
        }
      }
    } else {
      if (isEnabled("chat-aible")) {
        dispatch(chatGPTReducer.addNewChatMessage(true));
      }
      if (!skipUpdateActiveTab) {
        await dispatch(updateActiveTab(nextId, defaultView));
      }
    }

    const success = {
      ...outcomeValue?.value,
      label: outcomeValue?.value?.value
    };
    dispatch(setupReducer.updateSuccess(nextId, success));
    return dispatch(updateDatasetSuccess(nextId, success));
  };
}

export function initOpenChat(
  datasetId,
  prompt,
  skipQuestion = false,
  chatTypeOverride,
  comparisonOptions,
  skipIntroMessage = false,
  skipSecurityConfirm = false,
  skipAutoSave = false,
  skipRedirect = false
) {
  return async (dispatch, getState) => {
    dispatch(globalReducer.updateIsSkipChatGPTInit(true));
    dispatch(chatGPTReducer.updateIsAsking(true));
    const chatType = chatTypeOverride ?? chatGPTReducer.getChatType(getState());
    const initResponse = await dispatch(
      openExploration(
        datasetId,
        undefined,
        comparisonOptions,
        comparisonOptions ? 0 : undefined,
        true,
        undefined,
        undefined,
        skipRedirect
      )
    );
    if (!skipIntroMessage) {
      dispatch(chatGPTReducer.addNewChatMessage());
    }
    if (chatType === "SQL") {
      await dispatch(
        chatGPTReducer.askFirstFromDatasetWaiter(datasetId, {
          prompt,
          chatTypeOverride: "SQL",
          skipSecurityConfirm,
          skipAutoSave
        })
      );
    } else if (comparisonOptions || chatType === "WHATS_CHANGED") {
      await dispatch(
        chatGPTReducer.askFirstFromDatasetWaiter(datasetId, {
          prompt,
          chatTypeOverride: "WHATS_CHANGED",
          skipSecurityConfirm,
          skipAutoSave
        })
      );
    } else if (skipQuestion !== true) {
      await dispatch(
        chatGPTReducer.askFirstFromDatasetWaiter(datasetId, {
          prompt,
          skipSecurityConfirm,
          skipAutoSave
        })
      );
    } else {
      dispatch(updateDatasetId("new", datasetId));
      await dispatch(homeReducer.fetchDataset(datasetId, undefined, true));
      dispatch(chatGPTReducer.updateIsAsking(false));
    }

    return initResponse;
  };
}

export function initSimpleAnalyticsChat(datasetId, nextSearchOptionsOverride = undefined, options = {}) {
  return async (dispatch, getState) => {
    const { comparisonOptions, skipQuestion, skipIntroMessage, skipRedirect, skipSecurityConfirm, skipAutoSave } =
      options;

    dispatch(globalReducer.updateIsSkipChatGPTInit(true));
    dispatch(chatGPTReducer.updateIsAsking(true));

    const initResponse = await dispatch(
      openExploration(
        datasetId,
        undefined,
        comparisonOptions,
        comparisonOptions ? 0 : undefined,
        true,
        undefined,
        undefined,
        skipRedirect,
        undefined,
        undefined,
        undefined,
        true
      )
    );

    const nextId = getCurrentNextId(getState()) ?? "new";
    if (nextSearchOptionsOverride !== undefined && nextSearchOptionsOverride.length) {
      dispatch(updateSearchOptions(nextId, nextSearchOptionsOverride));
    }

    if (!skipIntroMessage) {
      dispatch(chatGPTReducer.addNewChatMessage());
    }

    if (skipQuestion !== true) {
      await dispatch(
        chatGPTReducer.askFirstFromDatasetWaiter(datasetId, {
          prompt,
          skipSecurityConfirm,
          skipAutoSave,
          isSimpleAgentAnalytics: true
        })
      );
    } else {
      dispatch(updateDatasetId("new", datasetId));
      await dispatch(homeReducer.fetchDataset(datasetId, undefined, true));
      dispatch(chatGPTReducer.updateIsAsking(false));
    }

    return initResponse;
  };
}

export function initNextChatGPT(datasetId) {
  return (dispatch, getState) => {
    const id = "DATASET_" + datasetId;

    const retNext = { ...initialNext, datasetId: datasetId };

    const rSetup = setupReducer.getSetup(getState(), id);

    if (rSetup?.blueprintId) {
      const blueprint = blueprintReducer.getBlueprint(getState(), rSetup.blueprintId);
      if (blueprint?.name) retNext.reportLabel = blueprint.name;
    } else {
      const dataset = datasetReducer.getDataset(getState(), datasetId);
      if (dataset?.name) retNext.reportLabel = dataset.name;
    }

    dispatch(updateNext(id, retNext));

    dispatch(updateIsSavingReport(id, false));

    return dispatch(updateGridType(id, "Reduced", true));
  };
}

export function initNextDashboard(oId, datasetId) {
  return (dispatch, getState) => {
    const id = "temp_" + datasetId;

    const retNext = { ...initialNext, datasetId: datasetId };

    const rSetup = setupReducer.getSetup(getState(), id);

    if (rSetup?.blueprintId) {
      const blueprint = blueprintReducer.getBlueprint(getState(), rSetup.blueprintId);
      if (blueprint?.name) retNext.reportLabel = blueprint.name;
    } else {
      const dataset = datasetReducer.getDataset(getState(), datasetId);
      if (dataset?.name) retNext.reportLabel = dataset.name;
    }

    dispatch(updateNext(id, retNext));

    dispatch(updateGridType(id, "Reduced", true));

    dispatch(updateTempDatasetId(oId, datasetId));
  };
}

export function updateTempDatasetId(id, datasetId) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "tempDatasetId",
    data: datasetId
  };
}

export function openDashboard(datasetId, outcomeValue) {
  return (dispatch, getState) => {
    return dispatch(init("new", datasetId)).then((e) => {
      dispatch(globalReducer.updateIsSkipNextInit(true));

      dispatch(push("/next/" + datasetId + "/new"));
      dispatch(updateActiveTab("new", "DASHBOARD"));

      const success = {
        ...outcomeValue?.value,
        label: outcomeValue?.value?.value
      };
      dispatch(setupReducer.updateSuccess("new", success));
      dispatch(updateDatasetSuccess("new", success));
    });
  };
}

export function openChatAible(nextId, messageId) {
  return (dispatch, getState) => {
    return dispatch(init(nextId)).then((e) => {
      dispatch(globalReducer.updateIsSkipNextInit(true));

      dispatch(push("/chataible/" + nextId));
      const chatApp = chatGPTReducer.getChatApp(getState());
      if (chatApp?.wizard?.startInDashboard === true) {
        dispatch(updateActiveTab(nextId, "NLQ Dashboard"));
      } else {
        dispatch(updateActiveTab(nextId, "CHATGPT"));
      }
      return Promise.resolve();
    });
  };
}

export function openCreateModels(datasetId, outcomeValue, comparisonOptions) {
  return (dispatch, getState) => {
    dispatch(globalReducer.updateIsSkipNextInit(true));
    let isNotRedirected = true;
    dispatch(push("/next/" + datasetId + "/new"));

    let timeout = 0;
    const isNotRedirectedCheck = () => {
      isNotRedirected = globalReducer.getIsSkipNextInit(getState());
      if (isNotRedirected && timeout < 24) {
        timeout++;
        return delay(500).then(() => isNotRedirectedCheck());
      }
      return Promise.resolve();
    };

    return isNotRedirectedCheck().then(() => {
      return dispatch(init("new", datasetId)).then((e) => {
        const retComparisonOptions =
          comparisonOptions?.dateField === undefined || comparisonOptions?.currentStart === undefined
            ? undefined
            : comparisonOptions;
        const dataset = homeReducer.getDataset(getState(), datasetId);
        const outcome = dataset?.outcome;
        const outcomeValues = dataset?.fields?.[outcome]?.data;
        const datasetSuccess = outcomeValues?.find((v) => v.value === outcomeValue?.value);
        const success = datasetSuccess
          ? {
              ...datasetSuccess,
              label: datasetSuccess.value
            }
          : {
              ...outcomeValue?.value,
              label: outcomeValue?.value?.value
            };
        dispatch(nextTransformReducer.createDefaultModels("new", datasetId, success, retComparisonOptions));

        dispatch(chatGPTReducer.selectBlueprint("CHATAIBLE_ANALYTICS"));
        dispatch(chatGPTReducer.addNewChatMessage());

        dispatch(updateActiveTab("new", "MODELS"));
      });
    });
  };
}

export function handleMuscleClick(id, field) {
  return (dispatch, getState) => {
    const searchOption = {
      field: field,
      label: field,
      value: field
    };

    dispatch(handleSearchInsights(id, field === undefined ? [] : [searchOption]));
    dispatch(updateIsHideSearch(id, field === undefined));

    return Promise.resolve();
  };
}

export function handleChartLink(id, chart) {
  return (dispatch, getState) => {
    /*
    filterField: "Channel"
    filterValue: "Digital Marketing"
    label: "Channel: Digital Marketing"
    max: undefined
    min: undefined
    score: 1
    value: "Channel: Digital Marketing"
    */

    /*
    Old: Adds to search

    const field = chart?.metadata?.properties?.[0]?.column;
    const filterField = chart?.metadata?.properties?.[1]?.column;
    const filterValue = chart?.metadata?.properties?.[1]?.value;
    const label =
      filterField && filterValue ? filterField + ": " + filterValue : field;

    let searchOption =
      filterField && filterValue
        ? {
            filterField,
            filterValue,
            label,
            value: label,
          }
        : { field, label, value: label };

    dispatch(handleSearchInsights(id, [searchOption]));
    dispatch(updateIsHideSearch(id, false));

    return Promise.resolve();
    */

    const isInReport = getIsInReport(getState(), id, chart);

    if (isInReport) {
      return dispatch(scrollReportByTitle(id, { chart: { title: chart?.narrative?.title } }));
    } else {
      const nChart = getInsightFromMetadata(getState(), id, chart?.metadata, false);

      const rNode = refreshHexNode(getState(), id, nChart);

      let node = {
        chart: rNode,
        fields: getFieldsFromChart(getState(), id, rNode),
        isSearch: true
      };

      const hexMap = getHexMap(getState(), id);

      const fKey =
        hexMap === undefined
          ? undefined
          : Object.keys(hexMap).find((hKey) => {
              const firstNode = hexMap[hKey]?.[0];

              if (
                firstNode?.fields?.[0]?.label === node?.fields?.[0]?.label ||
                firstNode?.fields?.[0]?.label === node?.fields?.[1]?.label
              ) {
                node.x = firstNode.x;
                node.y = firstNode.y;
              }
            });

      return dispatch(updateSelectedChart(id, node, node));
    }
  };
}

export function addToDo(id, node) {
  return (dispatch, getState) => {
    dispatch(updatePinnedHex(id, node, node, true, true));
  };
}

export function deleteFeedback(id, node, edits) {
  return (dispatch, getState) => {
    if (node?.type === "exploreAssign") {
      dispatch(editNodeAssign(id, node?.id, edits, node?.nIndex, true));
    } else if (node?.type === "exploreComment") {
      dispatch(editComment(id, node?.id, edits, node?.nIndex, true));

      //Hacky way to see if using new task backend system
    } else if (node?.assigned_to !== undefined) {
      dispatch(nextModelsReducer.deleteTask(id, node));
    } else {
      dispatch(nextModelsReducer.editComment(id, node?.id, edits, node?.nIndex, true));
    }

    return Promise.resolve();
  };
}

export function editFeedback(id, node, edits) {
  return (dispatch, getState) => {
    if (node?.type === "exploreAssign") {
      dispatch(editNodeAssign(id, node?.id, edits, node?.nIndex));
    } else if (node?.type === "exploreComment") {
      dispatch(editComment(id, node?.id, edits, node?.nIndex));
    } else if (node?.type === "modelsAssign") {
      dispatch(nextModelsReducer.editNodeAssign(id, node?.id, edits, node?.nIndex));
    } else {
      dispatch(nextModelsReducer.editComment(id, node?.id, edits, node?.nIndex));
    }

    return Promise.resolve();
  };
}

export function editNodeAssign(id, nodeId, todoEdits, tIndex, isDelete = false) {
  return (dispatch, getState) => {
    let nodeAsssign = { ...getNodeAssign(getState(), id) };

    if (nodeAsssign?.[nodeId]?.[tIndex] !== undefined) {
      if (isDelete === true) {
        nodeAsssign[nodeId].splice(tIndex, 1);
      } else {
        nodeAsssign[nodeId][tIndex] = {
          ...nodeAsssign[nodeId][tIndex],
          ...todoEdits
        };
      }
    }

    dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: nodeAsssign,
      key: "nodeAsssign"
    });

    return dispatch(nextModelsReducer.updateIsFixUpdate(id, !nextModelsReducer.getIsFixUpdate(getState(), id)));
  };
}

export function editComment(id, nodeId, commentEdits, tIndex, isDelete = false) {
  return (dispatch, getState) => {
    let comments = { ...getComments(getState(), id) };

    if (comments?.[nodeId]?.[tIndex] !== undefined) {
      if (isDelete === true) {
        comments[nodeId].splice(tIndex, 1);
      } else {
        comments[nodeId][tIndex] = {
          ...comments[nodeId][tIndex],
          ...commentEdits
        };
      }
    }

    dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: comments,
      key: "comments"
    });

    return dispatch(nextModelsReducer.updateIsFixUpdate(id, !nextModelsReducer.getIsFixUpdate(getState(), id)));
  };
}

export function updateComment(id, node, comment) {
  return (dispatch, getState) => {
    let comments = { ...getComments(getState(), id) };

    if (comments?.[node?.id] === undefined) {
      comments[node?.id] = [];
    }

    comments[node?.id].push({
      author: loginReducer.getUserName(getState()),
      title: comment?.node?.text,
      text: comment?.textBody,
      date: new Date(),
      id: comment?.node?.id,
      type: "exploreComment"
    });

    return dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: comments,
      key: "comments"
    });
  };
}

export function updateNodeAssign(id, node, todo) {
  return (dispatch, getState) => {
    let nodeAsssign = { ...getNodeAssign(getState(), id) };

    if (nodeAsssign?.[node?.id] === undefined) {
      nodeAsssign[node?.id] = [];
    }

    const datasetId = getDatasetId(getState(), todo?.nextId);

    nodeAsssign[node?.id].push({
      author: todo?.assignee,
      title: todo?.node?.text,
      metadata: todo?.node?.chart?.metadata,
      datasetId: datasetId,
      text: todo?.textBody,
      date: new Date(),
      id: todo?.node?.id,
      type: "exploreAssign"
    });

    dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: nodeAsssign,
      key: "nodeAsssign"
    });

    const exploreProjectId = getExploreProjectId(getState(), id);

    if (exploreProjectId === undefined) {
      dispatch(projectReducer.createEmptyProject(id)).then((project) => {
        dispatch(updateExploreProjectId(id, project?.id));
        return dispatch(saveNext(id, "", false)).then((rNextId) => {
          return dispatch(
            projectReducer.createSegmentTask(
              project?.segments?.[0]?.id,
              todo?.assigneeId,
              "EXPLORE_CHART",
              todo?.node?.text,
              undefined,
              todo?.textBody,
              getMetadataKey(getState(), rNextId, todo?.node)
            )
          );
        });
      });
    } else {
      const project = projectReducer.getProject(getState(), exploreProjectId);
      dispatch(
        projectReducer.createSegmentTask(
          project?.segments?.[0]?.id,
          todo?.assigneeId,
          "EXPLORE_CHART",
          todo?.node?.text,
          undefined,
          todo?.textBody,
          getMetadataKey(getState(), id, todo?.node)
        )
      );

      return dispatch(saveNext(id, "", false));
    }
  };
}

export function getMetadataKey(state, nextId, node) {
  return {
    metadata: node?.chart?.metadata,
    nextId: nextId,
    datasetId: getDatasetId(state, nextId)
  };
}

export function getIsSameChart(c1, c2) {
  return c1?.chart?.narrative?.title && c1?.chart?.narrative?.title === c2?.chart?.narrative?.title;
}

export function updateSelectedChart(id, hex, node) {
  return (dispatch, getState) => {
    const selChart = getSelectedChart(getState(), id);

    if (getIsSameChart(selChart, node)) {
      return Promise.resolve();
    }

    const isReplay = getIsReplay(getState(), id);

    isReplay !== true &&
      dispatch(
        addSavedAction(id, {
          type: "UPDATE_SELECTED_CHART",
          hex: hex,
          node: stripNodeOfData(node),
          isVisible: node !== undefined ? true : false
        })
      );

    dispatch(setHasViewed(id, node, true));

    const hexMap = getHexMap(getState(), id);

    let foundNode = undefined;
    let foundHex = undefined;
    Object.keys(hexMap).forEach((k) => {
      const nodes = hexMap[k];

      if (foundNode === undefined) {
        foundNode = nodes.find((n) => n?.chart?.title === node?.chart?.title);
        if (foundNode !== undefined) {
          foundHex = k;
        }
      }
    });

    const selectedHex = getSelectedHex(getState(), id);
    const selectedChart = getSelectedChart(getState(), id);

    if (
      selectedHex?.chart?.title &&
      selectedChart?.chart?.title &&
      selectedHex?.chart?.title === selectedChart?.chart?.title &&
      selectedHex?.chart?.metadata?.type === selectedChart?.chart?.metadata?.type &&
      node === undefined
    ) {
      return dispatch(resetActions(id));
    }

    let retHex = node?.isTask ? foundNode : hex;
    let retNode = node?.isTask ? foundNode : node;

    if (retHex === undefined || retNode === undefined) {
      return dispatch({
        type: UPDATE_FIELD_VALUE,
        id: id,
        data: undefined,
        key: "selectedChart"
      });
    }

    dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: { ...retNode, hKey: retHex.x + "_" + retHex.y },
      key: "selectedChart"
    });

    const hKey = retHex.x + "_" + retHex.y;

    return setTimeout(() => {
      dispatch(scrollReportByTitle(id, node));
    }, 10);
  };
}

export function updatePinnedHexForce(id, pinnedHex, saveReplay) {
  return (dispatch, getState) => {
    saveReplay === true &&
      dispatch(
        addSavedAction(id, {
          type: "UPDATE_PINNED_HEX_FORCE",
          pinnedHex: pinnedHex,
          isVisible: false,
          isInstant: true
        })
      );

    return dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: pinnedHex,
      key: "pinnedHex"
    });
  };
}

export function updateSelectionDirection(
  id,
  selectionDirection,
  saveReplay = true,
  isChartUpdate = false,
  isList = false
) {
  return (dispatch, getState) => {
    //dispatch(resetPinnedHex(id));

    const oSelectionDirection = getSelectionDirection(getState(), id);

    if (
      selectionDirection &&
      (oSelectionDirection === undefined || oSelectionDirection.type !== selectionDirection.type)
    ) {
      saveReplay === true &&
        dispatch(
          addSavedAction(id, {
            type: "UPDATE_SELECTION_DIRECTION",
            selectionDirection: selectionDirection
          })
        );
    }

    if (selectionDirection !== undefined) {
      const actionHexMap = getActionHexMap(getState(), id);
      const selectedHex = { ...getSelectedHex(getState(), id) };

      dispatch({
        type: UPDATE_FIELD_VALUE,
        id: id,
        data: undefined,
        key: "selectedChart"
      });

      const oSelectionDirection = getSelectionDirection(getState(), id);
      if (oSelectionDirection && oSelectionDirection.type === selectionDirection.type && isChartUpdate === false) {
        const pinnedHex = getPinnedHex(getState(), id);

        dispatch(resetActions(id, undefined, saveReplay, true));

        Object.keys(pinnedHex).length > 0 && dispatch(updatePinnedHexForce(id, pinnedHex, saveReplay));

        return dispatch(updateSelectedHex(id, selectedHex, selectedHex, undefined, saveReplay, true));
      }

      let retActionHexMap = {
        [selectionDirection.x + "_" + selectionDirection.y]: {
          ...actionHexMap[selectionDirection.x + "_" + selectionDirection.y],
          isAnimate: false
        }
      };

      const selectedField =
        selectedHex && selectedHex.fields && selectedHex.fields[0] ? selectedHex.fields?.[0]?.label : "";

      const hexFields = selectedHex ? selectedHex.fields : undefined;

      let type = "Descriptive";
      let field = selectedField;
      let filters = {};
      let filterField = undefined;

      switch (selectionDirection.type) {
        case HEXAGON_NODES.SECOND_VARIABLE:
          if (hexFields && hexFields[1]) {
            field = hexFields[1].label;
          }
          break;

        case HEXAGON_NODES.DRILL_IN_CLUSTER:
          filterField = field;
          field = undefined;
          break;

        case HEXAGON_NODES.STAT_ASSOC:
          type = "Correlation";
          break;

        case HEXAGON_NODES.VOTING:
          type = "ModelDriver";
          break;
      }

      const MAX_SELECTION_DIRECTION_CHARTS = 25;
      const options = { limit: MAX_SELECTION_DIRECTION_CHARTS };

      let nextCharts = getRelatedInsights(getState(), id, field, filters, filterField, type, options);

      if (selectionDirection?.type === HEXAGON_NODES.POPULAR) {
        nextCharts = getPopularCharts(getState(), id);
      }

      if (selectionDirection?.type === HEXAGON_NODES.VOTING) {
        //nextCharts = getVotingCharts(getState(), id);
      }

      /*
      const neighbors = getDoubleNeighborLocation(
        getState(),
        id,
        selectionDirection.x,
        selectionDirection.y
      );
      */

      const neighbors = getNeighborLocation(selectionDirection.x, selectionDirection.y);

      const consultants = marketReducer.getConsultantsArr(getState());
      // How many Hexes do we show when drilling in on explore
      const viewIndex = getViewIndex(getState(), id);

      const HEX_LIMIT = 6 + viewIndex;

      const totalChartCount = nextCharts ? nextCharts.length : 0;

      dispatch(updateTotalChartCount(id, totalChartCount));

      if (isList === true) {
        dispatch(
          updateSelectionDirectionCharts(
            id,
            nextCharts.map((nextChart, i) => ({
              chart: { ...nextChart },
              fields: getFieldsFromChart(getState(), id, nextChart),
              fromType: {
                type:
                  selectionDirection?.type === HEXAGON_NODES.FIRST_VARIABLE
                    ? HEXAGON_NODES.DRILL_IN
                    : selectionDirection?.type === HEXAGON_NODES.SECOND_VARIABLE
                      ? HEXAGON_NODES.DRILL_IN_CLUSTER
                      : selectionDirection?.type
              },
              parentField: selectedHex.fields?.[0]?.label,
              parentSortScore: selectedHex?.sortScore,
              rIndex: i,
              totalChartCount: totalChartCount,
              parent: selectionDirection
            }))
          )
        );
      }

      let aIndex = viewIndex;
      for (const nKey of Object.keys(neighbors)) {
        const neighbor = neighbors[nKey];

        if (
          (selectionDirection.x !== neighbor.x || selectionDirection.y !== neighbor.y) &&
          aIndex < Math.min(HEX_LIMIT + 1, nextCharts.length)
        ) {
          retActionHexMap[neighbor.x + "_" + neighbor.y] = {
            type:
              selectionDirection?.type === HEXAGON_NODES.VOTING
                ? HEXAGON_NODES.VOTING_CHART
                : HEXAGON_NODES.SECOND_ORDER_CHART,
            fields:
              nextCharts && nextCharts.length > aIndex ? getFieldsFromChart(getState(), id, nextCharts[aIndex]) : {},
            aParent: selectionDirection,
            parent: selectionDirection,
            sParent: { x: selectedHex.x, y: selectedHex.y },
            chart: nextCharts && nextCharts.length > aIndex ? nextCharts[aIndex] : undefined,
            text: "",
            cText: undefined,
            fromType: { type: selectionDirection?.type },
            parentField: selectedHex.fields?.[0]?.label,
            rIndex: aIndex,
            isAnimate: true,
            shouldAnimateReturn: true
            // Remove Fake Consultant stuff
            // text:
            //   selectionDirection?.type === HEXAGON_NODES.EXPERT &&
            //   consultants &&
            //   consultants[aIndex]
            //     ? consultants[aIndex]?.title
            //     : "",
            // cText: consultants[aIndex].match,
          };

          aIndex++;
        }
      }

      dispatch(updateActionHexMap(id, retActionHexMap));
    }

    /*
      for (const nKey of Object.keys(actionHexMap).filter(
        (a) =>
          actionHexMap[a].type !== HEXAGON_NODES.TEXT &&
          actionHexMap[a].type !== HEXAGON_NODES.SECOND_ORDER_CHART
      )) {
        const node = actionHexMap[nKey];
        const hexFields = node.fields;

        const isSecondOrder = Object.keys(hexFields).length === 2;

        const charts = selectionDirection
          ? getChartsFromDirection(
              getState(),
              id,
              hexFields,
              selectionDirection.type
            )
          : undefined;

        const selectedField =
          selectedHex && selectedHex.fields && selectedHex.fields[0]
            ? selectedHex.fields[0].label
            : "";

        const nextCharts = getRelatedInsights(
          getState(),
          id,
          selectionDirection &&
            selectionDirection.type === HEXAGON_NODES.SECOND_VARIABLE &&
            hexFields &&
            hexFields[1]
            ? hexFields[1].label
            : selectedField
        );

        const neighbors = getNeighborLocation(node.x, node.y);

        if (aIndex === 0 && Object.keys(hexFields).length > 0) {
          actionHexMap[neighbors[aIndex].x + "_" + neighbors[aIndex].y] = {
            type: HEXAGON_NODES.SECOND_ORDER_CHART,
            fields:
              nextCharts && nextCharts.length > 0
                ? getFieldsFromChart(getState(), id, nextCharts[0])
                : {},
            parent: node,
            isShowLess: true,
            chart:
              nextCharts && nextCharts.length > 0 ? nextCharts[0] : undefined,
          };

          actionHexMap[
            neighbors[aIndex + 1].x + "_" + neighbors[aIndex + 1].y
          ] = {
            type: HEXAGON_NODES.SECOND_ORDER_CHART,
            fields:
              nextCharts && nextCharts.length > 1
                ? getFieldsFromChart(getState(), id, nextCharts[1])
                : {},
            parent: node,
            chart:
              nextCharts && nextCharts.length > 1 ? nextCharts[1] : undefined,
          };
        } else if (aIndex === 1 && Object.keys(hexFields).length > 0) {
          actionHexMap[neighbors[aIndex].x + "_" + neighbors[aIndex].y] = {
            type: HEXAGON_NODES.SECOND_ORDER_CHART,
            fields:
              nextCharts && nextCharts.length > 2
                ? getFieldsFromChart(getState(), id, nextCharts[2])
                : {},
            parent: node,
            chart:
              nextCharts && nextCharts.length > 2 ? nextCharts[2] : undefined,
          };

          actionHexMap[
            neighbors[aIndex + 1].x + "_" + neighbors[aIndex + 1].y
          ] = {
            type: HEXAGON_NODES.SECOND_ORDER_CHART,
            fields:
              nextCharts && nextCharts.length > 3
                ? getFieldsFromChart(getState(), id, nextCharts[3])
                : {},
            parent: node,
            chart:
              nextCharts && nextCharts.length > 3 ? nextCharts[3] : undefined,
          };
        } else if (aIndex < 4 && Object.keys(hexFields).length > 0) {
          actionHexMap[neighbors[aIndex].x + "_" + neighbors[aIndex].y] = {
            type: HEXAGON_NODES.SECOND_ORDER_CHART,
            fields:
              nextCharts && nextCharts.length > 4
                ? getFieldsFromChart(getState(), id, nextCharts[4])
                : {},
            parent: node,
            chart:
              nextCharts && nextCharts.length > 4 ? nextCharts[4] : undefined,
          };

          actionHexMap[
            neighbors[aIndex + 1].x + "_" + neighbors[aIndex + 1].y
          ] = {
            type: HEXAGON_NODES.SECOND_ORDER_CHART,
            fields:
              nextCharts && nextCharts.length > 5
                ? getFieldsFromChart(getState(), id, nextCharts[5])
                : {},
            parent: node,
            chart:
              nextCharts && nextCharts.length > 5 ? nextCharts[5] : undefined,
          };
        } else if (aIndex === 4 && Object.keys(hexFields).length > 0) {
          actionHexMap[neighbors[aIndex].x + "_" + neighbors[aIndex].y] = {
            type: nextCharts
              ? HEXAGON_NODES.SECOND_ORDER_CHART
              : HEXAGON_NODES.TEXT,
            fields:
              nextCharts && nextCharts.length > 6
                ? getFieldsFromChart(getState(), id, nextCharts[6])
                : {},
            parent: node,
            chart:
              nextCharts && nextCharts.length > 6 ? nextCharts[6] : undefined,
          };

          actionHexMap[
            neighbors[aIndex + 1].x + "_" + neighbors[aIndex + 1].y
          ] = {
            type: nextCharts
              ? HEXAGON_NODES.SECOND_ORDER_CHART
              : HEXAGON_NODES.TEXT,
            fields:
              nextCharts && nextCharts.length > 7
                ? getFieldsFromChart(getState(), id, nextCharts[7])
                : {},
            parent: node,
            chart:
              nextCharts && nextCharts.length > 7 ? nextCharts[7] : undefined,
            isShowMore: true,
          };
        }

        aIndex++;
      }

      console.log(actionHexMap);

      dispatch(updateActionHexMap(id, actionHexMap));
    }
    */

    return dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: selectionDirection,
      key: "selectionDirection"
    });
  };
}

export function getNeighborLocationEmpty(state, id, x, y, activeHexMap = {}) {
  const hexMap = getHexMap(state, id);

  const neighbors = getNeighborLocation(x, y);

  return Object.keys(neighbors)
    .map((nKey) => neighbors[nKey])
    .filter((hex) => hexMap[hex.x + "_" + hex.y] === undefined && activeHexMap[hex.x + "_" + hex.y] === undefined);
}

export function getNeighborLocation(x, y) {
  let secondItemY = 0;
  let thirdItemY = 1;
  let lastItemY = 0;

  if (x % 2 === 0) {
    secondItemY = -1;
    thirdItemY = 0;
    lastItemY = -1;
  }

  return {
    [0]: {
      x: x,
      y: y - 1
    },
    [1]: {
      x: x + 1,
      y: y + secondItemY
    },
    [2]: {
      x: x + 1,
      y: y + thirdItemY
    },
    [3]: {
      x: x,
      y: y + 1
    },
    [4]: {
      x: x - 1,
      y: y + thirdItemY
    },
    [5]: {
      x: x - 1,
      y: y + lastItemY
    }
  };
}

export function getDistanceFromNode(aX, aY, bX, bY) {
  return Math.abs(aX - bX) + Math.abs(aY - bY);
}

export function getDoubleNeighborLocation(state, id, x, y) {
  const hexMap = getHexMap(state, id);
  const neighbors = getNeighborLocation(x, y);

  let retNeighbors = [];

  for (const nKey of Object.keys(neighbors)) {
    const neighbor = neighbors[nKey];

    const nextNeighbors = getNeighborLocation(neighbor.x, neighbor.y);

    for (const iKey of Object.keys(nextNeighbors)) {
      const nextNeighbor = nextNeighbors[iKey];

      if (
        hexMap &&
        hexMap[nextNeighbor.x + "_" + nextNeighbor.y] === undefined &&
        retNeighbors.find((n) => n.x === nextNeighbor.x && n.y === nextNeighbor.y) === undefined
      ) {
        retNeighbors.push(nextNeighbor);
      }
    }
  }

  return retNeighbors.sort((a, b) => {
    if (getNeighborFromPosition(state, id, a.x, a.y, x, y) !== undefined) {
      return -1;
    } else if (getNeighborFromPosition(state, id, b.x, b.y, x, y) !== undefined) {
      return 1;
    }

    return getDistanceFromNode(a.x, a.y, x, y) > getDistanceFromNode(b.x, b.y, x, y)
      ? 1
      : getDistanceFromNode(a.x, a.y, x, y) < getDistanceFromNode(b.x, b.y, x, y)
        ? -1
        : 0;
  });
}

export function getTransformedField(state, id, field, datasetIdOverride) {
  const datasetId = datasetIdOverride ?? getDatasetId(state, id);

  const dataset = homeReducer.getDataset(state, datasetId);
  const rankedFields = homeReducer.getRankedFields(state, datasetId);

  const fIndex = rankedFields.findIndex((f) => f.label === field);

  if (fIndex === -1) {
    return undefined;
  }

  const f = dataset.fields[field];

  return {
    type: f.type,
    label: f.label,
    rank: fIndex,
    color: colors[fIndex % colors.length] ?? "gray"
  };
}

export function getFieldsFromChart(state, id, chart, datasetIdOverride) {
  let retFields = {};

  if (chart?.chart?.xAxis === undefined) {
    return {};
  }

  if (chart && chart.metadata && chart.metadata.properties) {
    if (chart.metadata.properties.length === 1) {
      retFields[0] = getTransformedField(state, id, chart.metadata.properties[0].column, datasetIdOverride);
    }

    if (chart.metadata.properties.length === 2) {
      retFields[0] = getTransformedField(state, id, chart.metadata.properties[0].column, datasetIdOverride);

      if (
        chart?.metadata?.properties?.[1]?.column &&
        chart?.metadata?.properties?.[1]?.column !== chart?.metadata?.properties?.[0]?.column
      ) {
        retFields[1] = getTransformedField(state, id, chart.metadata.properties[1].column, datasetIdOverride);
      }
    }

    return retFields;
  }

  const fField = getTransformedField(state, id, chart.chart.xAxis.label, datasetIdOverride);

  if (chart && chart.chart && chart.chart.yAxis && chart.chart.yAxis.label === "Association Score") {
    const rFields = chart.chart.xAxis.label.split(" and ");

    return rFields && rFields.length > 1
      ? {
          0: getTransformedField(state, id, rFields[0], datasetIdOverride),
          1: getTransformedField(state, id, rFields[1], datasetIdOverride)
        }
      : {};
  }

  if (chart && chart.chart && chart.chart.series && chart.chart.series.length === 1) {
    return {
      0: getTransformedField(state, id, chart.chart.xAxis.label, datasetIdOverride)
    };
  }

  const eStr = chart.chart.data.length > 0 ? chart.chart.data[0].label : undefined;
  const sFieldLabel = eStr ? eStr.substring(eStr.lastIndexOf("when") + 5, eStr.lastIndexOf(" is ")) : undefined;

  const sField = getTransformedField(state, id, sFieldLabel, datasetIdOverride);

  return { 0: fField, 1: sField };
}

export function getIsFaded(state, id, hex, mType = undefined) {
  const actionHexMap =
    mType === undefined
      ? getActionHexMap(state, id)
      : mType === "TRANSFORM"
        ? nextTransformReducer.getActionHexMap(state, id)
        : mType === "MODELS"
          ? nextModelsReducer.getActionHexMap(state, id)
          : getActionHexMap(state, id);
  const selectedHex = getSelectedHex(state, id);

  const hasActions = actionHexMap === undefined ? false : Object.keys(actionHexMap).length === 0 ? false : true;

  return selectedHex && selectedHex.x === hex.x && selectedHex.y === hex.y
    ? false
    : hasActions && actionHexMap[hex.x + "_" + hex.y] === undefined
      ? true
      : false;
}

function trim(str) {
  return str?.replace(/^\s+|\s+$/gm, "");
}

function rgbaToHex(rgba) {
  if (!rgba || rgba == "grey" || rgba == "gray") {
    rgba = "rgba(128, 128, 128, 1)";
  }

  var inParts = rgba.substring(rgba.indexOf("(")).split(","),
    r = parseInt(trim(inParts[0].substring(1)), 10),
    g = parseInt(trim(inParts[1]), 10),
    b = parseInt(trim(inParts[2]), 10),
    a = parseFloat(trim(inParts[3] ? inParts[3].substring(0, inParts[3].length - 1) : "1")).toFixed(2);
  var outParts = [
    r.toString(16),
    g.toString(16),
    b.toString(16),
    Math.round(a * 255)
      .toString(16)
      .substring(0, 2)
  ];

  // Pad single-digit output values
  outParts.forEach(function (part, i) {
    if (part.length === 1) {
      outParts[i] = "0" + part;
    }
  });

  return outParts.filter((o, i) => i < outParts.length - 1).join("");
}

function LightenColor(color, percent) {
  var num = parseInt(color, 16),
    amt = Math.round(2.55 * percent),
    R = (num >> 16) + amt,
    B = ((num >> 8) & 0x00ff) + amt,
    G = (num & 0x0000ff) + amt;

  return (
    0x1000000 +
    (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
    (B < 255 ? (B < 1 ? 0 : B) : 255) * 0x100 +
    (G < 255 ? (G < 1 ? 0 : G) : 255)
  )
    .toString(16)
    .slice(1);
}

export function exportToPowerpointProject(id) {
  return (dispatch, getState) => {
    const projectId = getProjectId(getState(), id);

    return dispatch(projectReducer.exportToPowerpoint(projectId));
  };
}

export function updateIsExportingLooker(id, isExportingLooker) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: isExportingLooker,
    key: "isExportingLooker"
  };
}

export function exportToLooker(id) {
  return (dispatch, getState) => {
    const datasetId = getDatasetId(getState(), id);
    const successValue = getDatasetSuccess(getState(), id)?.value;

    const datasetAccountId = homeReducer.getDatasetAccountId(getState(), datasetId);

    const account = accountsReducer.getAccount(getState(), datasetAccountId);

    const lookerURL =
      account?.configuration?.looker_export_url ??
      "https://aible.cloud.looker.com/extensions/aible_extension_google::aible/";

    const isLastSlash = lookerURL.charAt(lookerURL.length - 1) === "/";

    window.open(lookerURL + (isLastSlash ? "" : "/") + datasetId + "/" + successValue + "/" + account?.id);
  };
}

export function generateExplorationPowerpoint(id) {
  return (dispatch, getState) => {
    let pres = new pptxgen();

    let titleSlide = pres.addSlide();
    titleSlide.background = { color: "512f77" };
    titleSlide.addImage({
      path: aibleHelix,
      x: 0,
      y: 1.09,
      w: 10,
      h: 4.5,
      sizing: { type: "contain" }
    });
    titleSlide.addImage({
      path: aibleTransparentLogo,
      x: 0.9,
      y: 0.92,
      w: 1.87,
      h: 0.41,
      sizing: { type: "contain" }
    });
    titleSlide.addText("AI for Business Impact", {
      color: "FFFFFF",
      x: 0.78,
      y: 1.6
    });

    const charts = getPinnedHexList(getState(), id);

    const topDrivers =
      charts.length > 0
        ? charts
            .filter((node) => node.chart?.isSecondOrder === false)
            .sort((a, b) => a.chart?.scoreRank - b.chart?.scoreRank)
            .slice(0, 10)
        : [];
    if (false && topDrivers.length > 0) {
      let summarySlide = pres.addSlide();
      summarySlide.addText(`Exploration Summary`, {
        x: "0%",
        y: "0%",
        w: "100%",
        h: "15%",
        color: "FFFFFF",
        fill: { color: "512f77" },
        fontSize: 24,
        fontFace: "Raleway"
      });
      const topModelsData = [
        [
          {
            text: "Rank",
            options: { color: "ffffff", fill: { color: "512f77" } }
          },
          {
            text: "Model",
            options: { color: "ffffff", fill: { color: "512f77" } }
          }
        ]
      ];

      topDrivers.forEach((node, index) => {
        topModelsData.push([
          {
            text: index + 1,
            options: {
              color: "000000",
              fill: { color: "c7bbd3" },
              align: "right"
            }
          },
          {
            text: node.chart?.title,
            options: { fill: { color: "E6E6FC" } }
          }
        ]);
      });
      if (topModelsData.length > 0) {
        summarySlide.addText("Ranking Results", {
          x: 0.2,
          y: 1.07,
          h: 0.43,
          w: 3
        });

        summarySlide.addTable(topModelsData, {
          x: 0.3,
          y: 1.63,
          fontSize: 11,
          colW: [0.7, 4]
        });
      }
    }
    console.log("Saving PPT");

    let chartIndex = 1;
    for (const mChart of charts) {
      const s = {
        ...mChart,
        chart: {
          ...getInsightFromMetadata(getState(), id, mChart?.chart?.metadata, false)
        }
      };

      let slide = pres.addSlide();
      let textboxText = chartIndex + ". Driver Analysis: " + s.chart.title;
      chartIndex++;

      const chartType = s.chart.chart.series?.[0]?.type;

      const baseColor = chartType === "Line" ? s.chart.color : s?.fields[0] ? s?.fields[0].color : colors[0];

      const convertFirst = rgbaToHex(baseColor);
      const convertSecond = LightenColor(convertFirst, 30);

      const chartColors =
        chartType === "Line" && s.chart.chart.series !== undefined
          ? s.chart.chart.series.map((ser, i) =>
              i === 0 ? rgbaToHex(baseColor) : LightenColor(rgbaToHex(baseColor), i * 5)
            )
          : [convertFirst, convertSecond];

      const firstOrderColors = [convertFirst, convertFirst];
      const isSecondOrder = s.chart?.isSecondOrder;

      if (s.chart.metadata === undefined) {
        continue;
      }

      const chartData =
        chartType === "Line" && s.chart.chart.series !== undefined && s.chart.chart.series.length >= 1
          ? s.chart.chart.series.map((series, i) => ({
              name: series.label,
              values: s.chart.chart.data.map((d) => d?.[series.dataKey]),
              labels: s.chart.chart.data.map((d) => d?.name)
            }))
          : s.chart.metadata.properties.length === 2
            ? [
                {
                  name:
                    s.chart.metadata.properties[1].column +
                    " is " +
                    (s.chart.metadata.properties[1].value
                      ? s.chart.metadata.properties[1].value
                      : `${s.chart.metadata.properties[1].start} to ${s.chart.metadata.properties[1].end}`),
                  labels: s.chart.chart.data.map((d) => d.name),
                  values: s.chart.chart.data.map((d) => d.y)
                },
                {
                  name: s.chart.metadata.properties[1].column + " is all other",
                  labels: s.chart.chart.data.map((d) => d.otherLabel),
                  values: s.chart.chart.data.map((d) => d.otherY)
                }
              ]
            : [
                {
                  name: s.chart.metadata.properties[0].column + " is " + s.chart.metadata.properties[0].value,
                  labels: s.chart.chart.data.map((d) => d.name),
                  label: s.chart.chart.data.map((d) => d.name),
                  values: s.chart.chart.data.map((d) => d.y)
                }
              ];

      let textboxOpts = { x: 1, y: 1, color: "363636" };
      //slide.addText(textboxText, textboxOpts);
      slide.addText(textboxText, {
        x: "0%",
        y: "0%",
        w: "100%",
        h: "15%",
        color: "FFFFFF",
        fill: { color: "512f77" },
        fontSize: 24,
        fontFace: "Raleway"
      });

      slide.addChart(chartType === "Line" ? pres.ChartType.line : pres.ChartType.bar, chartData, {
        x: 0.5,
        y: 1,
        w: 9,
        h: 3.35,
        chartColors: isSecondOrder || chartType === "Line" ? chartColors : firstOrderColors,
        catAxisLabelFontFace: "Calibri",
        valAxisLabelFontFace: "Calibri",
        legendPos: "b",
        showLegend: isSecondOrder || chartType === "Line" ? true : false
      });

      slide.addText(s.chart.narrative.body, {
        x: 0.5,
        y: 4.17,
        w: 9,
        h: 1.35,
        color: "512f77",
        fontFace: "Raleway"
      });
    }
    let endSlide = pres.addSlide();
    endSlide.background = { color: "512f77" };
    endSlide.addImage({
      path: aibleSmallTransparentLogo,
      x: 8.8,
      y: 5.22,
      w: 1,
      h: 0.21,
      sizing: { type: "contain" }
    });
    endSlide.addImage({
      path: aibleCenterTransparentLogo,
      x: 3.5,
      y: 1.3,
      w: 3,
      h: 3,
      sizing: { type: "contain" }
    });
    const currYear = new Date().getFullYear();
    endSlide.addText(`© ${currYear ?? 2022}, Aible, Inc. All Rights Reserved`, {
      color: "FFFFFF",
      x: 3.8,
      y: 5.15,
      w: 2.4,
      h: 0.35,
      fontSize: 10
    });
    // 4. Save the Presentation
    pres.writeFile();
  };
}

export function saveAsPpt(id) {
  return (dispatch, getState) => {
    const hexMap = getHexMap(getState(), id);

    let rHexMap = [];

    Object.keys(hexMap).forEach((hKey) =>
      hexMap[hKey]
        .filter((node) => node && node.isPath && node?.chart?.metadata?.properties)
        .forEach((node) => rHexMap.push(node))
    );

    let pres = new pptxgen();

    console.log("Saving PPT");

    for (const s of rHexMap) {
      let slide = pres.addSlide();
      let textboxText = s.chart.title;

      const baseColor = s?.fields[0] ? s?.fields[0].color : colors[0];

      const convertFirst = rgbaToHex(baseColor);
      const convertSecond = LightenColor(convertFirst, 50);

      const chartColors = [convertFirst, convertSecond];

      const chartData =
        s.chart.metadata.properties.length === 2
          ? [
              {
                name: s.chart.metadata.properties[0].column + " is " + s.chart.metadata.properties[0].value,
                labels: s.chart.chart.data.map((d) => d.name),
                values: s.chart.chart.data.map((d) => d.y)
              },
              {
                name: s.chart.metadata.properties[0].column + " is all other",
                labels: s.chart.chart.data.map((d) => d.otherLabel),
                values: s.chart.chart.data.map((d) => d.otherY)
              }
            ]
          : [
              {
                name: s.chart.metadata.properties[0].column + " is " + s.chart.metadata.properties[0].value,
                labels: s.chart.chart.data.map((d) => d.name),
                values: s.chart.chart.data.map((d) => d.y)
              }
            ];

      let textboxOpts = { x: 1, y: 1, color: "363636" };
      slide.addText(textboxText, textboxOpts);
      slide.addChart(pres.ChartType.bar, chartData, {
        x: 1,
        y: 2,
        w: 8,
        h: 2,
        chartColors: chartColors
      });

      slide.addText(s.chart.narrative.body, { x: 1, y: 5, color: "363636" });
    }

    // 4. Save the Presentation
    pres.writeFile();
  };
}

export function addClickEffect(hex) {
  const aKey = hex?.x + "_" + hex?.y;

  const pHexTile =
    document.getElementById("hexTile_" + aKey + "_0") ||
    document.getElementById("hexTile_" + aKey + "_a") ||
    document.getElementById("hexTile_" + aKey + "_n");

  const hexGridInner = document.getElementById("hexGridInner");

  if (pHexTile && hexGridInner) {
    let d = document.createElement("div");
    d.className = "clickEffect";
    d.style.left = pHexTile.offsetLeft + pHexTile.offsetWidth / 2 + "px";
    d.style.top = pHexTile.offsetTop + pHexTile.offsetHeight / 2 + "px";
    hexGridInner.appendChild(d);

    d.addEventListener(
      "animationend",
      function () {
        d.parentElement.removeChild(d);
      }.bind(this)
    );
  }
}

export function addPinned(id, saveReplay = true) {
  return (dispatch, getState) => {
    const pinnedHex = getPinnedHex(getState(), id);

    if (pinnedHex && pinnedHex.length === 0) {
      return dispatch(resetActions(id, true, saveReplay));
    }

    saveReplay === true &&
      setTimeout(() => {
        dispatch(
          addSavedAction(id, {
            type: "ADD_PINNED",
            isVisible: false
          })
        );
      }, 500);

    const selectedHex = getSelectedHex(getState(), id);
    const selectionDirection = getSelectionDirection(getState(), id);
    const hexagonRadius = getHexagonRadius(getState(), id);

    let retHexMap = getHexMap(getState(), id);
    const pinnedHexList = getPinnedHexList(getState(), id);

    const comparisonOptions = getComparisonOptions(getState(), id);

    for (const node of pinnedHex) {
      const hex = { x: selectedHex.x, y: selectedHex.y };

      let rHex = comparisonOptions !== undefined ? node : node.parent ? node.parent : hex;

      // Don't place on muscle chart
      if (rHex.x === hexagonRadius && rHex.y === hexagonRadius) {
        rHex = hex;
      }

      const hexFields = { ...node.fields };
      const hLength = Object.keys(hexFields).length;

      const retHex = {
        ...rHex,
        type: node.type
          ? node.type
          : hLength === 1
            ? HEXAGON_NODES.FIRST_ORDER_CHART
            : hLength === 2
              ? HEXAGON_NODES.SECOND_ORDER_CHART
              : HEXAGON_NODES.NONE,
        fields: { ...hexFields },
        chart: node && node.chart ? node.chart : undefined,
        isPath: true,
        fromNode: hex.x !== hexagonRadius || hex.y !== hexagonRadius ? selectedHex : undefined,
        fromType:
          hex.x !== hexagonRadius || hex.y !== hexagonRadius
            ? selectionDirection
              ? selectionDirection
              : node && node.parent && node.parent.type
                ? { type: node.parent.type }
                : undefined
            : undefined,
        isAction: false,
        isAnimate: false,
        isAdded: true,
        isDirection: false,
        isFromActionMap: undefined,
        sortIndex: node?.sortIndex,
        sortScore: node?.aParent?.sortScore !== undefined ? node?.aParent.sortScore + 1 : 9999999,

        // Don't animate me on reset actions
        isNoAnimateReturn: true
      };

      const uKey = rHex.x + "_" + rHex.y;

      let foundNode = undefined;
      let foundIndex = undefined;
      if (retHexMap[uKey] !== undefined) {
        const nodes = retHexMap[uKey];

        nodes.forEach((node, i) => {
          if (node?.chart?.title === retHex?.chart?.title) {
            foundNode = node;
            foundIndex = i;
          }
        });
      }

      if (retHexMap[uKey] === undefined) {
        retHexMap[uKey] = [{ ...retHex, index: 0 }];
      } else if (foundNode !== undefined && foundIndex !== undefined) {
        retHexMap[uKey][foundIndex] = {
          ...retHexMap[uKey][foundIndex],
          isPath: true
        };
      } else {
        retHexMap[uKey].unshift({ ...retHex, index: retHexMap[uKey].length });
      }

      addClickEffect(rHex);

      //const parentKey = node?.parent?.x + "_" + node?.parent?.y;

      /*
      const parentKey = rHex?.x + "_" + rHex?.y;

      const parentNode =
        document.getElementById("hexTile_" + parentKey + "_a") ||
        document.getElementById("hexTile_" + parentKey + "_0") ||
        document.getElementById("hexTile_" + parentKey);

      const selectNode =
        document.getElementById("hexTile_" + node.x + "_" + node.y + "_a") ||
        document.getElementById("hexTile_" + node.x + "_" + node.y + "_0") ||
        document.getElementById("hexTile_" + node.x + "_" + node.y);

      const nActionHexMap = getActionHexMap(getState(), id);

      if (parentNode) {
        parentNode.hidden = true;
      }

      if (parentNode && selectNode) {
        selectNode.style.zIndex = 15;
        selectNode.style.left = parentNode.style.left;
        selectNode.style.top = parentNode.style.top;

        setTimeout(() => {
          parentNode.style.transform = "none";
          parentNode.hidden = false;
          selectNode.style.zIndex = 5;
        }, 400);
      }
      */

      if (
        node?.isTodo !== true &&
        !pinnedHexList.find((possiblePin) => possiblePin?.chart?.title === retHex?.chart?.title)
      ) {
        pinnedHexList.push(retHex);
      }
    }

    const isReplay = getIsReplay(getState(), id);

    dispatch(updateIsAnimateReturn(id, true));

    return setTimeout(
      () => {
        dispatch(updateHexMap(id, retHexMap));
        dispatch(updatePinnedHexForce(id, []));
        dispatch(updatePinnedHexList(id, pinnedHexList));
        return dispatch(resetActions(id, undefined, saveReplay, true));
      },
      isReplay ? 0 : 400
    );
  };
}

export function moveHex(id, fHex, tHex, rNode) {
  return (dispatch, getState) => {
    const isReplay = getIsReplay(getState(), id);

    // Don't allow moving to or from the center muscle node for now
    if ((fHex?.x === 8 && fHex?.y === 8) || (tHex?.x === 8 && tHex?.y === 8)) {
      return dispatch(updateDragHex(id, undefined));
    }

    isReplay !== true &&
      dispatch(
        addSavedAction(id, {
          type: "MOVE_HEX",
          fHex: fHex,
          tHex: tHex,
          rNode: stripNodeOfData(rNode),
          isVisible: true,
          isInstant: false
        })
      );

    dispatch(updateDragHex(id, undefined));

    const hexMap = { ...getHexMap(getState(), id) };

    const fNode = hexMap[fHex.x + "_" + fHex.y];

    const nodeProps = {
      parent: fHex,
      aParent: fHex,
      x: tHex.x,
      y: tHex.y,
      isSearch: false
    };

    const nNode = {
      ...rNode,
      ...nodeProps
    };

    if (fNode === undefined && rNode !== undefined) {
      if (hexMap[tHex.x + "_" + tHex.y] === undefined) {
        hexMap[tHex.x + "_" + tHex.y] = [{ ...nNode, index: 0 }];
      } else {
        hexMap[tHex.x + "_" + tHex.y].unshift({
          ...nNode,
          index: hexMap[tHex.x + "_" + tHex.y].length
        });
      }
    } else if (fNode !== undefined && fNode.length === 1) {
      delete hexMap[fHex.x + "_" + fHex.y];
    } else if (fNode !== undefined && fNode.length > 1) {
      hexMap[fHex.x + "_" + fHex.y] = fNode.slice(1, fNode.length);

      let nIndex = 0;
      for (let node of hexMap[fHex.x + "_" + fHex.y]) {
        node.index = nIndex;
        nIndex++;
      }
    }

    const retNode =
      fNode && fNode.length > 0
        ? {
            ...fNode[0],
            ...nodeProps
          }
        : undefined;

    if (retNode) {
      if (hexMap[tHex.x + "_" + tHex.y] === undefined) {
        hexMap[tHex.x + "_" + tHex.y] = [{ ...retNode, index: 0 }];
      } else {
        hexMap[tHex.x + "_" + tHex.y].unshift({
          ...retNode,
          index: hexMap[tHex.x + "_" + tHex.y].length
        });
      }
    }

    if (rNode?.isSearch && rNode?.aParent === undefined) {
      dispatch(updateNodeCompleted(id, rNode));
    }

    dispatch(updateLastMoveChart(id, rNode));
    return dispatch(updateHexMap(id, hexMap));
  };
}

export function getPopularCharts(state, id) {
  const datasetId = getDatasetId(state, id);

  const reports = reportReducer.getReportsArr(state);

  let chartCount = {};
  let charts = [];

  reports &&
    reports
      .filter((r) => r?.metadata?.datasetId === datasetId)
      .forEach((r) => {
        r?.metadata?.hexMap &&
          Object.keys(r.metadata.hexMap).forEach((hKey) => {
            const nodes = r.metadata.hexMap[hKey];
            nodes.forEach((node) => {
              if (node.isPath) {
                if (chartCount[node.chart.title] === undefined) {
                  chartCount[node.chart.title] = {
                    count: 1,
                    chart: node.chart
                  };
                } else {
                  chartCount[node.chart.title].count++;
                }
              }
            });
          });
      });

  return Object.keys(chartCount)
    .map((title) => ({
      ...chartCount[title].chart,
      popularCount: chartCount[title].count
    }))
    .sort((a, b) => b.popularCount - a.popularCount)
    .map((c, i) => ({ ...c, scoreRank: i }));
}

export function getVotingCharts(state, id) {
  const datasetId = getDatasetId(state, id);
  const rankedFields = homeReducer.getRankedFields(state, datasetId);

  let charts = [];

  let scoreRank = 0;
  for (const rankedField of rankedFields) {
    const index = rankedFields.indexOf(rankedField);

    charts.push({
      chart: {
        color: colors[index % colors.length]
      },
      color: colors[index % colors.length],
      column: rankedField,
      title: rankedField?.label + " Drivers",
      scoreRank: scoreRank
    });

    scoreRank++;
  }

  return charts;
}

export function stripNodeOfData(node) {
  if (node === undefined) {
    return node;
  }

  const { aParent, parent, ...retNode } = node;

  return retNode;
}

export function addSavedAction(id, action) {
  return (dispatch, getState) => {
    const replayIndex = getReplayIndex(getState(), id);

    let savedActions = [...getSavedActions(getState(), id)];
    const vActions = savedActions.filter((a) => a.isVisible !== false && a.isTodo !== true);

    if (action?.isStopAdvance !== true) {
      if (replayIndex !== vActions.length - 1) {
        dispatch(resetHex(id));
      } else if (action.isVisible !== false) {
        dispatch(updateReplayIndex(id, replayIndex + 1));
      }
    }

    savedActions.push(action);
    //savedActions.push({...action, isConsultantAction: true});
    dispatch(updateSavedActions(id, savedActions));
    if (isEnabled("next-autosave")) {
      dispatch(clearAutosave(id));
      const newTimeoutId = setTimeout(() => {
        dispatch(saveNext(id, "", false));
      }, 10000);
      dispatch(updateAutosaveId(id, newTimeoutId));
    }
    return Promise.resolve();
  };
}

export function resetHex(id) {
  return (dispatch, getState) => {
    const activeTab = getActiveTab(getState(), id);

    if (activeTab === "MODELS") {
      return dispatch(nextModelsReducer.resetHex(id));
    }

    const actions = getVisibleActions(getState(), id);
    const vActions = actions.filter((a) => a.isVisible !== false && a.isTodo !== true);

    dispatch(updateIsReplay(id, false));
    dispatch(updateReplayIndex(id, vActions.length));
    dispatch(resetActions(id, undefined, false));

    const beforeReplayHexMap = getBeforeReplayHexMap(getState(), id);

    if (beforeReplayHexMap) {
      dispatch(updateHexMap(id, beforeReplayHexMap));
    }

    return dispatch(updateBeforeReplayHexMap(id, undefined));
  };
}

export function getVisibleActionsBad(state, id) {
  const actions = [...getSavedActions(state, id)];

  let retActions = [];

  for (let i = 0; i < actions.length; i++) {
    const action = actions[i];

    if (action?.type === "UPDATE_SELECTED_HEX") {
      retActions.push({
        vAction: action,
        uActions: [actions[i + 1]]
      });
    }

    if (action?.type === "UPDATE_PINNED_HEX") {
      retActions.push({
        vAction: action,
        uActions: []
      });
    }

    if (action?.type === "ADD_PINNED") {
      retActions.push({
        vAction: action,
        uActions: [actions[i + 1]]
      });
    }
  }
}

export function getReplayInfo(state, id) {
  const activeTab = getActiveTab(state, id);

  return {
    visibleActions:
      activeTab === "MODELS"
        ? nextModelsReducer.getSavedActions(state, id)
        : activeTab === "EXPLORE"
          ? getVisibleActions(state, id)
          : [],
    replayIndex:
      activeTab === "MODELS"
        ? nextModelsReducer.getReplayIndex(state, id)
        : activeTab === "EXPLORE"
          ? getReplayIndex(state, id)
          : -1
  };
}

export function getVisibleActions(state, id, stopNode) {
  const actions = getSavedActions(state, id);

  return actions;
}

export function handleAction(id, action, stopAction) {
  return (dispatch, getState) => {
    if (getIsReplay(getState(), id) === false) {
      return;
    }

    try {
      if (action.type === "UPDATE_SELECTED_HEX") {
        dispatch(updateSelectedHex(id, action.hex, action.n, action.shouldCenter, false));
      }
      if (action.type === "RESET_ACTIONS") {
        dispatch(resetActions(id, true, false));
      }
      if (action.type === "UPDATE_SELECTED_CHART") {
        dispatch(updateSelectedChart(id, action?.hex, action?.node));
      }
      if (action.type === "UPDATE_PINNED_HEX") {
        dispatch(updatePinnedHex(id, action.hex, action.node, false, action.isTodo));
      }
      if (action.type === "UPDATE_PINNED_HEX_FORCE") {
        dispatch(updatePinnedHexForce(id, action.pinnedHex));
      }
      if (action.type === "UPDATE_SELECTION_DIRECTION") {
        dispatch(updateSelectionDirection(id, action.selectionDirection, false));
      }
      if (action.type === "MOVE_HEX") {
        dispatch(moveHex(id, action.fHex, action.tHex, action.rNode));
      }
      if (action.type === "REMOVE_NODE") {
        dispatch(removeNode(id, action.hex, action.node));
      }
      if (action.type === "REMOVE_ALL_NODES") {
        dispatch(removeAllNodes(id, action.node));
      }
      if (action.type === "ADD_TO_PINNED_HEX_LIST") {
        dispatch(addToPinnedHexList(id, action.node));
      }
      if (action.type === "ADD_PINNED") {
        dispatch(addPinned(id, false));

        /*
        if (getReplayStopAfterAdd(getState(), id) === true) {
          console.log(stopNode);

          setTimeout(() => centerHex(stopNode, true), 1000);

          setTimeout(() => {
            dispatch(updateIsReplay(id, false));
            dispatch(updateReplayStopAfterAdd(id, false));
          }, 2000);
        }
        */
      }

      const aNode = action?.rNode || action?.node || action?.n;
      const sNode = stopAction?.rNode || stopAction?.node || stopAction?.n || stopAction;

      if (
        aNode &&
        aNode.chart &&
        aNode.chart.title &&
        stopAction &&
        sNode &&
        sNode.chart &&
        aNode.chart.title === sNode.chart.title &&
        action.type === stopAction.type
      ) {
        dispatch(updateIsReplay(id, false));

        setTimeout(() => centerHex(stopAction, true), 200);
      }

      if (stopAction?.isAdded) {
        if (
          sNode?.chart?.title &&
          sNode?.chart?.title === aNode?.chart?.title &&
          action?.type === "UPDATE_PINNED_HEX"
        ) {
          dispatch(updateIsReplay(id, false));

          setTimeout(() => centerHex(stopAction, true), 200);
        }
      }
    } catch (error) {
      dispatch(resetHex(id));
    }
  };
}

export function replayActions(id, stopNode = undefined) {
  return (dispatch, getState) => {
    const activeTab = getActiveTab(getState(), id);

    if (activeTab === "MODELS") {
      return dispatch(nextModelsReducer.replayActions(id, stopNode));
    }

    if (window.replayTimeouts) {
      window.replayTimeouts.forEach((timeout) => clearTimeout(timeout));
    }
    window.replayTimeouts = [];

    const actions = [...getSavedActions(getState(), id)];

    const vActions = actions.filter((a) => a.isVisible !== false);

    const hexagonRadius = getHexagonRadius(getState(), id);

    const hexMap = getHexMap(getState(), id);

    dispatch(updateIsReplay(id, true));
    dispatch(updateShowReplay(id, true));

    stopNode && dispatch(updateReplayIndex(id, -1));

    let replayIndex = getReplayIndex(getState(), id);

    if (replayIndex === -1 || replayIndex === vActions.length || replayIndex === vActions.length - 1) {
      if (replayIndex === vActions.length || replayIndex === vActions.length - 1) {
        dispatch(updateReplayIndex(id, -1));
      }
      dispatch(updateBeforeReplayHexMap(id, hexMap));
      dispatch(resetActions(id, undefined, false));
      dispatch(updateGridType(id, getGridType(getState(), id)));
      centerHex({ x: hexagonRadius, y: hexagonRadius }, true);
    }

    replayIndex = getReplayIndex(getState(), id);

    let originalReplayIndex = replayIndex;

    const rActions = actions.filter((a, i) => i > replayIndex);

    const retReplayIndex = replayIndex + 1;

    // TIMINGS
    const moveOffset = 100;
    const instantOffset = moveOffset / 2;
    const actionStartTimeout = 1000;
    const actionMiddleTimeout = 1000;
    const actionEndTimeout = 1000;

    window.replayTimeouts.push(
      setTimeout(
        () => dispatch(updateIsReplay(id, false)),
        (actions.length - retReplayIndex) * actionStartTimeout + actionMiddleTimeout + actionEndTimeout
      )
    );

    let aIndex = 0;

    try {
      rActions
        .filter((a) => a.isInstant !== true)
        .forEach((action, i) => {
          let stopAction = false;

          window.replayTimeouts.push(
            setTimeout(
              () => {
                if (getIsReplay(getState(), id) === false) {
                  return;
                }

                const nReplayIndex = getReplayIndex(getState(), id);

                const realIndex = action.isVisible === false ? nReplayIndex : 1 + nReplayIndex;

                // First move to hex
                setTimeout(() => {
                  if (action && action.hex) {
                    centerHex(action.hex, true);
                  } else if (action && action.selectionDirection && action.selectionDirection.parent) {
                    centerHex(action.selectionDirection.parent, true);
                  } else if (action && action.node) {
                    centerHex(action.node, true);
                  }
                }, moveOffset);

                // Then do action
                setTimeout(() => {
                  if (action && action.hex) {
                    const aKey = action.hex.x + "_" + action.hex.y;

                    const pHexTile =
                      document.getElementById("hexTile_" + aKey + "_0") ||
                      document.getElementById("hexTile_" + aKey + "_a") ||
                      document.getElementById("hexTile_" + aKey + "_n");

                    const hexGridInner = document.getElementById("hexGridInner");

                    if (pHexTile && hexGridInner) {
                      let d = document.createElement("div");
                      d.className = "clickEffect";
                      d.style.left = pHexTile.offsetLeft + pHexTile.offsetWidth / 2 + "px";
                      d.style.top = pHexTile.offsetTop + pHexTile.offsetHeight / 2 + "px";
                      hexGridInner.appendChild(d);

                      d.addEventListener(
                        "animationend",
                        function () {
                          d.parentElement.removeChild(d);
                        }.bind(this)
                      );
                    }
                  }

                  dispatch(handleAction(id, action, stopNode));
                  dispatch(updateReplayIndex(id, realIndex));

                  let checkNext = true;
                  while (rActions.length > aIndex && checkNext) {
                    if (rActions[aIndex].isInstant) {
                      setTimeout(() => {
                        dispatch(handleAction(id, rActions[aIndex - 1], stopNode));
                      }, instantOffset);
                      aIndex++;
                    } else {
                      checkNext = false;
                    }
                  }

                  aIndex++;
                }, actionEndTimeout);
              },
              i * actionStartTimeout + actionMiddleTimeout
            )
          );
        });
    } catch (error) {
      return dispatch(resetHex(id));
    }
  };
}

export function getIndexFromHex(state, id, hex, node) {
  const hexMap = getHexMap(state, id);

  const nodes = hexMap[hex.x + "_" + hex.y];

  let foundIndex = 0;

  nodes.forEach((n, i) => {
    if (n?.chart?.title === node?.chart?.title) {
      foundIndex = i;
    }
  });

  return foundIndex;
}

export function setHasViewed(id, node, hasViewed) {
  return (dispatch, getState) => {
    let hasViewedList = getHasViewedList(getState(), id);

    const title = node?.title || node?.chart?.title || node?.chart?.chart?.title;

    hasViewedList[title] = hasViewed;

    return dispatch(updateHasViewedList(id, hasViewedList));
  };
}

export function updateSelectedHex(id, hex, n, shouldCenter, saveReplay = true, isInstant = false) {
  return (dispatch, getState) => {
    const selectedHex = getSelectedHex(getState(), id);
    const isSelectedHex = selectedHex && hex.x === selectedHex.x && hex.y === selectedHex.y;

    saveReplay === true &&
      dispatch(
        addSavedAction(id, {
          type: "UPDATE_SELECTED_HEX",
          hex: hex,
          n: stripNodeOfData(n),
          shouldCenter: shouldCenter,
          isVisible: isInstant ? false : n ? true : false,
          isInstant: isInstant
        })
      );

    dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: false,
      key: "canHover"
    });

    /*
    onClick={(e) => {
      e.stopPropagation();
      assignTodo({
        aTypeReadable: node?.text,
        mNode: node,
      });
    }}
    */

    const hexagonRadius = getHexagonRadius(getState(), id);

    const selectionDirection = getSelectionDirection(getState(), id);

    if (isSelectedHex) {
      const actionHexMap = getActionHexMap(getState(), id);

      if (Object.keys(actionHexMap).length > 0) {
        const pinnedHex = getPinnedHex(getState(), id);

        if (pinnedHex && Object.keys(pinnedHex).length > 0) {
          return dispatch(addPinned(id, saveReplay));
        } else {
          return dispatch(resetActions(id, saveReplay, false));
        }
      }
    }

    const hexMap = getHexMap(getState(), id);
    const hKey = hex.x + "_" + hex.y;

    const node = n !== undefined ? n : getHexNode(getState(), id, hex);

    dispatch(setHasViewed(id, node, true));

    if (node && node.type === HEXAGON_NODES.MUSCLE) {
      return dispatch(resetActions(id, undefined, saveReplay));
    }

    const hexFields = { ...node.fields };

    const isSecondOrder = Object.keys(hexFields).length === 2;

    // TODO: Unhackify This
    // Recalculating the first and second order insights each time
    const comparisonOptions = getComparisonOptions(getState(), id);
    if (comparisonOptions && isSecondOrder) {
      return dispatch(updateSelectedChart(id, node, node));

      /*
      TODO: Delete this code if this new functionality works, just doing the updateSelectedChart here which should take care of
      clicking into the opened nodes.

      dispatch({
        type: UPDATE_FIELD_VALUE,
        id: id,
        key: "isAnimateReturn",
        data: true,
      });

      setTimeout(() => dispatch(scrollReportByTitle(id, n || hex)), 10);

      setTimeout(
        () =>
          dispatch({
            type: UPDATE_FIELD_VALUE,
            id: id,
            data: true,
            key: "canHover",
          }),
        1000,
      );

      dispatch({
        type: UPDATE_FIELD_VALUE,
        id: id,
        data: retHex,
        key: "selectedHex",
      });

      const nActionHexMap = getActionHexMap(getState(), id);
      if (Object.keys(nActionHexMap).length > 0) {
        return dispatch(resetActions(id, saveReplay, false));
      }
      */

      return;
    } else if (comparisonOptions) {
      const hLength = Object.keys(hexFields).length;

      const rHex = selectionDirection ? selectionDirection : node.parent ? node.parent : hex;

      const retHex =
        hexMap[hKey] && false
          ? { ...hexMap[hKey][0], isAction: false }
          : {
              ...rHex,
              x: node.x,
              y: node.y,
              type:
                hLength === 1
                  ? HEXAGON_NODES.FIRST_ORDER_CHART
                  : hLength === 2
                    ? HEXAGON_NODES.SECOND_ORDER_CHART
                    : HEXAGON_NODES.NONE,
              fields: { ...hexFields },
              chart: node && node.chart ? node.chart : undefined,
              isPath: true,
              fromNode: hex.x !== hexagonRadius || hex.y !== hexagonRadius ? selectedHex : undefined,
              fromType:
                hex.x !== hexagonRadius || hex.y !== hexagonRadius
                  ? selectionDirection
                    ? selectionDirection
                    : node && node.parent && node.parent.type
                      ? { type: node.parent.type }
                      : undefined
                  : undefined,
              isAction: false,
              isAnimate: false,
              isAdded: true
            };

      const retHexMap = {
        ...getHexMap(getState(), id)
      };

      const retHexKey = selectionDirection
        ? selectionDirection.x + "_" + selectionDirection.y
        : node.parent
          ? node.parent.x + "_" + node.parent.y
          : hKey;

      if (node.parent && node.isAction !== true) {
      } else {
        if (retHexMap[retHexKey] === undefined) {
          retHexMap[retHexKey] = [{ ...retHex, index: 0 }];
        } else if (retHexMap[retHexKey].find((n) => n.chart && n.chart.title === retHex.chart.title) === undefined) {
          retHexMap[retHexKey].push({
            ...retHex,
            index: retHexMap[retHexKey].length
          });
        }

        if (selectedHex && node && node.parent) {
          retHexMap[selectedHex.x + "_" + selectedHex.y] = [
            {
              ...selectedHex,
              isPath: true
            }
          ];
        }
      }

      const dateField = comparisonOptions.dateField;

      const column = retHex?.chart?.metadata?.properties?.find((p) => p.column !== dateField)?.column;

      const viewIndex = getViewIndex(getState(), id);

      const topSecondOrderInsights = getRelatedInsights(getState(), id, [dateField], {}, undefined, "Difference", {
        limit: 5000
      })
        .map((c) => {
          const fields = getFieldsFromChart(getState(), id, c);

          return {
            ...c,
            fields
          };
        })
        .filter((insight) => {
          return insight.metadata.properties.find((p) => p.column == column);
        })
        .map((c) => {
          const newChart = getInsightFromMetadata(getState(), id, c?.metadata, false);

          if (!newChart) {
            return;
          }

          const metrics = getMetricsFromChartData(newChart?.chart?.data, comparisonOptions);

          c.sortScore = Math.abs(metrics.difference);
          return c;
        });

      topSecondOrderInsights.sort((i1, i2) => {
        const firstDiff = i1?.sortScore ?? 0;
        const secondDiff = i2?.sortScore ?? 0;
        return Math.abs(secondDiff) - Math.abs(firstDiff);
      });

      const subSecondOrderInsights = topSecondOrderInsights.filter(
        (insight, i) => i >= viewIndex && i <= viewIndex + 6
      );

      let actionHexMap = {};

      const neighborLocation = getNeighborLocation(hex.x, hex.y);
      let nIndex = 0;
      let insightIndex = 0;

      const selectedField = node && node.fields && node.fields[0] ? node.fields[0].label : "";

      for (const nKey of Object.keys(neighborLocation)) {
        const neighbor = neighborLocation[nKey];

        if (nIndex < subSecondOrderInsights.length) {
          const currInsight = subSecondOrderInsights[nIndex];

          const currChart = {
            ...neighbor,
            type: HEXAGON_NODES.SECOND_ORDER_CHART,
            chart: currInsight,
            fields: getFieldsFromChart(getState(), id, currInsight),
            text: nIndex,
            parent: node,
            isAnimate: true
          };

          actionHexMap[neighbor.x + "_" + neighbor.y] = currChart;
        }

        // if (nIndex >= fIndex && nIndex < topSecondOrderInsights.length) {
        //   actionHexMap[neighbor.x + "_" + neighbor.y] = [];
        // }

        // for (let insightIndex = nIndex; (insightIndex <= nIndex || insightIndex >= fIndex) && insightIndex < topSecondOrderInsights.length; insightIndex++) {
        //   const currInsight = topSecondOrderInsights[insightIndex];

        //   const currChart = {
        //     ...neighbor,
        //     type: HEXAGON_NODES.SECOND_ORDER_CHART,
        //     chart: currInsight,
        //     fields: getFieldsFromChart(getState(), id, currInsight),
        //     text: insightIndex,
        //     parent: node,
        //     isHidden: true,
        //     isAnimate: true,
        //     shouldAnimateReturn: true,
        //   }

        //   if (nIndex < fIndex) {
        //     actionHexMap[neighbor.x + "_" + neighbor.y] = currChart;
        //   } else {
        //     actionHexMap[neighbor.x + "_" + neighbor.y].push(currChart);
        //   }
        // }

        nIndex++;
      }

      if (node.parent === undefined) {
        dispatch(updateHexMap(id, retHexMap));
        dispatch(updateViewIndex(id, 0));

        const selectionDirection = getSelectionDirection(getState(), id);

        selectionDirection !== undefined && dispatch(updateSelectionDirection(id, undefined, saveReplay));

        //dispatch(updateSelectedChart(id, hex, rHex));
      }

      dispatch({
        type: UPDATE_FIELD_VALUE,
        id: id,
        key: "isAnimateReturn",
        data: false
      });

      dispatch(updateTotalChartCount(id, topSecondOrderInsights.length ?? 0));

      dispatch(updateActionHexMap(id, actionHexMap));

      setTimeout(() => dispatch(scrollReportByTitle(id, n || hex)), 10);

      setTimeout(
        () =>
          dispatch({
            type: UPDATE_FIELD_VALUE,
            id: id,
            data: true,
            key: "canHover"
          }),
        1000
      );

      return dispatch({
        type: UPDATE_FIELD_VALUE,
        id: id,
        data: retHex,
        key: "selectedHex"
      });
    }

    const hLength = Object.keys(hexFields).length;

    const rHex = selectionDirection ? selectionDirection : node.parent ? node.parent : hex;

    const retHex =
      hexMap[hKey] && false
        ? { ...hexMap[hKey][0], isAction: false }
        : {
            ...rHex,
            x: node.x,
            y: node.y,
            type:
              hLength === 1
                ? HEXAGON_NODES.FIRST_ORDER_CHART
                : hLength === 2
                  ? HEXAGON_NODES.SECOND_ORDER_CHART
                  : HEXAGON_NODES.NONE,
            fields: { ...hexFields },
            chart: node && node.chart ? node.chart : undefined,
            isPath: true,
            fromNode: hex.x !== hexagonRadius || hex.y !== hexagonRadius ? selectedHex : undefined,
            fromType:
              hex.x !== hexagonRadius || hex.y !== hexagonRadius
                ? selectionDirection
                  ? selectionDirection
                  : node && node.parent && node.parent.type
                    ? { type: node.parent.type }
                    : undefined
                : undefined,
            isAction: false,
            isAnimate: false,
            isAdded: true
          };

    const retHexMap = {
      ...getHexMap(getState(), id)
    };

    const retHexKey = selectionDirection
      ? selectionDirection.x + "_" + selectionDirection.y
      : node.parent
        ? node.parent.x + "_" + node.parent.y
        : hKey;

    if (node.parent && node.isAction !== true) {
    } else {
      if (retHexMap[retHexKey] === undefined) {
        retHexMap[retHexKey] = [{ ...retHex, index: 0 }];
      } else if (retHexMap[retHexKey].find((n) => n.chart && n.chart.title === retHex.chart.title) === undefined) {
        retHexMap[retHexKey].push({
          ...retHex,
          index: retHexMap[retHexKey].length
        });
      }

      if (selectedHex && node && node.parent) {
        retHexMap[selectedHex.x + "_" + selectedHex.y] = [
          {
            ...selectedHex,
            isPath: true
          }
        ];
      }
    }

    let secondItemY = 0;
    let thirdItemY = 1;
    let lastItemY = 0;

    if (hex.x % 2 === 0) {
      secondItemY = -1;
      thirdItemY = 0;
      lastItemY = -1;
    }

    let actionHexMap = {};

    const doubleNeighbors = getDoubleNeighborLocation(getState(), id, hex.x, hex.y);

    const neighborLocation = getNeighborLocation(hex.x, hex.y);
    let nIndex = 0;

    const popularCharts = getPopularCharts(getState(), id).filter((n) => getIsInStory(getState(), id, n) !== true);

    const selectedField = node && node.fields && node.fields[0] ? node.fields[0].label : "";

    const votingCharts = getInsightsFromMetadata(getState(), id, {
      properties: [{ column: selectedField, type: "column" }],
      type: "ModelDriver"
    });

    for (const nKey of Object.keys(neighborLocation)) {
      const neighbor = neighborLocation[nKey];

      const hasPopular = popularCharts.length > 0;
      const hasVoting = votingCharts.length > 0;

      const fIndex = 3 + (hasPopular ? 1 : 0) + (hasVoting ? 1 : 0);

      if (nIndex < fIndex) {
        actionHexMap[neighbor.x + "_" + neighbor.y] = {
          ...neighbor,
          type:
            node?.chart?.metadata?.type === "ModelDriver"
              ? nIndex === 0
                ? HEXAGON_NODES.VOTING
                : nIndex === 1
                  ? HEXAGON_NODES.DRILL_IN
                  : nIndex === 2
                    ? HEXAGON_NODES.DRILL_IN_CLUSTER
                    : nIndex === 3
                      ? HEXAGON_NODES.STAT_ASSOC
                      : nIndex === 4
                        ? HEXAGON_NODES.POPULAR
                        : HEXAGON_NODES.TEXT
              : nIndex === 0
                ? isSecondOrder
                  ? HEXAGON_NODES.FIRST_VARIABLE
                  : HEXAGON_NODES.DRILL_IN
                : nIndex === 1
                  ? isSecondOrder
                    ? HEXAGON_NODES.SECOND_VARIABLE
                    : HEXAGON_NODES.DRILL_IN_CLUSTER
                  : nIndex === 2
                    ? HEXAGON_NODES.STAT_ASSOC
                    : nIndex === 3
                      ? HEXAGON_NODES.VOTING
                      : nIndex === 4
                        ? HEXAGON_NODES.POPULAR
                        : nIndex === 5
                          ? HEXAGON_NODES.TEXT
                          : HEXAGON_NODES.TEXT,
          fields: hexFields,
          text: nIndex,
          isAnimate: true,
          parent: node,
          aParent: node,
          mHex: { x: neighbor.x, y: neighbor.y },
          aDelta: {
            top: node.x - neighbor.x,
            left: node.y - neighbor.y
          },
          isDirection: true,
          shouldAnimateReturn: true
        };
      }

      nIndex++;
    }

    const nextCharts = getRelatedInsights(getState(), id, selectedField, {}, undefined, "Descriptive");

    let otherCharts = [];
    if (node && node.fields && node.fields[1] && node?.chart?.metadata?.type !== "ModelDriver") {
      otherCharts = getRelatedInsights(getState(), id, node.fields[1].label, {}, undefined, "Descriptive");
    } else {
      otherCharts = getRelatedInsights(getState(), id, undefined, {}, selectedField, "Descriptive");

      /*

      const filterCharts = otherCharts.filter(
        (n) => getIsInStory(getState(), id, n) !== true
      );
      otherCharts = filterCharts.length > 0 ? filterCharts : otherCharts;
      */
    }

    let statCharts = [];
    if (node && node.fields && node.fields[0]) {
      statCharts = getRelatedInsights(getState(), id, node.fields[0].label, {}, undefined, "Correlation");
    }

    let aIndex = 0;
    for (const nKey of Object.keys(actionHexMap)) {
      const aNode = actionHexMap[nKey];

      const neighbors = getNeighborLocation(aNode.x, aNode.y);

      const sItems = {
        parent: aNode,
        aParent: node,
        isHidden: true,
        isAnimate: true,
        shouldAnimateReturn: true,
        parentSortScore: node?.sortScore
      };

      const dChartOne = {
        rIndex: nextCharts[0]?.scoreRank,
        fromType: { type: HEXAGON_NODES.DRILL_IN },
        type: HEXAGON_NODES.SECOND_ORDER_CHART,
        chart: nextCharts && nextCharts.length > 0 ? nextCharts[0] : undefined,
        fields: nextCharts && nextCharts.length > 0 ? getFieldsFromChart(getState(), id, nextCharts[0]) : {},
        ...sItems
      };
      const dChartTwo = {
        rIndex: nextCharts[1]?.scoreRank,
        fromType: { type: HEXAGON_NODES.DRILL_IN },
        type: HEXAGON_NODES.SECOND_ORDER_CHART,
        chart: nextCharts && nextCharts.length > 1 ? nextCharts[1] : undefined,
        fields: nextCharts && nextCharts.length > 1 ? getFieldsFromChart(getState(), id, nextCharts[1]) : {},
        ...sItems
      };

      // Leave the fields blank if there's no appropriate charts
      const oChartOne = {
        rIndex: otherCharts?.[0]?.scoreRank,
        // otherCharts && otherCharts.length > 0
        //   ? otherCharts[0]?.scoreRank
        //   : nextCharts && nextCharts.length > 2
        //   ? nextCharts[2]?.scoreRank
        //   : undefined,
        fromType: { type: HEXAGON_NODES.DRILL_IN_CLUSTER },
        type: HEXAGON_NODES.SECOND_ORDER_CHART,
        chart: otherCharts?.[0],
        // otherCharts && otherCharts.length > 0
        //   ? otherCharts[0]
        //   : nextCharts && nextCharts.length > 2
        //   ? nextCharts[2]
        //   : undefined,
        fields: otherCharts && otherCharts.length > 0 ? getFieldsFromChart(getState(), id, otherCharts[0]) : {},
        // otherCharts && otherCharts.length > 0
        //   ? getFieldsFromChart(getState(), id, otherCharts[0])
        //   : nextCharts && nextCharts.length > 2
        //   ? getFieldsFromChart(getState(), id, nextCharts[2])
        //   : {},
        ...sItems
      };

      const oChartTwo = {
        rIndex: otherCharts?.[1]?.scoreRank,
        // otherCharts && otherCharts.length > 1
        //   ? otherCharts[1]?.scoreRank
        //   : nextCharts && nextCharts.length > 3
        //   ? nextCharts[3]?.scoreRank
        //   : undefined,
        fromType: { type: HEXAGON_NODES.DRILL_IN_CLUSTER },
        type: HEXAGON_NODES.SECOND_ORDER_CHART,
        chart: otherCharts?.[1],
        // otherCharts && otherCharts.length > 1
        //   ? otherCharts[1]
        //   : nextCharts && nextCharts.length > 3
        //   ? nextCharts[3]
        //   : undefined,
        fields: otherCharts && otherCharts.length > 1 ? getFieldsFromChart(getState(), id, otherCharts[1]) : {},
        // otherCharts && otherCharts.length > 1
        //   ? getFieldsFromChart(getState(), id, otherCharts[1])
        //   : nextCharts && nextCharts.length > 3
        //   ? getFieldsFromChart(getState(), id, nextCharts[3])
        //   : {},
        ...sItems
      };

      const sChartOne = {
        rIndex: statCharts[0]?.scoreRank,
        fromType: { type: HEXAGON_NODES.STAT_ASSOC },
        type: HEXAGON_NODES.SECOND_ORDER_CHART,
        chart: statCharts && statCharts.length > 0 ? statCharts[0] : undefined,
        fields: statCharts && statCharts.length > 0 ? getFieldsFromChart(getState(), id, statCharts[0]) : {},
        ...sItems
      };

      const sChartTwo = {
        rIndex: statCharts[1]?.scoreRank,
        fromType: { type: HEXAGON_NODES.STAT_ASSOC },
        type: HEXAGON_NODES.SECOND_ORDER_CHART,
        chart: statCharts && statCharts.length > 1 ? statCharts[1] : undefined,
        fields: statCharts && statCharts.length > 1 ? getFieldsFromChart(getState(), id, statCharts[1]) : {},
        ...sItems
      };

      const vChartOne =
        votingCharts && votingCharts.length > 0
          ? {
              rIndex: votingCharts[0].scoreRank !== undefined ? votingCharts[0].scoreRank : 0,
              fromType: { type: HEXAGON_NODES.VOTING },
              type: HEXAGON_NODES.VOTING_CHART,
              fields: hexFields,
              chart: votingCharts && votingCharts.length > 0 ? votingCharts[0] : undefined,
              text: "Model Voting 1",
              ...sItems
            }
          : undefined;

      const vChartTwo =
        votingCharts && votingCharts.length > 1
          ? {
              rIndex: votingCharts[1].scoreRank !== undefined ? votingCharts[1].scoreRank : 1,
              fromType: { type: HEXAGON_NODES.VOTING },
              type: HEXAGON_NODES.VOTING_CHART,
              fields: hexFields,
              chart: votingCharts && votingCharts.length > 1 ? votingCharts[1] : undefined,
              text: "Model Voting 2",
              ...sItems
            }
          : undefined;

      const pChartOne =
        popularCharts && popularCharts.length > 0
          ? {
              rIndex: 0,
              fromType: { type: HEXAGON_NODES.POPULAR },
              type: HEXAGON_NODES.SECOND_ORDER_CHART,
              chart: popularCharts && popularCharts.length > 0 ? popularCharts[0] : undefined,
              fields:
                popularCharts && popularCharts.length > 0 ? getFieldsFromChart(getState(), id, popularCharts[0]) : {},
              ...sItems
            }
          : undefined;

      const pChartTwo =
        popularCharts && popularCharts.length > 1
          ? {
              rIndex: 1,
              fromType: { type: HEXAGON_NODES.POPULAR },
              type: HEXAGON_NODES.SECOND_ORDER_CHART,
              chart: popularCharts && popularCharts.length > 1 ? popularCharts[1] : undefined,
              fields:
                popularCharts && popularCharts.length > 1 ? getFieldsFromChart(getState(), id, popularCharts[1]) : {},
              ...sItems
            }
          : undefined;

      if (Object.keys(hexFields).length > 0) {
        const firstKey = neighbors[aIndex].x + "_" + neighbors[aIndex].y;
        const secondKey = neighbors[aIndex + 1].x + "_" + neighbors[aIndex + 1].y;

        const isMD = node?.chart?.metadata?.type === "ModelDriver";

        let first = undefined;
        let second = undefined;

        switch (aIndex) {
          // First Var
          case 0:
            first = isMD ? vChartOne : dChartOne;
            second = isMD ? vChartTwo : dChartTwo;
            break;

          // Second Var
          case 1:
            first = isMD ? dChartOne : oChartOne;
            second = isMD ? dChartTwo : oChartTwo;
            break;

          // Stat Assoc
          case 2:
            first = isMD ? oChartOne : sChartOne;
            second = isMD ? oChartTwo : sChartTwo;
            break;

          // Model Voting
          case 3:
            first = isMD ? sChartOne : vChartOne;
            second = isMD ? sChartTwo : vChartTwo;
            break;

          // Popularity
          case 4:
            if (popularCharts && popularCharts.length > 0) {
              first = pChartOne;
              second = pChartTwo;
            }
            break;
        }

        if (first !== undefined && first.chart !== undefined) {
          actionHexMap[firstKey] = {
            ...first,
            mHex: { x: neighbors[aIndex].x, y: neighbors[aIndex].y }
          };
        }

        if (second !== undefined && second.chart !== undefined) {
          actionHexMap[secondKey] = {
            ...second,
            mHex: { x: neighbors[aIndex + 1].x, y: neighbors[aIndex + 1].y }
          };
        }
      }

      aIndex++;
    }

    /*
    if (actionHexMap[hexagonRadius + "_" + hexagonRadius]) {
      if (Object.keys(hexFields).length >= 1) {
        actionHexMap[hex.x - 1 + "_" + (hex.y + secondItemY)] =
          actionHexMap[hexagonRadius + "_" + hexagonRadius];

        actionHexMap[hex.x - 1 + "_" + (hex.y + secondItemY)].x = hex.x - 1;
        actionHexMap[hex.x - 1 + "_" + (hex.y + secondItemY)].y =
          hex.y + secondItemY;
      }

      actionHexMap[hexagonRadius + "_" + hexagonRadius] = {
        type: HEXAGON_NODES.MUSCLE,
        fields: hexFields,
      };
    }
    */

    if (node.parent === undefined) {
      dispatch(updateHexMap(id, retHexMap));
      dispatch(updateViewIndex(id, 0));

      const selectionDirection = getSelectionDirection(getState(), id);

      selectionDirection !== undefined && dispatch(updateSelectionDirection(id, undefined, saveReplay));

      //dispatch(updateSelectedChart(id, hex, rHex));
    }

    dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      key: "isAnimateReturn",
      data: false
    });

    dispatch(updateActionHexMap(id, actionHexMap));

    setTimeout(() => dispatch(scrollReportByTitle(id, n || hex)), 10);

    setTimeout(
      () =>
        dispatch({
          type: UPDATE_FIELD_VALUE,
          id: id,
          data: true,
          key: "canHover"
        }),
      1000
    );

    return dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: retHex,
      key: "selectedHex"
    });
  };
}
/*
export function updateHexOrderOld(id, hex, isRight) {
  return (dispatch, getState) => {
    const hexMap = {...getHexMap(getState(), id)};

    const nodes = [...hexMap[hex.x + "_" + hex.y]];

    if (isRight === false) {
      nodes.unshift(nodes.pop());
    } else {
      nodes.push(nodes.shift());
    }
    hexMap[hex.x + "_" + hex.y] = nodes;

    return dispatch(updateHexMap(id, hexMap));
  };
}
*/

export function updateHexOrder(id, hex, isRight) {
  return (dispatch, getState) => {
    const hexMap = getHexMap(getState(), id);

    const nodes = hexMap[hex.x + "_" + hex.y];

    let hexOrder = { ...getHexOrder(getState(), id) };
    const currentIndex = hexOrder[hex.x + "_" + hex.y] !== undefined ? hexOrder[hex.x + "_" + hex.y] : 0;

    if (isRight === true) {
      if (nodes.length === currentIndex + 1) {
        hexOrder[hex.x + "_" + hex.y] = 0;
      } else if (nodes.length > currentIndex + 1) {
        hexOrder[hex.x + "_" + hex.y] = currentIndex + 1;
      }
    } else {
      if (currentIndex > 0) {
        hexOrder[hex.x + "_" + hex.y] = currentIndex - 1;
      }
    }

    const cIndex = hexOrder[hex.x + "_" + hex.y];

    const pNode = nodes?.[cIndex];

    pNode && dispatch(updateSelectedChart(id, pNode, pNode));

    return dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: hexOrder,
      key: "hexOrder"
    });
  };
}

export function updateIsAnimateReturn(id, isAnimateReturn) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "isAnimateReturn",
    data: isAnimateReturn
  };
}

export function updateSearchOptions(id, searchOptions) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: searchOptions,
    key: "searchOptions"
  };
}

export function setTableauDataId(id) {
  return (dispatch, getState) => {
    const tableauDataId = loginReducer.getTableauDataId(getState());

    return dispatch(updateTableauDataId(id, tableauDataId));
  };
}

export function updateTableauDataId(id, tableauDataId) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: tableauDataId,
      key: "tableauDataId"
    });

    return dispatch(saveNext(id, "", false));
  };
}

export function updateSearchTimeline(id, searchTimeline) {
  return (dispatch, getState) => {
    const activeTab = getActiveTab(getState(), id);

    if (activeTab === "MODELS") {
      return dispatch(nextModelsReducer.updateSearchTimeline(id, searchTimeline));
    }

    return dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: searchTimeline,
      key: "searchTimeline"
    });
  };
}

export function quickSearch(id, column) {
  return (dispatch, getState) => {
    dispatch(handleSearchInsights(id, [{ field: column }], true));
  };
}

export function handleSearchInsights(id, options, isDashboard = false) {
  return (dispatch, getState) => {
    return dispatch(handleSearchInsightsHelper(id, options, isDashboard));
  };
}

export function handleSearchInsightsHelper(id, options, isDashboard = false) {
  return (dispatch, getState) => {
    if (options === undefined || options.length === 0) {
      const result = dispatch({
        type: UPDATE_FIELD_VALUE,
        id: id,
        data: [],
        key: "searchInsights"
      });
      dispatch(updateSearchOptions(id, []));
      return result;
    }
    const firstOrderOption = options.find((o) => o.filterValue === undefined);

    if (firstOrderOption && isDashboard === true) {
      const comparisonOptions = getComparisonOptions(getState(), id);

      let retOptions = [...options.filter((o) => o.filterValue !== undefined)];

      const datasetId = getDatasetId(getState(), id);
      const dataset = homeReducer.getDataset(getState(), datasetId);

      const rField = dataset.fields[firstOrderOption.field];
      let chartData;

      if (comparisonOptions?.dateField) {
        const allCharts = getComparisonChartsByColumn(getState(), id, undefined, undefined, true);
        const fChart = allCharts?.find((ac) => ac.column === firstOrderOption.field);

        // We want chartData to be undefined if there are no charts associated with the firstOrderOption
        // so we can use the fallback
        chartData = fChart?.charts?.map((c) => {
          const cProp = c.metadata?.properties?.find((p) => p.column !== comparisonOptions?.dateField);
          const value = cProp.value ?? c.title.substring((cProp.column + " is ").length);
          return {
            ...cProp,
            value: value
          };
        });
      } else {
        const allCharts = getAllDashboardCharts(getState(), id);
        const fChart = allCharts?.find((ac) => ac.title === firstOrderOption.field);
        chartData = fChart?.mainChart?.chart?.data;
      }

      let retData = chartData ?? rField?.data ?? [];
      const hideOtherInCharts = chatGPTReducer.getHideOtherInCharts(getState());
      const hideMissingInCharts = chatGPTReducer.getHideMissingInCharts(getState());

      // Filter out the other and missing values when doing search
      // if in whats changed, respect the option to hide the missing/other filter
      if (!comparisonOptions?.dateField || hideOtherInCharts || hideMissingInCharts) {
        retData = retData?.filter((rData) => {
          if (hideOtherInCharts && (rData?.value === "{Other}" || rData?.name === "{Other}")) {
            return false;
          }
          if (
            hideMissingInCharts &&
            (rData?.value === "{Missing}" || rData?.name === "{Missing}" || rData?.value === "missing")
          ) {
            return false;
          }
          return true;
        });
      }

      retData.forEach((rData) => {
        const retValue = rData.value !== undefined ? rData.value : rData.name;

        retOptions.push({
          filterField: firstOrderOption.field,
          filterValue: retValue,
          label: firstOrderOption.field + ": " + retValue,
          value: firstOrderOption.field + ": " + retValue,
          min: rData.min,
          max: rData.max
        });
      });

      return dispatch(handleSearchInsights(id, retOptions));
    }

    const selectedSearchOptionsLabels = new Set();

    const filteredSelectedSearchOptions = [];
    for (const obj of options) {
      if (!selectedSearchOptionsLabels.has(obj.label)) {
        selectedSearchOptionsLabels.add(obj.label);
        filteredSelectedSearchOptions.push(obj);
      }
    }

    dispatch(updateSearchOptions(id, filteredSelectedSearchOptions));

    const datasetId = getDatasetId(getState(), id);
    const dataset = homeReducer.getDataset(getState(), datasetId);
    const rankedFields = homeReducer.getRankedFields(getState(), datasetId);

    const bestFieldsUnfiltered = (rankedFields ?? []).map((field, i) => ({
      label: field.label
    }));

    const bestFields = dataset?.field_scores
      ? bestFieldsUnfiltered.filter((field) => {
          return dataset.field_scores[field.label] > 0;
        })
      : [];

    const searchType = getSearchType(getState(), id);

    const comparisonOptions = getComparisonOptions(getState(), id);

    let metadata = {
      properties: [],
      type: comparisonOptions ? "Difference" : searchType
    };

    options.forEach((option) => {
      if (option?.field) {
        metadata.properties.push({ column: option.field, type: "column" });
      } else if (option?.filterField) {
        if (comparisonOptions) {
          metadata.properties.push({
            column: comparisonOptions.dateField,
            type: "column"
          });
        }
        if (option?.max !== undefined && option?.min !== undefined) {
          metadata.properties.push({
            column: option.filterField,
            value: (option.min + option.max) / 2
          });
        } else {
          metadata.properties.push({
            column: option.filterField,
            value: option.filterValue
          });
        }
      }
    });

    if (searchType === "All Insights" && !comparisonOptions) {
      const oSearch = searchTypeOptions.filter((s) => s.value !== "All Insights" && s.value !== "NLQ");

      // Removed adding in the popularity search because it seems we no longer need it to return all results in explore search

      // Highlight search results to display first
      const insightHighlights = [];
      // Other search results
      const insightOther = [];

      // How many results to check for highlights
      const HIGHLIGHT_LIMIT = 2;

      oSearch.forEach((o) => {
        metadata.type = o.value;

        const sInsights = getInsightAndRelatedFromMetadata(getState(), id, metadata, false);

        for (let i = 0; i < sInsights.length; i++) {
          if (
            i < HIGHLIGHT_LIMIT &&
            insightHighlights.find(
              (insight) =>
                sInsights[i]?.narrative?.title === insight?.narrative?.title &&
                sInsights[i]?.metadata?.type === insight?.metadata?.type
            ) === undefined
          ) {
            insightHighlights.push(sInsights[i]);
          } else {
            if (
              insightOther.find(
                (insight) =>
                  sInsights[i]?.narrative?.title === insight?.narrative?.title &&
                  sInsights[i]?.metadata?.type === insight?.metadata?.type
              ) === undefined
            ) {
              insightOther.push(sInsights[i]);
            }
          }
        }
      });

      const retInsights = [...insightHighlights];

      // Only add in results that haven't been added
      insightOther.forEach((currInsight) => {
        if (
          insightHighlights.find(
            (hInsight) =>
              currInsight?.narrative?.title === hInsight?.narrative?.title &&
              currInsight?.metadata?.type === hInsight?.metadata?.type
          ) === undefined
        ) {
          retInsights.push(currInsight);
        }
      });

      const finalRetInsights = retInsights.map((c) => ({
        ...c,
        fields: getFieldsFromChart(getState(), id, c)
      }));

      return dispatch({
        type: UPDATE_FIELD_VALUE,
        id: id,
        data: finalRetInsights.sort((a, b) => {
          const isImportantA = bestFields.find((field) => field.label === a?.narrative?.columnLabel);
          const isImportantB = bestFields.find((field) => field.label === b?.narrative?.columnLabel);

          return options.length === 1 && options?.[0]?.field !== undefined && a.title === options?.[0].field
            ? -1
            : options.length === 1 && options?.[0]?.field !== undefined && b.title === options?.[0].field
              ? 1
              : isImportantA && !isImportantB
                ? -1
                : isImportantB && !isImportantA
                  ? 1
                  : 0;
        }),
        key: "searchInsights"
      });
    }

    const searchInsights = getInsightAndRelatedFromMetadata(getState(), id, metadata).map((c) => ({
      ...c,
      fields: getFieldsFromChart(getState(), id, c)
    }));

    return dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: searchInsights.sort((a, b) => {
        const isImportantA = bestFields.find((field) => field.label === a?.narrative?.columnLabel);
        const isImportantB = bestFields.find((field) => field.label === b?.narrative?.columnLabel);

        return isImportantA && !isImportantB ? -1 : isImportantB && !isImportantA ? 1 : 0;
      }),
      key: "searchInsights"
    });
  };
}

export function updateSearchDashboardSimple(id, search) {
  return (dispatch, getState) => {
    const searchOptions = getSearchOptions(getState(), id) || [];

    const columnLabel = search?.split(" is ")?.[0];
    const value = search?.split(" is ")?.[1];

    const min = value?.split[" to "]?.[0];
    const max = value?.split[" to "]?.[1];

    const label = columnLabel + ": " + value;

    let retOptions = [
      ...searchOptions,
      {
        label: label,
        filterField: columnLabel,
        filterValue: value,
        min: min === undefined ? min : Number(min),
        max: max === undefined ? max : Number(max),
        value: label
      }
    ];

    if (value !== undefined) {
      return dispatch(handleSearchInsights(id, retOptions));
    }
  };
}

export function updateSearchDashboard(id, search) {
  return (dispatch, getState) => {
    if (search === undefined || search === null || !Object.keys(search)?.length) {
      return;
    }
    const searchOptions = getSearchOptions(getState(), id) || [];

    const columnLabel = search?.activePayload?.[0]?.payload?.column;
    const value = search?.activePayload?.[0]?.payload?.name;

    const min = search?.activePayload?.[0]?.payload?.min;
    const max = search?.activePayload?.[0]?.payload?.max;

    const label = columnLabel + ": " + value;

    let retOptions = [
      ...searchOptions,
      {
        label: label,
        filterField: columnLabel,
        filterValue: value,
        min: min === undefined ? min : Number(min),
        max: max === undefined ? max : Number(max),
        value: label
      }
    ];

    return dispatch(handleSearchInsights(id, retOptions));
  };
}

export function handleGoogleSheetsSearch() {
  return (dispatch, getState) => {
    const googleSheetsData = globalReducer.getGoogleSheetsData(getState());
    const column = googleSheetsData?.column;

    const dataset = homeReducer.getGoogleSheetsDataset(getState());

    if (!column || !dataset) {
      return;
    }

    const searchOption = {
      field: column,
      label: column,
      value: column
    };

    return dispatch(handleSearchInsights("new", [searchOption]));
  };
}

export function updateSearchInsights(id, field = undefined, filter = {}, filterField = undefined) {
  return (dispatch, getState) => {
    const searchType = getSearchType(getState(), id);

    const lastSearchOptions = {
      field: field,
      filter: filter,
      filterField: filterField
    };

    dispatch(updateLastSearchOptions(id, lastSearchOptions));

    const searchInsights =
      searchType === "Popularity"
        ? getPopularCharts(getState(), id).filter(
            (n) => field === undefined || (n?.title && n?.title.indexOf(field) !== -1)
          )
        : getRelatedInsights(getState(), id, field, filter, filterField, searchType).map((insight) => ({
            ...insight,
            fields: getFieldsFromChart(getState(), id, insight),
            wtf: "helpMe"
          }));

    return dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: searchInsights,
      key: "searchInsights"
    });
  };
}

export function updateHexMap(id, hexMap) {
  return { type: UPDATE_FIELD_VALUE, id: id, data: hexMap, key: "hexMap" };
}

export function updateActionHexMap(id, actionHexMap) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: actionHexMap,
    key: "actionHexMap"
  };
}

export function updateBestCharts(id, bestCharts) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: bestCharts,
    key: "bestCharts"
  };
}

export function updateExploreProjectId(id, exploreProjectId) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: exploreProjectId,
    key: "exploreProjectId"
  };
}

export function updateAgentAutonomyView(id, agentAutonomyView) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: agentAutonomyView,
    key: "agentAutonomyView"
  };
}

export function updateSavedHexMap(id) {
  return (dispatch, getState) => {
    const hexMap = getHexMap(getState(), id);
    const savedHexMap = getSavedHexMap(getState(), id);

    const savedLength = Object.keys(savedHexMap).length;

    const retSavedHexMap = { ...savedHexMap, [savedLength]: hexMap };

    return dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: retSavedHexMap,
      key: "savedHexMap"
    });
  };
}

export function removePin(id, hex, node) {
  return (dispatch, getState) => {
    const hexMap = { ...getHexMap(getState(), id) };

    const nodes = hexMap[hex.x + "_" + hex.y];

    if (nodes) {
      const foundNode = nodes.find((n) => n?.chart?.title === node?.chart?.title);

      foundNode.isPath = false;

      return dispatch(updateHexMap(id, hexMap));
    }

    return Promise.resolve();
  };
}

export function removeAllNodes(id, node) {
  return (dispatch, getState) => {
    const isReplay = getIsReplay(getState(), id);

    isReplay !== true &&
      dispatch(
        addSavedAction(id, {
          type: "REMOVE_ALL_NODES",
          node: stripNodeOfData(node)
        })
      );

    const undoHexMap = { ...getHexMap(getState(), id) };
    let hexMap = { ...getHexMap(getState(), id) };

    const undoPinnedHex = [...getPinnedHex(getState(), id)];
    let pinnedHex = [...getPinnedHex(getState(), id)];

    Object.keys(hexMap).forEach((hKey) => {
      hexMap[hKey] = hexMap[hKey].filter((hNode) => hNode?.chart?.title !== node?.chart?.title);
    });

    pinnedHex = pinnedHex.filter((pNode) => pNode?.chart?.title !== node?.chart?.title);

    const oPinnedHex = getPinnedHexList(getState(), id) ?? [];
    if (oPinnedHex?.length) {
      const newPinnedHexArr = oPinnedHex.filter((pinnedHex) => pinnedHex?.chart?.title !== node?.chart?.title);
      dispatch(updatePinnedHexList(id, newPinnedHexArr));
    }

    const selectedHex = getSelectedHex(getState(), id);

    if (
      selectedHex?.chart?.narrative?.title !== undefined &&
      selectedHex?.chart?.narrative?.title === node?.chart?.narrative?.title
    ) {
      dispatch(resetActions(id));
    }

    dispatch(updateHexMap(id, hexMap));
    dispatch(updatePinnedHexForce(id, pinnedHex));

    if (isReplay !== true) {
      toast(
        <div
          onClick={() => {
            dispatch(updateHexMap(id, undoHexMap));
            dispatch(updatePinnedHexForce(id, pinnedHex));
          }}
        >
          {"Chart " + node?.chart?.title + " has been removed. CLICK HERE TO UNDO REMOVAL"}
        </div>,
        {
          type: toast.TYPE.SUCCESS,
          position: toast.POSITION.TOP_CENTER,
          autoClose: 7500
        }
      );
    }

    return Promise.resolve();
  };
}

export function removeOrAddNode(id, node) {
  return (dispatch, getState) => {
    const pinnedHexList = getPinnedHexList(getState(), id);

    const activeNode = pinnedHexList.find((n) => n?.chart?.narrative?.title === node?.narrative?.title);

    if (activeNode !== undefined) {
      return dispatch(removeNode(id, activeNode, activeNode));
    } else {
      return dispatch(addNode(id, node));
    }
  };
}

export function removeNode(id, hex, node) {
  return (dispatch, getState) => {
    const isReplay = getIsReplay(getState(), id);

    isReplay !== true &&
      dispatch(
        addSavedAction(id, {
          type: "REMOVE_NODE",
          hex: hex,
          node: stripNodeOfData(node)
        })
      );

    const hexMap = { ...getHexMap(getState(), id) };
    const undoHexMap = { ...getHexMap(getState(), id) };

    const selectedHex = getSelectedHex(getState(), id);

    if (selectedHex && selectedHex?.x === hex?.x && selectedHex?.y === hex?.y) {
      dispatch(resetActions(id));
    }

    if (hexMap && hex && (hexMap[hex.x + "_" + hex.y] || (hex.x === undefined && hex.y === undefined))) {
      const oPinnedHex = getPinnedHexList(getState(), id) ? getPinnedHexList(getState(), id) : [];

      if (hex && oPinnedHex.length > 0) {
        const newPinnedHexArr =
          hex.x === undefined && hex.y === undefined
            ? oPinnedHex.filter((pinnedHex) => pinnedHex?.chart?.title !== node?.chart?.title)
            : oPinnedHex.filter(
                (pinnedHex) =>
                  pinnedHex.x + "," + pinnedHex.y !== hex.x + "," + hex.y ||
                  pinnedHex?.chart?.title !== node?.chart?.title
              );
        dispatch(updatePinnedHexList(id, newPinnedHexArr));
      }

      if (hex.x === undefined && hex.y === undefined) {
        Object.keys(hexMap).forEach((coord) => {
          const currNodes = hexMap[coord];
          hexMap[coord] = currNodes.filter((n) => n?.chart?.title !== node?.chart?.title);
        });
      } else {
        const nodes = hexMap[hex.x + "_" + hex.y];
        hexMap[hex.x + "_" + hex.y] = nodes.filter((n) => n?.chart?.title !== node?.chart?.title);
      }

      dispatch(updateHexMap(id, hexMap));

      if (isReplay !== true) {
        toast(
          <div
            onClick={() => {
              dispatch(updateHexMap(id, undoHexMap));
            }}
          >
            {"Chart " + node?.chart?.title + " has been removed. CLICK HERE TO UNDO REMOVAL"}
          </div>,
          {
            type: toast.TYPE.SUCCESS,
            position: toast.POSITION.TOP_CENTER,
            autoClose: 7500
          }
        );
      }
    }

    return Promise.resolve();
  };
}

export function getNodeFromMetadata(state, id, metadata) {
  const insight = getInsightFromMetadata(state, id, metadata, false);
  const fields = getFieldsFromChart(state, id, insight);

  return { chart: insight, fields: fields };
}

export function initGridDriver(id, initialHex = undefined, skipNew = false) {
  return (dispatch, getState) => {
    if (initialHex === undefined) {
      window.helpSavedActions = [];
    }

    const datasetId = getDatasetId(getState(), id);

    return dispatch(homeReducer.fetchDataset(datasetId)).then((dataset) => {
      dispatch(setupReducer.initNewSetup("new", datasetId));

      if (id === "new" && skipNew === false) {
        dispatch(nextTransformReducer.init(id));
        dispatch(nextModelsReducer.init(id));
      }

      const hexagonRadius = getHexagonRadius(getState(), id);
      let retHexMap = initialHex ? initialHex : { ...getHexMap(getState(), id) };

      const firstOrderInsights = getRelatedInsights(getState(), id);

      const firstOrderFields = firstOrderInsights
        .map((c) => getFieldsFromChart(getState(), id, c))
        .filter((fields) => fields && fields[0])
        .map((fields) => fields[0].label);

      return new Promise((resolve, reject) => {
        return setTimeout(() => {
          let topSecondOrderInsights = [];

          firstOrderFields.forEach((f) => {
            const metadata = {
              properties: [{ column: f }],
              type: "ModelDriver"
            };

            const rInsights = getInsightsFromMetadata(getState(), id, metadata)
              .map((c) => {
                const fields = getFieldsFromChart(getState(), id, c);

                return {
                  ...c,
                  fields
                };
              })
              .slice(0, 2);

            for (let insight of rInsights) {
              topSecondOrderInsights.push(insight);
            }
          });

          const bestCharts = firstOrderInsights
            .filter((c, i) => i < 6)
            .map((c) => {
              const fields = getFieldsFromChart(getState(), id, c);

              const column = c.metadata.properties.find((p) => p.type == "column")?.column;

              const retChart = {
                ...c,
                fields: fields,
                relatedCharts:
                  column == undefined
                    ? undefined
                    : topSecondOrderInsights
                        .filter(
                          (insight) => insight.metadata.properties.find((p) => p.type == "column")?.column == column
                        )
                        .slice(0, 2),
                otherRelatedCharts:
                  column == undefined
                    ? undefined
                    : topSecondOrderInsights
                        .filter(
                          (insight) => insight.metadata.properties.find((p) => p.type != "column")?.column == column
                        )
                        .slice(0, 4)
              };

              return retChart;
            });

          dispatch(updateBestCharts(id, bestCharts));

          let pinnedCharts = [];
          for (let i = 0; i < hexagonRadius * 2; i++) {
            for (let j = 0; j < hexagonRadius * 2; j++) {
              const nIndex = getNeighborFromPosition(getState(), id, i, j);

              if (nIndex !== undefined && dataset && firstOrderInsights && firstOrderInsights.length > nIndex) {
                const fieldLabel = firstOrderInsights[nIndex].chart.xAxis.label;

                const metadata = {
                  properties: [{ column: fieldLabel, type: "column" }],
                  type: "ModelDriver"
                };

                const rInsights = [getInsightFromMetadata(getState(), id, metadata)].map((c) => {
                  const fields = getFieldsFromChart(getState(), id, c);

                  return {
                    ...c,
                    fields
                  };
                });

                let retNode =
                  rInsights[0] && rInsights[0]?.chart
                    ? [
                        {
                          ...rInsights[0],
                          chart: {
                            ...rInsights[0],
                            scoreRank: rInsights[0].rank
                          },
                          x: i,
                          y: j,
                          isPath: true,
                          initialAnimation: true
                        }
                      ]
                    : [
                        {
                          x: i,
                          y: j,
                          chart: {
                            ...firstOrderInsights[nIndex],
                            title: fieldLabel,
                            scoreRank: firstOrderInsights[nIndex].rank
                          },
                          fields: getFieldsFromChart(getState(), id, firstOrderInsights[nIndex]),
                          isPath: true,
                          initialAnimation: true
                        }
                      ];

                if (retNode[0] && retNode[0].fields[0]) {
                  retNode[0].chart.color = retNode[0].fields[0].color;
                }

                retHexMap[i + "_" + j] = retNode;

                if (retNode?.[0]) {
                  pinnedCharts.push(retNode?.[0]);
                }
              }
            }
          }

          retHexMap[hexagonRadius + "_" + hexagonRadius] = [
            {
              x: hexagonRadius,
              y: hexagonRadius,
              fields: {},
              type: HEXAGON_NODES.MUSCLE
            }
          ];

          dispatch(updatePinnedHexList(id, pinnedCharts));
          dispatch(updateHexMap(id, retHexMap));

          const nRetHexMap = { ...getHexMap(getState(), id) };

          const midNeighbors = getNeighborLocation(hexagonRadius, hexagonRadius);

          for (const mKey of Object.keys(midNeighbors)) {
            const midNeighbor = midNeighbors[mKey];

            const hex = nRetHexMap[midNeighbor.x + "_" + midNeighbor.y]
              ? nRetHexMap[midNeighbor.x + "_" + midNeighbor.y][0]
              : {};

            const neighbors = getNeighborLocationEmpty(getState(), id, hex?.x, hex?.y, nRetHexMap);

            const nextCharts = topSecondOrderInsights.filter(
              (insight) =>
                insight.metadata.properties.find((p) => p.type == "column")?.column == hex?.fields?.[0]?.label
            );

            if (neighbors.length > 0) {
              for (let i = 0; i < nextCharts.length; i++) {
                const neighIndex =
                  Number(mKey) === 0
                    ? 0
                    : Number(mKey) === 5 && neighbors.length > 2
                      ? 2
                      : neighbors.length > 1
                        ? 1
                        : 0;

                const { x, y } = neighbors[neighIndex];

                //const { x, y } = neighbors[0];
                const chart = nextCharts[i];
                const sChart = {
                  x: x,
                  y: y,
                  chart: chart,
                  fields: getFieldsFromChart(getState(), id, chart),
                  isPath: true,
                  initialAnimation: true
                };

                (nRetHexMap[x + "_" + y] ??= []).push(sChart);

                pinnedCharts.push(sChart);
              }
            }
          }

          dispatch(updatePinnedHexList(id, pinnedCharts));
          dispatch(updateHexMap(id, nRetHexMap));
          return resolve();
        }, 8000);
      });
    });
  };
}

export function initGridEmpty(id) {
  return (dispatch, getState) => {
    const hexagonRadius = getHexagonRadius(getState(), id);

    let retHexMap = {};

    retHexMap[hexagonRadius + "_" + hexagonRadius] = [
      {
        x: hexagonRadius,
        y: hexagonRadius,
        fields: {},
        type: HEXAGON_NODES.MUSCLE
      }
    ];

    dispatch(updateHexMap(id, retHexMap));

    return Promise.resolve();
  };
}

export function initGrid(id, initialHex = undefined, gridType = "Default", comparisonOptions) {
  return (dispatch, getState) => {
    if (initialHex === undefined) {
      window.helpSavedActions = [];
    }

    const datasetId = getDatasetId(getState(), id);

    return dispatch(homeReducer.fetchDataset(datasetId)).then((dataset) => {
      dispatch(setupReducer.initNewSetup("new", datasetId));
      dispatch(checkIgnored(id, datasetId));

      const hexagonRadius = getHexagonRadius(getState(), id);
      let retHexMap = initialHex ? initialHex : { ...getHexMap(getState(), id) };

      // TODO: Move this into insights ("Difference" evaluation type)
      let fieldDifferences;
      if (comparisonOptions) {
        const cMetaData = getComparisonMetaData(getState(), id, comparisonOptions);

        const dateField = comparisonOptions?.dateField;
        const dataByColumn = {};
        cMetaData?.forEach((insight) => {
          const score = insight.score;
          const iMetadata = insight.metadata?.properties.find((p) => p.column !== dateField);
          const column = iMetadata?.column;
          if (!dataByColumn[column]) {
            dataByColumn[column] = {
              name: column,
              color: insight.color,
              children: [],
              score: score
            };
          }
          const name = insight.narrative?.conditionTitle ?? insight.title?.split(dateField + " when ").join("");
          dataByColumn[column].children.push({
            name: name,
            difference: insight.sortScore,
            rawDifference: insight.difference
          });
        });

        const hasScores = Object.keys(dataByColumn).find((k) => {
          const cData = dataByColumn[k];
          if (cData.score > 0) {
            return true;
          }
          return false;
        });

        if (!hasScores) {
          Object.keys(dataByColumn).forEach((key) => {
            const cData = dataByColumn[key];
            const totalDiff = cData.children.reduce((acc, c) => acc + c.difference, 0);
            cData.totalDifference = totalDiff;
            cData.score = totalDiff;
          });
        }

        fieldDifferences = dataByColumn;
      }

      let rawFirstOrderInsights = getRelatedInsights(
        getState(),
        id,
        undefined,
        {},
        undefined,
        undefined,
        comparisonOptions ? { limit: 5000 } : gridType === "Reverse" ? { goal: "worst" } : undefined
      ).filter((c, i) => {
        if (comparisonOptions) {
          const fields = Object.values(getFieldsFromChart(getState(), id, c)).filter((v) => v !== undefined);
          // return !fields.find((f) => f?.label === comparisonOptions.dateField);

          const isDateField = fields.find(
            (f) => f?.label === comparisonOptions.dateField || f?.label === `${comparisonOptions.dateField}_diff`
          );
          if (isDateField) {
            return false;
          }
          // const column = c.metadata.properties.find((p) => p.type == "column")
          //   ?.column;
          // const hasNoDifference = !fieldDifferences[column]?.score;
          // if (hasNoDifference) {
          //   return false;
          // }
        }
        return true;
      });

      if (comparisonOptions) {
        rawFirstOrderInsights.sort((a, b) => {
          const aColumn = a.metadata.properties.find(
            (p) => p.type == "column" && p.column !== comparisonOptions?.dateField
          )?.column;
          const bColumn = b.metadata.properties.find(
            (p) => p.type == "column" && p.column !== comparisonOptions?.dateField
          )?.column;
          const aDifference = fieldDifferences[aColumn]?.score;
          const bDifference = fieldDifferences[bColumn]?.score;
          return bDifference - aDifference;
        });
      }

      const firstOrderInsights = rawFirstOrderInsights.filter((f, i) => gridType !== "Reduced" || i < BESTCHART_SIZE);

      const firstOrderFields = firstOrderInsights
        .map((c) => getFieldsFromChart(getState(), id, c))
        .filter((fields) => fields && fields[0])
        .map((fields) => fields[0].label);

      let topSecondOrderInsights = [];

      // TODO: Unhackify This
      // Using Second order insights with the date field as the column then injecting the child graphs back into the parent
      if (comparisonOptions) {
        const datasetFields = homeReducer.getFields(getState(), datasetId);
        const dateField = comparisonOptions.dateField;

        topSecondOrderInsights = getRelatedInsights(getState(), id, [dateField], {}, undefined, "Difference", {
          limit: 5000
        }).map((c) => {
          const fields = getFieldsFromChart(getState(), id, c);

          return {
            ...c,
            fields
          };
        });
      } else {
        topSecondOrderInsights = getRelatedInsights(getState(), id, firstOrderFields, {}, undefined, undefined, {
          limit: 500
        }).map((c) => {
          const fields = getFieldsFromChart(getState(), id, c);

          return {
            ...c,
            fields
          };
        });
      }

      const topChildCharts = {};

      const bestCharts = firstOrderInsights
        .filter((c, i) => i < BESTCHART_SIZE)
        .map((c) => {
          const fields = getFieldsFromChart(getState(), id, c);

          const column = c.metadata.properties.find((p) => p.type == "column")?.column;

          let relatedSecondOrders;

          if (comparisonOptions) {
            relatedSecondOrders =
              column == undefined
                ? undefined
                : topSecondOrderInsights.filter((insight) =>
                    insight.metadata.properties.find((p) => p.column == column)
                  );

            topChildCharts[column] = relatedSecondOrders;
          } else {
            const tChild = getRelatedInsights(getState(), id, column, {}, undefined, "Descriptive");

            topChildCharts[column] = tChild;

            relatedSecondOrders =
              column == undefined
                ? undefined
                : topSecondOrderInsights.filter(
                    (insight) => insight.metadata.properties.find((p) => p.type == "column")?.column == column
                  );
          }

          const retChart = {
            ...c,
            fields: fields,
            relatedCharts: relatedSecondOrders.slice(0, 20),
            otherRelatedCharts: relatedSecondOrders.slice(20, 40)
          };

          return retChart;
        });

      dispatch(updateBestCharts(id, bestCharts));

      let sortScores = {};
      let pinnedCharts = [];
      for (let i = 0; i < hexagonRadius * 2; i++) {
        for (let j = 0; j < hexagonRadius * 2; j++) {
          const nIndex = getNeighborFromPosition(getState(), id, i, j);

          if (nIndex !== undefined && dataset && firstOrderInsights && firstOrderInsights.length > nIndex) {
            const fieldLabel = firstOrderInsights[nIndex].chart.xAxis.label;

            let retNode = [
              {
                x: i,
                y: j,
                chart: {
                  ...firstOrderInsights[nIndex],
                  title: fieldLabel,
                  childCharts: comparisonOptions ? topChildCharts[fieldLabel] : undefined
                },
                fields: getFieldsFromChart(getState(), id, firstOrderInsights[nIndex]),
                isPath: true,
                initialAnimation: true,
                sortScore: firstOrderInsights[nIndex]?.scoreRank * 1000,
                isComparison: comparisonOptions ? true : undefined
              }
            ];

            if (retNode[0] && retNode[0].fields[0]) {
              retNode[0].chart.color = retNode[0].fields[0].color;
            }

            retHexMap[i + "_" + j] = retNode;

            if (retNode?.[0]) {
              pinnedCharts.push(retNode?.[0]);
            }
          }
        }
      }

      retHexMap[hexagonRadius + "_" + hexagonRadius] = [
        {
          x: hexagonRadius,
          y: hexagonRadius,
          fields: {},
          type: HEXAGON_NODES.MUSCLE
        }
      ];

      dispatch(updateHexMap(id, retHexMap));
      dispatch(updatePinnedHexList(id, pinnedCharts));

      if (gridType === "Reduced") {
        return;
      }

      const nRetHexMap = { ...getHexMap(getState(), id) };

      const midNeighbors = getNeighborLocation(hexagonRadius, hexagonRadius);

      const chartsAdded = {};

      const getKey = (insight) => JSON.stringify(insight.metadata.properties);

      for (const mKey of Object.keys(midNeighbors)) {
        const midNeighbor = midNeighbors[mKey];

        const hex = nRetHexMap[midNeighbor.x + "_" + midNeighbor.y]
          ? nRetHexMap[midNeighbor.x + "_" + midNeighbor.y][0]
          : {};

        const neighbors = getNeighborLocationEmpty(getState(), id, hex.x, hex.y, nRetHexMap);

        /*
        const nextCharts = topSecondOrderInsights.filter(
          (insight) =>
            !chartsAdded[getKey(insight)] &&
            insight.metadata.properties.find(
              (p) =>
                p.column !== undefined && p.column === hex.fields?.[0]?.label
            )
        );
        */

        const nextCharts = topChildCharts?.[hex.fields?.[0]?.label];

        if (nextCharts !== undefined) {
          const MAX_CHILD_CHART_COUNT = 5;
          let chartsPerParent = {};
          let aChartsPerParent = {};

          let scoreCount = 0;
          if (neighbors.length > 0) {
            for (let i = 0; i < nextCharts.length; i++) {
              scoreCount++;

              const neighIndex =
                Number(mKey) === 0 ? 0 : Number(mKey) === 5 && neighbors.length > 2 ? 2 : neighbors.length > 1 ? 1 : 0;

              const { x, y } = neighbors[neighIndex];
              const chart = nextCharts[i];

              chartsAdded[getKey(chart)] = true;

              const fields = getFieldsFromChart(getState(), id, chart);
              const parent = hex.fields?.[0]?.label;

              if (aChartsPerParent[parent] === undefined) {
                aChartsPerParent[parent] = 0;
              } else {
                aChartsPerParent[parent] = aChartsPerParent[parent] + 1;
              }

              if (aChartsPerParent[parent] <= MAX_CHILD_CHART_COUNT) {
                const sortScore =
                  firstOrderInsights.find((ins) => ins?.chart?.xAxis?.label === hex.fields?.[0]?.label)?.scoreRank *
                  1000;

                const fIndex = topChildCharts[parent].findIndex(
                  (tC) => tC?.narrative?.title === chart?.narrative?.title
                );

                const sChart = {
                  x: x,
                  y: y,
                  chart: chart,
                  fields: getFieldsFromChart(getState(), id, chart),
                  isPath: true,
                  initialAnimation: true,
                  sortScore: sortScore === undefined ? 99999999999 : sortScore + (aChartsPerParent[parent] + 1),
                  rIndex: fIndex,
                  fromType: {
                    type: HEXAGON_NODES.DRILL_IN
                  },
                  parentField: hex.fields?.[0]?.label,
                  parent: {
                    fields: {
                      0: {
                        label: hex.fields?.[0]?.label,
                        color: hex.fields?.[0]?.color
                      }
                    }
                  },
                  isComparison: comparisonOptions ? true : undefined
                };

                (nRetHexMap[x + "_" + y] ??= []).push(sChart);
                pinnedCharts.push(sChart);
              }
            }
          }
        }
      }

      if (comparisonOptions) {
        const newPinnedCharts = pinnedCharts
          .map((chart) => {
            const insights = getInsightFromMetadata(getState(), id, chart?.chart?.metadata, false);

            const chartData = insights.chart.data.filter((d) => {
              return (
                !getIsReferenceDate(undefined, undefined, d?.name, comparisonOptions) ||
                !getIsCurrentDate(undefined, undefined, d?.name, comparisonOptions)
              );
            });

            let comparisonNarrative = {
              metrics: undefined,
              difference: 0,
              countChange: 0
            };

            if (chart?.chart?.metadata?.properties?.length > 1) {
              const metrics = getMetricsFromChartData(chartData, comparisonOptions);

              comparisonNarrative = {
                metrics: metrics?.newCount !== undefined ? metrics : undefined,
                difference: Math.abs(metrics?.difference ?? 0),
                countChange: Math.abs(metrics?.countChange ?? 0)
              };
            } else {
              const iMetadata = chart?.chart?.metadata?.properties.find(
                (p) => p.column !== comparisonOptions?.dateField
              );
              const column = iMetadata?.column;
              comparisonNarrative.difference = fieldDifferences[column]?.score;
            }

            chart.rawScore = comparisonNarrative.difference;
            chart.sortScore = Math.abs(comparisonNarrative.difference);

            return chart;
          })
          .sort((a, b) => {
            if (a.chart?.metadata?.properties?.length !== a.chart?.metadata?.properties?.length) {
              return a.chart?.metadata?.properties?.length - b.chart?.metadata?.properties?.length;
            }
            if (a.chart?.isSecondOrder && !b.chart?.isSecondOrder) {
              return 1;
            }
            if (b.chart?.isSecondOrder && !a.chart?.isSecondOrder) {
              return -1;
            }
            if (b.sortScore !== a.sortScore) {
              return b.sortScore - a.sortScore;
            }
            return a.chart.rank - b.chart.rank;
          });

        // newPinnedCharts.sort((a, b) => {
        //   const aColumn = a.metadata.properties.find((p) => p.type == "column" && p.column !== comparisonOptions?.dateField)
        //     ?.column;
        //   const bColumn = b.metadata.properties.find((p) => p.type == "column" && p.column !== comparisonOptions?.dateField)
        //     ?.column;

        //   if (aColumn !== bColumn) {
        //     const aDifference = fieldDifferences[aColumn]?.score;
        //     const bDifference = fieldDifferences[bColumn]?.score;
        //     return bDifference - aDifference;
        //   } else {
        //     return a?.narrative?.conditionTitle < b?.narrative?.conditionTitle ? -1 : 1
        //   }
        // });

        dispatch(updatePinnedHexList(id, newPinnedCharts));
      } else {
        dispatch(updatePinnedHexList(id, pinnedCharts));
      }
      return dispatch(updateHexMap(id, nRetHexMap));
    });
  };
}

export function createProject(id, runId, skipCheck = false, skipRedirect = false) {
  return (dispatch, getState) => {
    let proceedCheck =
      skipCheck === true
        ? true
        : confirm(
            "This will create a new project with your subgroup settings. Your todo list and microtasks will be preserved in the current project."
          );

    if (!proceedCheck) {
      return;
    }

    const setup = setupReducer.getSetup(getState(), runId) || {};
    const datasetId = setupReducer.getDatasetId(getState(), runId);
    const blueprintId = setupReducer.getBlueprintId(getState(), runId);

    const { defaultSetup, frontier, ...retSetup } = setup;

    dispatch(nextModelsReducer.updateViewTask(id, undefined));
    dispatch(updateActiveTab(id, "TRANSFORM"));

    dispatch(nextTransformReducer.updateIsCreating(id, true));

    dispatch(init(id, datasetId, undefined, blueprintId));

    dispatch(setupReducer.updateSetup(id, retSetup));

    const CREATE_HEX = {
      success: { ...setup?.success },
      leftSection: "CREATE",
      isSave: true
    };

    if (skipRedirect === true) {
      dispatch(updateDatasetId(id, datasetId));
    }

    // dispatch(push("/next/" + datasetId + "/new"))

    return dispatch(
      nextTransformReducer.createProjectHelper(id, undefined, CREATE_HEX, true, undefined, skipRedirect)
    ).then((reportId) => {
      if (getActiveTab(getState(), reportId) !== "MODELS") {
        dispatch(updateActiveTab("MODELS"));
      }

      return reportId;
    });
  };
}

export function createAndUpdateProject(id, runId) {
  return (dispatch, getState) => {
    dispatch(updateIsUpdatingProject(id, true));

    const oldSetup = setupReducer.getSetup(getState(), runId);

    return dispatch(setupReducer.initJobFromWizard(runId, undefined, { nextId: id })).then((projectId) => {
      const projects = { ...getProjects(getState(), id) };

      projects[oldSetup?.success?.value] = projectId;

      dispatch(updateProjects(id, projects));
      dispatch(updateProjectId(id, projectId));
      dispatch(updateActiveTab(id, "MODELS"));
      dispatch(nextModelsReducer.init(id));

      dispatch(updateIsUpdatingProject(id, false));

      return dispatch(saveNext(id, "New AI Creation Started", false));
    });
  };
}

export function clearAutosave(id) {
  return (dispatch, getState) => {
    const autosaveId = getAutosaveId(getState(), id);
    clearTimeout(autosaveId);
    dispatch(updateAutosaveId(id, undefined));
  };
}

export function saveNext(id, toastText = "Project Saved", showToast = true, skipRedirect = false, chatGPTOverride) {
  return async (dispatch, getState) => {
    const lastChatId = globalReducer.getLastOpenAIChat(getState());
    // Clear any existing autosave
    dispatch(clearAutosave(id));

    // Check target column and subgrouping and save in report
    // IMPORTANT: keep this synced when saving
    dispatch(checkAndUpdateProjectTargetAndSubgroup(id));

    const targetColumn = getTargetColumn(getState(), id);
    const splitColumn = getSplitColumn(getState(), id);

    const nData = { ...getNext(getState(), id) };
    delete nData.beforeReplayHexMap;
    delete nData.searchInsights;
    delete nData.isOpenSaveScenarioModal;
    delete nData.isSavingScenario;

    nData.isSavingReport = false;

    const projects = getProjects(getState(), id);
    if ((projects === undefined || Object.keys(projects).length === 0) && nData.success === undefined) {
      nData.success = setupReducer.getSuccess(getState(), "new");
    }

    const savedNextId = getSavedNextId(getState(), id);
    const retId = id === "new" && savedNextId !== undefined ? savedNextId : id;

    const nTransformData = {
      ...nextTransformReducer.getTransform(getState(), id)
    };
    const nModelsData = { ...nextModelsReducer.getModels(getState(), id) };

    let retExplorations = { ...reportReducer.getExplorations(getState(), id) };

    const explorationKey = getExplorationKey(getState(), id);
    retExplorations[explorationKey] = nData;

    let projectId = undefined;
    let exploreProjects = projects ?? {};
    Object.keys(retExplorations).forEach((eKey) => {
      if (retExplorations[eKey]?.projectId !== undefined) {
        projectId = retExplorations[eKey]?.projectId;
        if (Object.keys(exploreProjects).length < Object.keys(retExplorations[eKey]?.projects ?? {}).length) {
          exploreProjects = retExplorations[eKey]?.projects;
        }
      }
      // Inject target columns and split columns into older explorations
      if (retExplorations[eKey]) {
        if (targetColumn !== undefined && retExplorations[eKey].targetColumn !== targetColumn) {
          retExplorations[eKey].targetColumn = targetColumn;
        }
        if (splitColumn !== undefined && retExplorations[eKey].splitColumn !== splitColumn) {
          retExplorations[eKey].splitColumn = splitColumn;
        }
        const isDeployed = projectReducer.getDeployedScenarioIndex(getState(), projectId) !== undefined;
        if (isDeployed && retExplorations[eKey].isDeployed !== isDeployed) {
          retExplorations[eKey].isDeployed = isDeployed;
        }
      }
    });
    if (projectId !== undefined) {
      Object.keys(retExplorations).forEach((eKey) => {
        retExplorations[eKey].projectId = projectId;
        retExplorations[eKey].projects = exploreProjects;
      });
    }

    const nMonitoringData = {
      ...nextMonitoringReducer.getNextMonitoring(getState(), id)
    };

    const accountId = chatGPTReducer.getChatGPTAccountId(getState());
    const activeTab = getActiveTab(getState(), id);

    let baseChatGPT;
    if (chatGPTOverride) {
      baseChatGPT = chatGPTOverride;
    } else {
      baseChatGPT = chatGPTReducer.getBase(getState());
    }
    const rawChatGPTConvo = {
      ...(baseChatGPT || {}),
      isAsking: false,
      accountId: accountId,
      hoverChart: {},
      showChart: {},
      showSettings: false,
      isCreatingOptimize: false
    };

    // Remove the chance of state mutation from deleting keys
    const nChatGPTConvo = JSON.parse(JSON.stringify(rawChatGPTConvo));

    // Remove ChatGPTReducer keys we don't want to save;
    if (nChatGPTConvo.KPIChartSummary) {
      nChatGPTConvo.KPIChartSummary = { ...nChatGPTConvo.KPIChartSummary };
      for (const summaryKey in nChatGPTConvo.KPIChartSummary) {
        const currSumm = nChatGPTConvo.KPIChartSummary[summaryKey];
        const INVALID_VALUES = [
          "LOADING"
          // "RETRY",
        ];
        if (!currSumm || INVALID_VALUES.includes(currSumm)) {
          delete nChatGPTConvo.KPIChartSummary[summaryKey];
        }
      }
    }
    // Remove in progress deep dives
    if (nChatGPTConvo.KPIDeepDives) {
      nChatGPTConvo.KPIDeepDives = { ...nChatGPTConvo.KPIDeepDives };
      for (const kpiKey in nChatGPTConvo.KPIDeepDives) {
        const currDeepDive = nChatGPTConvo.KPIDeepDives[kpiKey];
        if (!currDeepDive || currDeepDive.status !== "DONE") {
          delete nChatGPTConvo.KPIDeepDives[kpiKey];
        }
      }
    }
    const DELETE_KEYS = ["KPIAnalysisResults", "KPIDates", "KPIChartsLoaded", "shouldSyncDatasetDateRange"];
    DELETE_KEYS.forEach((k) => {
      if (k in nChatGPTConvo) {
        delete nChatGPTConvo[k];
      }
    });

    const next = {
      transforms: nTransformData,
      models: nModelsData,
      explorations: retExplorations,
      monitoring: nMonitoringData,
      chatGPTConvo: nChatGPTConvo,
      savedTab: activeTab
    };

    const projectFolderId = globalReducer.getProjectFolderId(getState());
    const selectedFolderId = foldersReducer.getSelectedFolder(getState());

    if (projectFolderId !== undefined && projectFolderId !== selectedFolderId) {
      dispatch(foldersReducer.selectFolder(projectFolderId));
    }

    const folderId = projectFolderId !== undefined ? projectFolderId : selectedFolderId;

    const reportLabel = getReportLabel(getState(), id);

    dispatch(updateIsSavingReport(id, true));

    console.log("saving what is retId", retId);

    const mProjectId = retExplorations?.[0]?.projectId;
    const linkedProjectId = projectReducer.getLinkedProjectId(getState(), mProjectId);
    if (mProjectId !== undefined && linkedProjectId !== undefined) {
      //dispatch(projectReducer.saveScenario(projectId, "Default Scenario"));
      //dispatch(projectReducer.saveScenario(linkedProjectId, "Default Scenario"));

      dispatch(projectReducer.updateAllScenariosWithLinkedRuns(mProjectId));
    }

    if (retId === "new") {
      const activeTab = getActiveTab(getState(), retId);

      return ReportAPI.createReport(folderId, next, reportLabel)
        .then((response) => {
          dispatch(updateReportR(response.id, { ...response }));
          dispatch(updateReportR("new", { ...response }));
          dispatch(reportReducer.reloadReport(response.id));

          dispatch(updateSavedNextId(id, response.id));

          dispatch(updateIsSavingReport(id, false));

          const datasetId = getDatasetId(getState(), id) ?? "new";

          let currNext = getNext(getState(), id);
          try {
            currNext = JSON.parse(JSON.stringify(currNext));
          } catch (e) {
            console.log(e);
          }
          dispatch(updateNext(response.id, currNext));

          dispatch(updateActiveTab(response.id, activeTab));

          if (skipRedirect) {
            dispatch(updateIsSavingReport(id, false));
            return response.id;
          }

          return dispatch(
            init(response.id, datasetId, true, undefined, undefined, undefined, undefined, undefined, true)
          ).then(() => {
            if (showToast) {
              toast(<div>{toastText}</div>, {
                type: toast.TYPE.SUCCESS,
                position: toast.POSITION.TOP_CENTER,
                autoClose: 7500
              });
            }

            const currentChatId = globalReducer.getLastOpenAIChat(getState());
            if (currentChatId === lastChatId) {
              if (globalReducer.getIsTableauMode(getState())) {
                dispatch(push("/project_next/" + response.id));
              } else {
                dispatch(push("/next/" + datasetId + "/" + response.id));
                dispatch(updateCurrentNextId(response.id));
              }
            }
            return response.id;
          });
        })
        .catch((e) => {
          console.log(e);
          if (showToast) {
            toast(
              <div>
                {"There was an error saving your project. Please contact aible support if this issue persists."}
              </div>,
              {
                type: toast.TYPE.ERROR,
                position: toast.POSITION.TOP_CENTER,
                autoClose: 7500
              }
            );
          }
          dispatch(updateIsSavingReport(id, false));
          throw e;
        });
    } else {
      return ReportAPI.updateReport(retId, next)
        .then((response) => {
          dispatch(updateReportR(response.id, { ...response }));
          dispatch(updateIsSavingReport(id, false));

          if (showToast)
            toast(<div>{toastText}</div>, {
              type: toast.TYPE.SUCCESS,
              position: toast.POSITION.TOP_CENTER,
              autoClose: 7500
            });

          return retId;
        })
        .catch((e) => {
          console.log(e);
          if (showToast) {
            toast(
              <div>
                {"There was an error saving your project. Please contact aible support if this issue persists."}
              </div>,
              {
                type: toast.TYPE.ERROR,
                position: toast.POSITION.TOP_CENTER,
                autoClose: 7500
              }
            );
          }
          dispatch(updateIsSavingReport(id, false));
          throw e;
        });
    }
  };
}

export function initExploration(id) {
  return (dispatch, getState) => {
    const explorations = reportReducer.getExplorations(getState(), id) ?? {};
    const explorationKeys = Object.keys(explorations);

    if (explorationKeys && explorationKeys.length) {
      const retExplorationKey = Math.max(...explorationKeys);
      dispatch(updateExplorationKey(id, retExplorationKey, ["activeTab"]));
    }
  };
}

export function updateNextMonitoringFromResponse(id, response) {
  return (dispatch, getState) => {
    if (response?.metadata?.monitoring && Object.keys(response.metadata.monitoring).length > 0) {
      dispatch(
        nextMonitoringReducer.updateNextMonitoring(id, {
          ...response.metadata.monitoring
        })
      );
      // dispatch(
      //   nextMonitoringReducer.checkMonitoringSummary(id, {
      //     ...response.metadata,
      //   })
      // );
    } else {
      dispatch(nextMonitoringReducer.init(id));
    }
  };
}

export function initSubmodules(id, response, skipNextMonitoring = false) {
  return (dispatch, getState) => {
    if (response.metadata.transforms && Object.keys(response.metadata.transforms).length > 0) {
      dispatch(
        nextTransformReducer.updateTransform(id, {
          ...response.metadata.transforms
        })
      );
    } else {
      dispatch(nextTransformReducer.init(id));
    }

    if (!skipNextMonitoring) {
      dispatch(updateNextMonitoringFromResponse(id, response));
    }

    const cNext = nextModelsReducer.getModels(getState(), id);

    if (cNext === undefined || Object.keys(cNext).length <= 1) {
      if (response.metadata.models && Object.keys(response.metadata.models).length > 0) {
        dispatch(
          nextModelsReducer.updateModels(id, {
            ...response.metadata.models,
            isLoading: cNext?.isLoading
          })
        );

        dispatch(nextModelsReducer.checkSplits(id));
      } else {
        dispatch(nextModelsReducer.init(id));
      }
    }

    dispatch(nextModelsReducer.checkBlueprint(id));

    dispatch(initExploration(id));
  };
}

export function updateGridType(id, gridType, skipNew = false, comparisonOptions) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      key: "gridType",
      data: gridType
    });

    dispatch(updateHexMap(id, {}));

    if (gridType === "ModelDriver") {
      return dispatch(initGridDriver(id, undefined, skipNew));
    } else if (gridType === "Empty") {
      return dispatch(initGridEmpty(id));
    } else {
      return dispatch(initGrid(id, undefined, gridType, comparisonOptions));
    }
  };
}

export function updateSearchNLQ(id, NLQ) {
  return (dispatch, getState) => {
    const datasetId = getDatasetId(getState(), id);
    const dataset = homeReducer.getDataset(getState(), datasetId);

    const splitNLQ = NLQ.split(" ");

    let pFields = [];

    splitNLQ
      .filter((word) => word.length > 2)
      .forEach((word) => {
        const foundField = Object.keys(dataset.fields).find(
          (field) => field.toLowerCase().indexOf(word.toLowerCase()) !== -1
        );
        if (foundField !== undefined && pFields.find((f) => f === foundField) === undefined) {
          pFields.push(foundField);
        }
      });

    let foundValue = undefined;
    let foundValueField = undefined;

    splitNLQ
      .filter((word) => word.length > 2)
      .forEach((word) => {
        pFields.forEach((pKey) => {
          const fValue = dataset.fields[pKey].data.find((pd) => pd.value.toLowerCase() === word.toLowerCase());

          if (fValue !== undefined) {
            foundValue = fValue?.value;
            foundValueField = pKey;
          }
        });
      });

    if (pFields.length === 0) {
      return Promise.resolve();
    }

    let metadata = {
      properties:
        foundValue && foundValueField
          ? [
              { type: "column", column: foundValueField },
              { column: foundValueField, value: foundValue }
            ]
          : pFields.filter((word, i) => i < 2).map((word) => ({ type: "column", column: word })),
      type: undefined
    };

    const oSearch = searchTypeOptions.filter((s) => s.value !== "All Insights" && s.value !== "NLQ");

    let retInsights = [];

    oSearch.forEach((o) => {
      metadata.type = o.value;

      const sInsights = getInsightAndRelatedFromMetadata(getState(), id, metadata, true);

      if (
        sInsights.length > 0 &&
        retInsights.find(
          (insight) =>
            sInsights[0]?.narrative?.title === insight?.narrative?.title &&
            sInsights[0]?.metadata?.type === insight?.metadata?.type
        ) === undefined
      ) {
        retInsights.push(sInsights[0]);
      }
      if (
        sInsights.length > 1 &&
        retInsights.find(
          (insight) =>
            sInsights[1]?.narrative?.title === insight?.narrative?.title &&
            sInsights[1]?.metadata?.type === insight?.metadata?.type
        ) === undefined
      ) {
        retInsights.push(sInsights[1]);
      }
    });

    return dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      data: retInsights.map((c) => ({
        ...c,
        fields: getFieldsFromChart(getState(), id, c)
      })),
      key: "searchInsights"
    });
  };
}

export function updateDatasetId(id, datasetId) {
  return (dispatch, getState) => {
    dispatch(chatAppReducer.updateStep(datasetId, "datasetId"));

    return dispatch({
      type: UPDATE_FIELD_VALUE,
      id: id,
      key: "datasetId",
      data: datasetId
    });
  };
}

export function updateReportLabelAndContentGenerationCollection(id, newLabel) {
  return async (dispatch, getState) => {
    const cgCollectionId = chatGPTReducer.getCollectionId(getState());

    if (cgCollectionId) {
      dispatch(contentGenerationReducer.updateCollection(cgCollectionId, { name: newLabel }));
    }

    dispatch(updateReportLabel(id, newLabel));
  };
}

export function updateDatasetSuccess(id, success) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "success",
    data: success
  };
}

export function checkIgnored(id, datasetId) {
  return (dispatch, getState) => {
    const dataset = homeReducer.getDataset(getState(), datasetId);

    const ignoredColumns = dataset?.transformations?.exclude_columns;

    if (ignoredColumns && ignoredColumns.length > 0) {
      ignoredColumns.forEach((column) => {
        dispatch(setupReducer.updateIgnored(id, column, true));
      });
    }

    const projections = dataset?.transformations?.projections;

    if (projections) {
      for (const p of projections) {
        if (typeof p != "string" && "column" in p && ["categorical", "category"].includes(p["col_type"])) {
          setupReducer.updateFieldTypes("new", p["column"], "Categorical");
        }
      }
    }
  };
}

export function initDashboardAndOpen() {
  return async (dispatch, getState) => {
    const nextId = getCurrentNextId(getState());
    const datasetId = getDatasetId(getState());

    await dispatch(nextTransformReducer.createDefaultExplore(nextId, undefined));

    return dispatch(updateActiveTab(nextId, "DASHBOARD"));
  };
}

export function initDashboard(datasetId) {
  return (dispatch, getState) => {
    return dispatch(init("new", datasetId)).then(async (e) => {
      await dispatch(nextTransformReducer.createDefaultExplore("new", undefined));
    });
  };
}

export function init(
  id,
  datasetId,
  isCurrent = false,
  blueprintId,
  forceExploreCreate = false,
  isChatGPT = false,
  selectedBlueprintId,
  uiState,
  skipLoading = false,
  skipUpdateActiveTab = false,
  isBackground = false,
  forceChatTab = false,
  skipAskIntro = false,
  reportLabelOverride = undefined,
  scrollToSection = undefined
) {
  const retryPromise = (callback, numRetries = 0, maxRetries = 10) => {
    return callback()
      .then((r) => r)
      .catch((e) => {
        console.log(e);
        if (numRetries === 2) {
          toast("I am having a hard time opening the dataset but I will keep trying.", {
            type: toast.TYPE.ERROR,
            position: toast.POSITION.TOP_CENTER,
            autoClose: 7500
          });
        }

        if (numRetries > maxRetries) {
          throw e;
        }
        return retryPromise(callback, numRetries + 1);
      });
  };
  return (dispatch, getState) => {
    let checkShareApp = () => Promise.resolve();
    if (uiState?.type === "SHARE") {
      checkShareApp = () => {
        const url = uiState?.url;

        const userId = loginReducer.getUserID(getState());
        const email = loginReducer.getUserEmail(getState());

        const payload = {
          role_user: userId,
          role_user_email: email,
          role_type: chatAppReducer.CHATAPP_ROLE
        };

        return dispatch(chatAppReducer.executePresignedShare(url, payload, uiState?.name, uiState?.method));
      };
    } else if (uiState?.type === "SHARE_LINK") {
      const savedUiState = globalReducer.getUiState(getState());
      if (savedUiState?.type !== "SHARE_LINK") {
        const queryParams = `?ui-state=${chatAppReducer.encodeUiState(uiState)}`;
        const path = "/login";
        dispatch(
          push({
            pathname: path,
            search: queryParams
          })
        );
        dispatch(loginReducer.handleLogout({ redirect: false }));
        throw new Error("Logging out");
      }
    }

    return checkShareApp().then(() => {
      // This skips the init so we don't double init for the Sense buttons.
      // We should find a better solution.
      if (globalReducer.getIsSkipNextInit(getState()) === true) {
        dispatch(globalReducer.updateIsSkipNextInit(undefined));
        return Promise.resolve();
      }

      let checkBlueprint = () => Promise.resolve();
      const blueprint = blueprintId ? blueprintReducer.getBlueprint(getState(), blueprintId) : undefined;
      const selectedFolderId = foldersReducer.getSelectedFolder(getState());
      if (blueprintId && (!blueprint?.id || Number(blueprint?.folder_id) !== Number(selectedFolderId))) {
        checkBlueprint = () => {
          return (() => {
            if (!blueprint?.id) {
              return dispatch(blueprintReducer.fetchBlueprint(blueprintId))
                .then((r) => r)
                .catch((e) => console.log(e));
            }
            return Promise.resolve(blueprint);
          })().then(() => {
            const blueprint = blueprintReducer.getBlueprint(getState(), blueprintId);
            if (blueprint?.folder_id && Number(blueprint?.folder_id) !== Number(selectedFolderId)) {
              return dispatch(foldersReducer.selectFolder(blueprint?.folder_id))
                .then((r) => r)
                .catch((e) => console.log(e));
            }

            return Promise.resolve();
          });
        };
      }

      return checkBlueprint().then(() => {
        const activeTab = getActiveTab(getState(), id);
        if (activeTab === "CHATGPT" && !skipLoading) {
          dispatch(globalReducer.updateIsNextLoading(true));
        }

        if (activeTab === "CHATGPT") {
          isChatGPT = true;
        }

        if (
          (isEnabled("chat-aible-consumer") && !isEnabled("aible-optimize")) ||
          globalReducer.getShouldSwitchToGPT(getState())
        ) {
          isChatGPT = true;
          dispatch(globalReducer.updateShouldSwitchToGPT(undefined));
        }

        if (id !== "new") {
          let datasetPromise = Promise.resolve();
          if (datasetId !== undefined && datasetId !== "new" && datasetId !== "undefined" && !isNaN(datasetId)) {
            datasetPromise = retryPromise(() => {
              return dispatch(homeReducer.fetchDataset(datasetId, undefined, true));
            });
          }

          // Get the report, switch folders if necessary, then get the dataset
          return ReportAPI.getReport(id).then((reportResponse) => {
            let folderPromise = Promise.resolve();
            const currFolderId = foldersReducer.getSelectedFolder(getState());
            if (currFolderId !== reportResponse.folder_id) {
              folderPromise = dispatch(foldersReducer.selectFolder(reportResponse.folder_id));
            }

            return folderPromise.then(() => {
              return datasetPromise.then(async () => {
                // we only care about the report response
                const response = reportResponse;

                // Whether to load the KPI analysis results
                let shouldRefreshKPIAnalaysis = false;

                dispatch(reportReducer.updateReportR(id, response));

                let retNext = response?.metadata?.next
                  ? { ...response.metadata.next }
                  : response?.metadata?.explorations && Object.keys(response?.metadata?.explorations).length > 0
                    ? response?.metadata?.explorations[0]
                    : { ...response.metadata };

                if (!retNext) {
                  retNext = {};
                }

                const savedTab = response?.metadata?.savedTab;

                if (forceChatTab) {
                  retNext.activeTab = "CHATGPT";
                } else {
                  retNext.activeTab = savedTab ?? activeTab ?? retNext?.activeTab;
                }

                // If we're skipping loading, we're gonna initialize chatgpt with the current values
                let baseGPT = {};
                if (skipLoading) {
                  baseGPT = chatGPTReducer.getBase(getState());
                }

                const chatGPTConvo = {
                  ...baseGPT,
                  ...(response?.metadata?.chatGPTConvo || {})
                };
                chatGPTConvo.hoverChart = {};
                chatGPTConvo.showChart = {};

                const savedChartsOrder = chatGPTConvo.KPIChartsOrder;
                const savedDateRange = chatGPTConvo.KPIDateRange;

                // If this is a KPI Analaysis project, load the analysis if we're not skipping
                if (savedChartsOrder && savedDateRange && (!skipLoading || !chatGPTConvo.KPIAnalysisResults)) {
                  shouldRefreshKPIAnalaysis = true;
                }

                if (isBackground !== true) {
                  dispatch(chatGPTReducer.updateBase(chatGPTConvo));
                }

                const optimizeSetup = chatGPTReducer.getOptimizeSetup(getState());

                if (optimizeSetup?.blueprintId !== undefined) {
                  dispatch(blueprintReducer.initBlueprint(optimizeSetup?.blueprintId, optimizeSetup?.runId));
                  dispatch(blueprintReducer.checkEvaluator(optimizeSetup?.blueprintId, optimizeSetup?.runId));

                  if (chatGPTReducer.getIsOptimizeModelsRunning(getState()) === true) {
                    dispatch(chatGPTReducer.handleOptimizeJobWaiter());
                  }
                }

                if (chatGPTConvo.artifactId) {
                  const artifact = llmReducer.getCorpus(getState(), chatGPTConvo.artifactId);
                  if (!artifact?.id) {
                    try {
                      await dispatch(llmReducer.fetchCorpus(chatGPTConvo.artifactId));
                    } catch (e) {
                      console.log(e);
                      toast(
                        "Unable to load data. Please check that you have access to the folder this project is located in and that the data associated with this project has not been deleted.",
                        {
                          type: toast.TYPE.ERROR,
                          position: toast.POSITION.TOP_CENTER,
                          autoClose: 7500
                        }
                      );
                    }
                  }
                }

                if (chatGPTConvo.clawAgentId) {
                  try {
                    await dispatch(aibleAnywhereReducer.initClaw(chatGPTConvo.clawAgentId));
                  } catch (e) {
                    console.log(e);
                  }
                }

                if (retNext?.agentAutonomyView !== undefined) {
                  dispatch(viewReducer.updateAgentAutonomyView(retNext?.agentAutonomyView));
                }

                // WARNING: Race condition
                // Let's turn this function async so we can use awaits instead of these chained promises :|
                const chatFlow = chatGPTReducer.getChatFlow(getState());
                if (chatFlow === "REASONING") {
                  dispatch(chatDetailsReducer.fetchReportChatMessageDetails(id));
                }

                dispatch(chatGPTReducer.fetchDatasetsFromConversation());

                const loadNexts = {};
                const idList = chatGPTConvo?.conversation
                  ? Object.keys(chatGPTConvo?.conversation)
                      .filter((cKey) => hasOutputContent(chatGPTConvo?.conversation[cKey]))
                      .map((cKey) => chatGPTConvo?.conversation[cKey])
                  : [];

                idList.forEach((ids) => {
                  getMessageContentReferenceData(ids)
                    .filter((id) => id?.datasetId !== undefined)
                    .forEach((id) => {
                      loadNexts[id?.datasetId] = true;
                    });
                });

                const datasetList = chatGPTConvo?.conversation
                  ? Object.keys(chatGPTConvo?.conversation)
                      .filter((cKey) => chatGPTConvo?.conversation[cKey].datasets !== undefined)
                      .map((cKey) => chatGPTConvo?.conversation[cKey])
                  : [];

                datasetList.forEach((convo) => {
                  convo.datasets
                    .filter((dataset) => dataset?.id !== undefined)
                    .forEach((dataset) => {
                      loadNexts[dataset?.id] = true;
                    });
                });

                Object.keys(loadNexts).forEach((dKey) => {
                  dispatch(initNextChatGPT(dKey));
                });

                if (Object.keys(chatGPTConvo).length === 0 && isBackground !== true) {
                  dispatch(chatGPTReducer.updateConversation({}));
                }

                const storedDatasetId = retNext?.datasetId;

                dispatch(updateNext(id, retNext));

                if (shouldRefreshKPIAnalaysis) {
                  await dispatch(chatGPTReducer.handleKPIAnalysis(true, false, id, true));
                  dispatch(chatGPTReducer.fetchKPIDeepDives());
                }

                // TODO: Remove this when we move values to dataset options
                const comparisonOptions = getComparisonOptions(getState(), id);

                const chatType = chatGPTReducer.getChatType(getState());

                if (isCurrent === true || true) {
                  dispatch(updateCurrentNextId(id));

                  const projects = getProjects(getState(), id);
                  const exploreProjectId = getExploreProjectId(getState(), id);

                  if (projects === undefined || Object.keys(projects).length === 0) {
                    dispatch(initSubmodules(id, response));

                    dispatch(setupReducer.updateDatasetId("new", datasetId));
                    if (datasetId !== undefined && datasetId !== "new") {
                      dispatch(checkIgnored("new", datasetId));
                    }
                    const success = getDatasetSuccess(getState(), id);
                    if (success) {
                      dispatch(setupReducer.updateSuccess("new", success));
                    }

                    const dataset = homeReducer.getDataset(getState(), datasetId);

                    if (dataset?.transformations?.projections) {
                      const projections = dataset?.transformations?.projections ?? [];

                      for (const p of projections) {
                        if (
                          typeof p != "string" &&
                          "column" in p &&
                          ["categorical", "category"].includes(p["col_type"])
                        ) {
                          setupReducer.updateFieldTypes("new", p["column"], "Categorical");
                        }
                      }
                    }

                    const promise =
                      exploreProjectId === undefined
                        ? Promise.resolve()
                        : dispatch(projectReducer.init(exploreProjectId));

                    promise.then(() => dispatch(globalReducer.updateIsNextLoading(false)));
                  } else {
                    Object.keys(projects).forEach((pKey, i) => {
                      const projectId = projects[pKey];

                      dispatch(updateNextMonitoringFromResponse(id, response));
                      dispatch(projectReducer.init(projectId)).then((e) => {
                        if (i === 0) {
                          dispatch(initSubmodules(id, response, true));
                          if (datasetId !== undefined && datasetId !== "new") {
                            dispatch(checkIgnored(id, datasetId));
                          }

                          dispatch(globalReducer.updateIsNextLoading(false));

                          if (scrollToSection === "OPTIMIZE") {
                            dispatch(chatGPTReducer.handleOptimizeScrollToResults());
                          }
                        }
                      });
                    });
                  }
                } else {
                }

                //return dispatch(nextTransformReducer.init(id));

                //return dispatch(initGrid(id));

                const chatApp = chatGPTReducer.getChatApp(getState());

                if (chatApp?.wizard?.steps !== undefined) {
                  dispatch(chatAppReducer.updateSteps(chatApp?.wizard?.steps));
                  dispatch(updateIsSavingReport(id, false));
                  //dispatch(chatGPTReducer.initChatApp(chatApp));
                }

                if (storedDatasetId && storedDatasetId !== "new" && Number(datasetId) !== storedDatasetId) {
                  dispatch(homeReducer.fetchDataset(storedDatasetId, undefined, true));
                }

                const chatProjectType = chatGPTReducer.getProjectType(getState());
                const isStartInDashboard = chatAppReducer.getStartInDashboard(getState());

                if (skipUpdateActiveTab !== true) {
                  if (savedTab) {
                    dispatch(updateActiveTab(id, savedTab));
                  } else if (chatProjectType === "KPI") {
                    if (isStartInDashboard === false) {
                      dispatch(updateActiveTab(id, "CHATGPT"));
                    } else {
                      dispatch(updateActiveTab(id, "KPI DASHBOARD"));
                    }
                  } else if (
                    isChatGPT ||
                    Object.keys(chatGPTConvo?.conversation || {}).length > 0 ||
                    datasetId === "new" ||
                    datasetId === undefined
                  ) {
                    if (isStartInDashboard === true) {
                      dispatch(updateActiveTab(id, "NLQ Dashboard"));
                    } else {
                      dispatch(updateActiveTab(id, "CHATGPT"));
                    }
                  } else if (activeTab === "EXPLORE") {
                    if (!comparisonOptions) {
                      const defaultView = getExploreDefaultViewMode(getState());
                      dispatch(updateActiveTab(id, defaultView));
                    }
                  }
                }
              });
            });
          });
        } else {
          const retLabel = reportLabelOverride ? reportLabelOverride : "New Chat";

          const retNext = {
            ...initialNext,
            datasetId: datasetId,
            activeTab: activeTab,
            reportLabel: retLabel,
            agentAutonomyView: viewReducer.getAgentAutonomyView(getState())
          };

          const rSetup = setupReducer.getSetup(getState(), id);

          if (rSetup?.blueprintId) {
            const blueprint = blueprintReducer.getBlueprint(getState(), rSetup.blueprintId);
            if (blueprint?.name) retNext.reportLabel = blueprint.name;
          } else {
            const dataset = datasetReducer.getDataset(getState(), datasetId);
            if (dataset?.name) retNext.reportLabel = dataset.name;
          }

          dispatch(updateNext(id, retNext));

          dispatch(nextTransformReducer.init(id));
          dispatch(nextModelsReducer.init(id));

          dispatch(reportReducer.localDeleteReport("new"));

          dispatch(updateCurrentNextId("new"));

          // TODO: Remove this when we move values to dataset options
          const comparisonOptions = getComparisonOptions(getState(), id);

          const blueprint = blueprintReducer.getBlueprint(getState(), blueprintId);
          const hasSetup = Boolean(blueprint?.wizard?.setup);

          if (blueprint?.wizard?.fewShotExamples && Object.keys(blueprint?.wizard?.fewShotExamples ?? {}).length > 0) {
            dispatch(updateFewShotExamples(id, blueprint?.wizard?.fewShotExamples));
            dispatch(updateIsFewShotEnabled(id, true));
          }

          // Creating a new blueprint entry
          if (blueprintId === "new" || (blueprintId !== undefined && (!blueprint || hasSetup))) {
            // Select costs step if new blueprint
            if (blueprintId === "new") {
              const mHexMap = nextModelsReducer.getHexMap(getState(), id);
              const fKey = Object.keys(mHexMap).find((s) => mHexMap[s]?.id === "OPTIMIZE");

              if (fKey) {
                dispatch(nextModelsReducer.updateSelectedHex(id, { x: 8, y: 7 }, mHexMap[fKey]));

                const mActionHexMap = nextModelsReducer.getActionHexMap(getState(), id);

                const aKey = Object.keys(mActionHexMap).find((a) => mActionHexMap[a]?.id === "OPTIMIZE_BLUEPRINT");

                if (aKey) {
                  dispatch(nextModelsReducer.updateSelectedHex(id, { x: 9, y: 7 }, mActionHexMap[aKey]));
                }
              }
            }

            const datasetPromise = () => {
              if (datasetId !== undefined && datasetId !== "new" && datasetId !== "undefined") {
                return retryPromise(() => dispatch(homeReducer.fetchDataset(datasetId, undefined, true)));
              }
              return Promise.resolve();
            };
            return datasetPromise()
              .then(() => {
                if (datasetId !== undefined && datasetId !== "new" && datasetId !== "undefined") {
                  dispatch(checkIgnored(id, datasetId));
                  dispatch(checkAndSetDateField(datasetId, "new"));
                }
                dispatch(createBlueprintSetup(id, datasetId, blueprintId));

                return dispatch(globalReducer.updateIsNextLoading(false));
              })
              .catch((e) => {
                console.log(e);
                dispatch(createBlueprintSetup(id, datasetId, blueprintId));
                return dispatch(globalReducer.updateIsNextLoading(false));
              });
          }

          const selectedBlueprint = blueprintReducer.getBlueprint(getState(), selectedBlueprintId);
          const activeTab = getActiveTab(getState(), id);
          const chatProjectType = chatGPTReducer.getProjectType(getState());
          const isStartInDashboard = chatAppReducer.getStartInDashboard(getState());
          if (skipUpdateActiveTab !== true) {
            if (chatProjectType === "KPI") {
              if (isStartInDashboard === false) {
                dispatch(updateActiveTab(id, "CHATGPT"));
              } else {
                dispatch(updateActiveTab(id, "KPI DASHBOARD"));
              }
            } else if (
              isChatGPT ||
              Boolean(selectedBlueprint?.wizard?.chatGPT) ||
              datasetId === "new" ||
              datasetId === undefined
            ) {
              const chatApp = chatGPTReducer.getChatApp(getState());
              if (isStartInDashboard === true) {
                dispatch(updateActiveTab(id, "NLQ Dashboard"));
              } else {
                dispatch(updateActiveTab(id, "CHATGPT"));
              }
            } else if (activeTab === "EXPLORE" && forceExploreCreate) {
              if (!comparisonOptions) {
                const defaultView = getExploreDefaultViewMode(getState());
                dispatch(updateActiveTab(id, defaultView));
              }
            } else {
              dispatch(updateActiveTab(id, "TRANSFORM"));
            }
          }

          const datasetPromise = () => {
            if (datasetId !== undefined && datasetId !== "new" && datasetId !== "undefined") {
              return retryPromise(() => dispatch(homeReducer.fetchDataset(datasetId, undefined, true)));
            }
            return Promise.resolve();
          };
          return datasetPromise()
            .then(async (dataset) => {
              dispatch(setupReducer.initNewSetup("new", datasetId));
              if (datasetId !== undefined && datasetId !== "new" && datasetId !== "undefined") {
                dispatch(checkIgnored(id, datasetId));
                dispatch(checkAndSetDateField(datasetId, "new"));
                dispatch(updateDatasetId(id, datasetId));
              }

              if (
                datasetId !== undefined &&
                datasetId !== "new" &&
                (forceExploreCreate || selectedBlueprint?.wizard?.chatGPT)
              ) {
                return dispatch(
                  nextTransformReducer.createDefaultExplore(
                    "new",
                    undefined,
                    undefined,
                    undefined,
                    isChatGPT || Boolean(selectedBlueprint?.wizard?.chatGPT),
                    false,
                    false,
                    skipAskIntro,
                    selectedBlueprint
                  )
                ).then(() => {
                  const dataset = datasetReducer.getDataset(getState(), datasetId);
                  const newLabel = `Exploring ${
                    dataset?.outcome !== undefined ? dataset.outcome + " in " : ""
                  }${dataset.label}`;
                  dispatch(updateReportLabel(id, newLabel));

                  if (selectedBlueprint?.wizard?.chatGPT) {
                    dispatch(chatGPTReducer.selectBlueprint(selectedBlueprint.id));
                  } else if (
                    chatGPTReducer.getBlueprintId(getState()) === chatGPTReducer.DEFAULT_BLUEPRINT_ID &&
                    datasetId !== undefined &&
                    datasetId !== "new"
                  ) {
                    dispatch(chatGPTReducer.selectBlueprint(chatGPTReducer.DEFAULT_DATASET_BLUEPRINT_ID));
                  }

                  dispatch(globalReducer.updateIsNextLoading(false));
                });
              }

              if (selectedBlueprint?.wizard?.chatGPT) {
                dispatch(chatGPTReducer.selectBlueprint(selectedBlueprint.id));
              } else if (
                chatGPTReducer.getBlueprintId(getState()) === chatGPTReducer.DEFAULT_BLUEPRINT_ID &&
                datasetId !== undefined &&
                datasetId !== "new"
              ) {
                if (dataset?.outcome) {
                  dispatch(chatGPTReducer.selectBlueprint(chatGPTReducer.DEFAULT_DATASET_BLUEPRINT_ID));
                } else {
                  if (isEnabled("chat-aible-sql-queries")) {
                    dispatch(chatGPTReducer.selectBlueprint(chatGPTReducer.CHATAIBLE_SQL.id));
                  } else {
                    dispatch(chatGPTReducer.selectBlueprint(chatGPTReducer.CHATAIBLE_BLUEPRINTS.CHATAIBLE_JUST_CHAT));
                  }
                }
              }
              // We don't want this message if it's an agent, it's handled in handleChatAppStep()
              const blueprint = blueprintReducer.getBlueprint(getState(), blueprintId);
              if (!blueprintId || blueprintId === "new" || (blueprint && !blueprint?.wizard?.isChatApp)) {
                const conversationArray = chatGPTReducer.getConversationArray(getState());
                if (!conversationArray?.length) {
                  dispatch(chatGPTReducer.addNewChatMessage());
                }
              }
              dispatch(chatGPTReducer.updateShowRecommendedOptions(false));
              return dispatch(globalReducer.updateIsNextLoading(false));
            })
            .catch((e) => {
              console.log(e);
              dispatch(setupReducer.initNewSetup("new", datasetId));
              dispatch(chatGPTReducer.updateShowRecommendedOptions(false));
              return dispatch(globalReducer.updateIsNextLoading(false));
            });
        }
      });
    });
  };
}

export function createBlueprintSetup(id, datasetId, blueprintId) {
  return (dispatch, getState) => {
    const blueprint = blueprintReducer.getBlueprint(getState(), blueprintId);

    if (blueprint === undefined && blueprintId !== "new") {
      return setTimeout(() => dispatch(createBlueprintSetup(id, datasetId, blueprintId)), 1000);
    }

    dispatch(blueprintReducer.setBlueprint("new", blueprintId));

    if (blueprint && blueprint.wizard) {
      const dataset = blueprint.wizard.dataset;

      if (
        dataset !== undefined &&
        dataset.id !== undefined &&
        homeReducer.getDataset(getState(), dataset.id) === undefined
      ) {
        dispatch(homeReducer.updateDataset(dataset.id, { ...dataset, isHidden: true }));
      }
    }

    dispatch(updateReportLabel(id, blueprint?.name ? blueprint.name : "My Untitled Blueprint"));

    dispatch(setupReducer.updateDatasetId("new", datasetId));
    const successOptions = setupReducer.getSuccessOptions(getState(), "new");

    if (successOptions && successOptions.length > 0) {
      const bpSuccess = blueprint?.wizard?.setup?.success;
      let retSuccess = successOptions.find((e) => e.value === bpSuccess?.value);
      if (retSuccess === undefined) {
        retSuccess = successOptions[0];
      }

      dispatch(setupReducer.updateSuccess("new", retSuccess));
      dispatch(updateDatasetSuccess(id, retSuccess));

      dispatch(setupReducer.checkCounts(id, datasetId));
    }

    dispatch(nextModelsReducer.updateIsLoading(id, false));
    dispatch(updateActiveTab(id, "MODELS"));

    if (blueprint?.wizard?.nextObj?.modelsReducer) {
      dispatch(nextModelsReducer.updateModels(id, blueprint?.wizard?.nextObj?.modelsReducer));
    }

    if (blueprint?.wizard?.chatGPT) {
      dispatch(chatGPTReducer.selectBlueprint(blueprint.id));
    }

    return Promise.resolve();
  };
}

export function updateScrollReportTitle(id, val) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    key: "scrollReportTitle",
    data: val
  };
}

export function scrollReportByTitle(id, node) {
  return (dispatch, getState) => {
    if (id === undefined) {
      id = getCurrentNextId(getState());
    }
    const chartTitle = isNaN(node) ? node?.chart?.title : parseInt(node);
    dispatch(updateScrollReportTitle(id, chartTitle));
    setTimeout(() => {
      dispatch(updateScrollReportTitle(id, undefined));
    }, 5);
    // setTimeout(() => {
    //   document.getElementById("nextChartReport_" + node?.chart?.title) &&
    //     document
    //       .getElementById("nextChartReport_" + node?.chart?.title)
    //       .scrollIntoView({
    //         behavior: "smooth",
    //         block: "end",
    //         inline: "nearest",
    //       });
    // }, 80);
  };
}

/* Misc Functions */
export function centerHex(hex, isSmooth = false, isScrollReport = true) {
  const hKey = hex ? hex.x + "_" + hex.y : "undefined";

  const hexTile =
    document.getElementById("hexTile_" + hKey) ||
    document.getElementById("hexTile_" + hKey + "_0") ||
    document.getElementById("hexTile_" + hKey + "_a") ||
    document.getElementById("hexTile_" + hKey + "_n");

  hexTile &&
    hexTile.scrollIntoView({
      block: "center",
      inline: "center",
      behavior: isSmooth ? "smooth" : "auto"
    });

  isScrollReport === true &&
    setTimeout(() => {
      document.getElementById("reportChart_" + hKey) &&
        document.getElementById("reportChart_" + hKey).element &&
        document.getElementById("reportChart_" + hKey).element.scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "nearest"
        });
    }, 100);
}

export function addFineTuneRow(id, fineTuneRow) {
  return (dispatch, getState) => {
    const fineTuneRows = getFineTuneRows(getState(), id);

    const updatedRows = {
      ...fineTuneRows,
      ["Training_Data_" + Object.keys(fineTuneRows).length]: fineTuneRow
    };

    return dispatch(updateFineTuneRows(id, updatedRows));
  };
}

export function updateCurrentArtifact(id, currentArtifact) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: currentArtifact,
    key: "currentArtifact"
  };
}

export function updateFineTuneRows(id, fineTuneRows) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: fineTuneRows,
    key: "fineTuneRows"
  };
}

export function updateIsPowerBI(id, isPowerBI) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: isPowerBI,
    key: "isPowerBI"
  };
}

export function updateIsLookerDashboard(id, isLookerDashboard) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: isLookerDashboard,
    key: "isLookerDashboard"
  };
}

export function updateIsLookerLoading(id, isLookerLoading) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: isLookerLoading,
    key: "isLookerLoading"
  };
}

export function updateLookerCount(id, lookerCount) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: lookerCount,
    key: "lookerCount"
  };
}

export function updateLookerDashboardElementCount(id, lookerDashboardElementCount) {
  return {
    type: UPDATE_FIELD_VALUE,
    id: id,
    data: lookerDashboardElementCount,
    key: "lookerDashboardElementCount"
  };
}

export function createDashboardLineChart(id, state, view, dataset, dimField, pColumns, dashboardId) {
  return new Promise((resolve, reject) => {
    const lookerAPIClient = loginReducer.getLookerAPIClient(state);

    const outcome = dataset?.outcome;
    const successValue = getDatasetSuccess(state, id)?.value;
    const isSuccess = successValue === dataset?.target_value?.[0];

    const retOutcome = outcome.toLowerCase().replace(/ /g, "_");
    const retDimField = dimField.toLowerCase().replace(/ /g, "_");

    const modelName = lookerSettingsReducer.getLookerModelName(state);

    const vConfig = {
      type: "looker_line",
      x_axis_gridlines: false,
      y_axis_gridlines: true,
      show_view_names: false,
      show_y_axis_labels: true,
      show_y_axis_ticks: true,
      y_axis_tick_density: "default",
      y_axis_tick_density_custom: 5,
      show_x_axis_label: true,
      show_x_axis_ticks: true,
      y_axis_scale_mode: "linear",
      x_axis_reversed: false,
      y_axis_reversed: false,
      plot_size_by_field: false,
      trellis: "",
      stacking: "",
      limit_displayed_rows: false,
      legend_position: "center",
      point_style: "none",
      show_value_labels: false,
      label_density: 25,
      x_axis_scale: "auto",
      y_axis_combined: true,
      show_null_points: true,
      interpolation: "linear",
      ordering: "none",
      width: 20,
      height: 10,
      row: 0,
      col: 0,
      show_null_labels: false,
      show_totals_labels: false,
      show_silhouette: false,
      totals_color: "#808080",
      defaults_version: 1,
      series_types: {},
      series_labels: {}
    };

    const measureName = "average_of_" + retOutcome;

    const dynamic_fields = [
      {
        category: "dimension",
        expression: "if(${" + view + "." + retOutcome + "} = " + (isSuccess ? "yes" : "no") + ", 100, 0)",
        label: outcome + "_fixed",
        value_format: null,
        value_format_name: null,
        dimension: outcome + "_fixed",
        _kind_hint: "dimension",
        _type_hint: "yesno"
      },
      {
        measure: measureName,
        based_on: outcome + "_fixed",
        expression: "",
        label: "Average of " + outcome,
        type: "average",
        _kind_hint: "measure",
        _type_hint: "number"
      }
    ];

    let req = {
      client_id: 2,
      model: modelName,
      view: view,
      fields: [measureName, view + "." + retDimField],
      pivots: [],
      sorts: [view + "." + retDimField],
      filters: {},
      dynamic_fields: JSON.stringify(dynamic_fields),
      limit: 500,
      vis_config: vConfig
    };
    let retFilters = {};

    /*
    Object.keys(pColumns).forEach((pField) => {
      Object.keys(vConfig.series_labels).forEach((sKey) => {
        dataset.fields[pField].data.forEach((pVal) => {
          const retVal =
            dataset.fields[pField].type === "number"
              ? Math.round(pVal.value).toFixed(0)
              : pVal.value;
          vConfig.series_labels[sKey + " - " + retVal] =
            vConfig.series_labels[sKey] + " and " + pField + " is " + retVal;
        });
      });

      //[]
    });
    */

    let nColumns = JSON.parse(JSON.stringify(pColumns));
    const labels = buildLabels(nColumns);
    vConfig.series_labels = labels;

    Object.keys(pColumns).forEach((pField) => {
      const rField = pField.toLowerCase().replace(/ /g, "_");
      req.fields.push(view + "." + rField);
      req.pivots.push(view + "." + rField);

      const dataField = dataset.fields[pField];

      if (
        true ||
        (pColumns[pField] &&
          pColumns[pField].length > 1 &&
          dataField.data.find((d) => d.value === pColumns[pField][0]) !== undefined)
      ) {
        retFilters[view + "." + rField] = pColumns[pField].reduce((a, b) => a + (a === "" ? "" : ", ") + b, "");
      } else {
      }
    });

    req.filters = retFilters;

    return lookerAPIClient.create_query(req).then((queryResponse) => {
      //console.log("query req?", queryResponse);

      const dashReq = {
        body: {
          query_id: queryResponse.value.id + "",
          query: queryResponse.value,
          type: "vis",
          title: dimField,
          dashboard_id: dashboardId
        }
      };

      return lookerAPIClient.create_dashboard_element(dashReq).then((r) => resolve(r));
    });
  });
}

export function buildLabels(nColumns) {
  let retColumns = JSON.parse(JSON.stringify(nColumns));

  let retLines = {};
  let nextLines = {};

  Object.keys(retColumns).forEach((nKey, i) => {
    const values = retColumns[nKey];

    if (i === 0) {
      values.forEach((val) => {
        retLines[val] = nKey + " is " + val;
      });
    } else {
      Object.keys(retLines).forEach((lKey) => {
        values.forEach((val) => {
          nextLines[lKey + " - " + val] = retLines[lKey] + " and " + nKey + " is " + val;
        });
      });

      Object.keys(nextLines).forEach((nextLineKey) => {
        retLines[nextLineKey] = nextLines[nextLineKey];
      });
    }
  });

  return retLines;
}

export function createDashboardBarChart(id, state, view, dataset, chart, dashboardId) {
  return new Promise((resolve, reject) => {
    const lookerAPIClient = loginReducer.getLookerAPIClient(state);

    const outcome = dataset?.outcome;
    const successValue = getDatasetSuccess(state, id)?.value;
    const isSuccess = successValue === dataset?.target_value?.[0];

    const dimField = chart?.metadata?.properties?.[0]?.column;
    const filterField = chart?.metadata?.properties?.[1]?.column;
    const filterValue = chart?.metadata?.properties?.[1]?.value;

    if (filterValue === undefined) {
      return resolve();
    }

    const retOutcome = outcome.toLowerCase().replace(/ /g, "_");
    const retDimField = dimField.toLowerCase().replace(/ /g, "_");
    const retFilterField = filterField.toLowerCase().replace(/ /g, "_");
    const retFilterValue = filterValue.toLowerCase().replace(/ /g, "_");

    const measureName = "average_of_" + retOutcome;
    const dimensionName = retFilterField + "_pivot";

    const vConfig = {
      type: "looker_column",
      x_axis_gridlines: false,
      y_axis_gridlines: true,
      show_view_names: false,
      show_y_axis_labels: true,
      show_y_axis_ticks: true,
      y_axis_tick_density: "default",
      y_axis_tick_density_custom: 5,
      show_x_axis_label: true,
      show_x_axis_ticks: true,
      y_axis_scale_mode: "linear",
      x_axis_reversed: false,
      y_axis_reversed: false,
      plot_size_by_field: false,
      trellis: "",
      stacking: "",
      limit_displayed_rows: false,
      legend_position: "center",
      point_style: "none",
      show_value_labels: false,
      label_density: 25,
      x_axis_scale: "auto",
      y_axis_combined: true,
      ordering: "none",
      show_null_labels: false,
      show_totals_labels: false,
      show_silhouette: false,
      totals_color: "#808080",
      defaults_version: 1,
      series_types: {},
      series_colors: {
        ["Yes - " + measureName]: chart.color,
        ["No - " + measureName]: "rgb(153, 153, 153)"
      },
      series_labels: {
        ["No - " + measureName]: "All Others",
        ["Yes - " + measureName]: filterField + " is " + filterValue
      }
    };

    const dynamic_fields = [
      {
        category: "dimension",
        expression: "if(${" + view + "." + retOutcome + "} = " + (isSuccess ? "yes" : "no") + ", 100, 0)",
        label: outcome + "_fixed",
        value_format: null,
        value_format_name: null,
        dimension: outcome + "_fixed",
        _kind_hint: "dimension",
        _type_hint: "yesno"
      },
      {
        category: "dimension",
        expression: "${" + view + "." + retFilterField + '} = "' + filterValue + '"',
        label: filterField + " is " + filterValue,
        value_format: null,
        value_format_name: null,
        dimension: dimensionName,
        _kind_hint: "dimension",
        _type_hint: "yesno"
      },
      {
        measure: measureName,
        based_on: outcome + "_fixed",
        expression: "",
        label: "Average of " + outcome,
        type: "average",
        _kind_hint: "measure",
        _type_hint: "number"
      }
    ];

    const modelName = lookerSettingsReducer.getLookerModelName(state);

    let req = {
      client_id: 2,
      model: modelName,
      view: view,
      fields: [measureName, view + "." + retDimField, dimensionName],
      pivots: [dimensionName],
      sorts: [dimensionName + " desc", view + "." + retDimField],
      dynamic_fields: JSON.stringify(dynamic_fields),
      limit: 500,
      vis_config: vConfig
    };
    let retFilters = {};

    return lookerAPIClient.create_query(req).then((queryResponse) => {
      const dashReq = {
        body: {
          query_id: queryResponse.value.id + "",
          query: queryResponse.value,
          type: "vis",
          title: dimField + " when " + filterField + " is " + filterValue,
          body_text: chart?.narrative?.topText,
          note_text: chart?.narrative?.topText,
          note_display: "above",
          note_state: "visible",
          dashboard_id: dashboardId
        }
      };

      return lookerAPIClient.create_dashboard_element(dashReq).then((r) => resolve(r));
    });
  });
}

export function createDashboardSingleBarChart(id, state, view, dataset, chart, dashboardId) {
  const lookerAPIClient = loginReducer.getLookerAPIClient(state);

  const outcome = dataset?.outcome;
  const successValue = getDatasetSuccess(state, id)?.value;
  const isSuccess = successValue === dataset?.target_value?.[0];

  const dimField = chart?.metadata?.properties?.[0]?.column;

  const retOutcome = outcome.toLowerCase().replace(/ /g, "_");
  const retDimField = dimField.toLowerCase().replace(/ /g, "_");

  const measureName = "average_of_" + retOutcome;

  const vConfig = {
    type: "looker_column",
    x_axis_gridlines: false,
    y_axis_gridlines: true,
    show_view_names: false,
    show_y_axis_labels: true,
    show_y_axis_ticks: true,
    y_axis_tick_density: "default",
    y_axis_tick_density_custom: 5,
    show_x_axis_label: true,
    show_x_axis_ticks: true,
    y_axis_scale_mode: "linear",
    x_axis_reversed: false,
    y_axis_reversed: false,
    plot_size_by_field: false,
    trellis: "",
    stacking: "",
    limit_displayed_rows: false,
    legend_position: "center",
    point_style: "none",
    show_value_labels: false,
    label_density: 25,
    x_axis_scale: "auto",
    y_axis_combined: true,
    ordering: "none",
    show_null_labels: false,
    show_totals_labels: false,
    show_silhouette: false,
    totals_color: "#808080",
    defaults_version: 1,
    series_types: {},
    series_colors: {
      [measureName]: chart.color
    }
  };

  const dynamic_fields = [
    {
      category: "dimension",
      expression: "if(${" + view + "." + retOutcome + "} = " + (isSuccess ? "yes" : "no") + ", 100, 0)",
      label: outcome + "_fixed",
      value_format: null,
      value_format_name: null,
      dimension: outcome + "_fixed",
      _kind_hint: "dimension",
      _type_hint: "yesno"
    },
    {
      measure: measureName,
      based_on: outcome + "_fixed",
      expression: "",
      label: "Average of " + outcome,
      type: "average",
      _kind_hint: "measure",
      _type_hint: "number"
    }
  ];

  const modelName = lookerSettingsReducer.getLookerModelName(state);
  let req = {
    client_id: 2,
    model: modelName,
    view: view,
    fields: [measureName, view + "." + retDimField],
    pivots: [],
    sorts: [view + "." + retDimField],
    dynamic_fields: JSON.stringify(dynamic_fields),
    limit: 500,
    vis_config: vConfig
  };
  let retFilters = {};

  return lookerAPIClient.create_query(req).then((queryResponse) => {
    const dashReq = {
      body: {
        query_id: queryResponse.value.id + "",
        query: queryResponse.value,
        type: "vis",
        title: dimField,
        body_text: chart?.narrative?.topText,
        note_text: chart?.narrative?.topText,
        note_display: "above",
        note_state: "visible",
        dashboard_id: dashboardId
      }
    };

    return lookerAPIClient.create_dashboard_element(dashReq).then((r) => r);
  });
}

export function lookerCreateDashboard(state, datasetId) {
  const dataset = homeReducer.getDataset(state, datasetId);
  const lookerAPIClient = loginReducer.getLookerAPIClient(state);
  const SPACE_ID = "dev";
  const dashTitle = dataset?.name + " (" + dataset?.id + ") Dashboard";

  const result = lookerAPIClient.me().then((result) => console.log(result));

  return lookerAPIClient.all_dashboards().then((allResponse) => {
    if (allResponse?.value) {
      const foundDash = allResponse.value.find((d) => d.title === dashTitle);

      if (foundDash) {
        return foundDash;
      }
    }

    const dashboard = {
      title: dashTitle,
      space_id: SPACE_ID,
      Title: dashTitle,
      Space_id: SPACE_ID
    };
    return lookerAPIClient
      .create_dashboard({
        body: dashboard,
        title: dashTitle,
        space_id: SPACE_ID
      })
      .then((r) => r);
  });
}

export function clearDashboard(state, dashboardId) {
  const lookerAPIClient = loginReducer.getLookerAPIClient(state);

  return lookerAPIClient.dashboard_dashboard_elements(dashboardId).then((r) => {
    if (r?.value) {
      r.value.forEach((dashElement) => {
        lookerAPIClient.delete_dashboard_element(dashElement.id).then((r) => r);
      });
    }
  });
}

export function buildDashboard(id, datasetId, dashboardId, forceCharts = undefined) {
  return (dispatch, getState) => {
    dispatch(updateIsLookerLoading(id, true));
    const dataset = homeReducer.getDataset(getState(), datasetId);
    const dashboardCharts = getAllDashboardCharts(getState(), id);
    const searchInsights = forceCharts !== undefined ? forceCharts : getSearchInsights(getState(), id);

    const tableName = "aible_dataset_" + datasetId + "_binned";

    let promises = [];

    let order = [];

    if (searchInsights && searchInsights.length > 0) {
      searchInsights.forEach((searchChart, i) => {
        order.push(searchChart?.title);

        if (searchChart?.metadata?.properties.length === 2) {
          const barPromise = createDashboardBarChart(id, getState(), tableName, dataset, searchChart, dashboardId);

          promises.push(barPromise);
        } else if (searchChart?.metadata?.properties.length === 1) {
          const barPromise = createDashboardSingleBarChart(
            id,
            getState(),
            tableName,
            dataset,
            searchChart,
            dashboardId
          );

          promises.push(barPromise);
        }
      });
    } else {
      dashboardCharts.forEach((dashChart, i) => {
        const childKeys = dashChart?.childKeys.filter((c, i) => i < 5).reduce((a, b) => a + "," + b.otherValue, "");

        let pColumns = {};

        dashChart?.childKeys &&
          dashChart?.childKeys
            .filter((c, i) => i < 5)
            .forEach((cKey) => {
              if (pColumns[cKey.otherKey] === undefined) {
                pColumns[cKey.otherKey] = [cKey.otherValue];
              } else {
                pColumns[cKey.otherKey].push(cKey.otherValue);
              }
            });

        const linePromise = createDashboardLineChart(
          id,
          getState(),
          tableName,
          dataset,
          dashChart?.title,
          pColumns,
          dashboardId
        );

        promises.push(linePromise);
        order.push(dashChart?.title);

        for (let i = 0; i < 3; i++) {
          if (dashChart?.secondaryCharts?.[i] !== undefined) {
            promises.push(
              createDashboardBarChart(id, getState(), tableName, dataset, dashChart?.secondaryCharts?.[i], dashboardId)
            );

            order.push(dashChart?.secondaryCharts?.[i]?.title);
          }
        }
      });
    }

    return Promise.allSettled(promises).then((responses) => {
      const lookerAPIClient = loginReducer.getLookerAPIClient(getState());

      lookerAPIClient.dashboard_layout_dashboard_layout_components(dashboardId).then((r) => {
        let layoutPromises = [];
        const layoutElements = r.value;

        layoutElements &&
          layoutElements.forEach((layoutEle) => {
            const fIndex = order.indexOf(layoutEle?.element_title);

            if (fIndex !== -1) {
              const layoutPromise = layoutPromises.push(
                new Promise((resolve, reject) => {
                  const retIndex = order.indexOf(layoutEle?.element_title);

                  return lookerAPIClient
                    .update_dashboard_layout_component(layoutEle.id, {
                      col: retIndex % 3 === 0 ? 0 : retIndex % 3 === 1 ? 8 : 16,
                      row: Math.floor(retIndex + 3 / 4) * 9,
                      height: 9,
                      width: layoutEle?.element_title && layoutEle?.element_title.indexOf(" is ") !== -1 ? 8 : 24
                    })
                    .then((upl) => {
                      dispatch(
                        updateLookerDashboardElementCount(id, getLookerDashboardElementCount(getState(), id) + 1)
                      );

                      return resolve(upl);
                    });
                })
              );
            }
          });

        return Promise.all(layoutPromises).then((layR) => {
          dispatch(updateIsLookerDashboard(id, dashboardId));
          dispatch(updateIsLookerLoading(id, false));

          return setTimeout(() => {
            const lookerCount = getLookerCount(getState(), id);
            return dispatch(updateLookerCount(id, lookerCount + 1));
          }, 50);
        });
      });

      return Promise.resolve();
    });
  };
}

export function createFirstDashboard(id) {}

export function openLookerDashboard(id) {
  dispatch(push("/project_next/" + 3));
}

async function getDashboardForDataset(state, id, datasetId) {
  const coreSDK = loginReducer.getLookerAPIClient(state);
  const searchOptions = getSearchOptions(state, id);
  const pinnedHexList = getPinnedHexList(state, id);

  const meResponse = await coreSDK.me();

  const searchResponse = await coreSDK.search_folders({});
  if (searchResponse.value && searchResponse.value.length > 0) {
    const folder = searchResponse.value.find((f) => f.name === meResponse?.value?.display_name);

    const searchString =
      searchOptions === undefined || searchOptions.length === 0
        ? ""
        : "_" +
          (searchOptions?.[0].filterField
            ? searchOptions?.[0].filterField + "_" + searchOptions?.[0].filterValue
            : searchOptions?.[0].field
              ? searchOptions?.[0].field
              : "") +
          "_+" +
          searchOptions.length;

    const dashTitle = "Aible Generated Dashboard (" + datasetId + ")" + searchString;

    const foundDashboard = folder.dashboards.find((d) => d.title === dashTitle);
    if (foundDashboard !== undefined) {
      return foundDashboard?.id;
    } else {
      const createDashResponse = await coreSDK.create_dashboard({
        title: dashTitle,
        folder_id: folder?.id
      });

      const dashboardId = createDashResponse?.value?.id;

      return dashboardId;
    }
  } else {
    // Could create folder here but probably won't have permissions
  }
}

export function createDashboard(id, messageId) {
  return (dispatch, getState) => {
    dispatch(updateIsLookerLoading(id, true));
    dispatch(updateLookerDashboardElementCount(id, 0));

    const datasetId = getDatasetId(getState(), id);

    getDashboardForDataset(getState(), id, datasetId).then((dashboardId) => {
      dispatch(globalReducer.updateLookerDashboardId(dashboardId));

      clearDashboard(getState(), dashboardId).then((clearResponse) => {
        if (messageId !== undefined) {
          const charts = chatGPTReducer.getChartsFromMessage(getState(), messageId);
          console.log("BOOM GOES THE DASHBOARD", charts);

          return dispatch(buildDashboard(id, datasetId, dashboardId, charts));
        } else {
          return dispatch(buildDashboard(id, datasetId, dashboardId));
        }
      });
    });
  };
}

export function openBenchmark(chatAppId, skipFetch = false) {
  return (dispatch, getState) => {
    const chatApp = blueprintReducer.getBlueprint(getState(), chatAppId);
    if (chatApp === undefined) {
      setTimeout(() => dispatch(openBenchmark(chatAppId, skipFetch)), 250);
      return;
    }

    const datasetId = chatApp?.wizard?.steps?.[0]?.datasetId;
    const dataset = homeReducer.getDataset(getState(), datasetId);
    if (!dataset) {
      if (!skipFetch) {
        dispatch(homeReducer.fetchDataset(datasetId, undefined, true));
      }
      return setTimeout(() => {
        return dispatch(openBenchmark(chatAppId, true));
      }, 250);
    }

    const outcomeState = getDatasetOutcome(getState(), datasetId);

    const outcomeSuccess = outcomeState.outcomeSuccess;
    const successOptions = homeReducer.getSuccessOptions(getState(), datasetId, dataset, dataset?.outcome);
    const defaultSuccess = homeReducer.getDefaultSuccess(getState(), datasetId);

    const minimumValueCounts = getDatasetMinimumValueCount(getState(), datasetId);

    const outcomeOptions =
      dataset?.fields?.[dataset?.outcome]?.type !== "number" && dataset?.fields?.[dataset?.outcome]?.data
        ? successOptions?.map((o) => ({
            value: o.value,
            label: o.label
          }))
        : undefined;

    const outcomeValue =
      outcomeSuccess ?? outcomeOptions?.find((o) => o?.value === defaultSuccess) ?? outcomeOptions?.[0];

    dispatch(openExploration(dataset?.id, outcomeValue, undefined, minimumValueCounts)).then(() => {
      if (chatApp?.wizard?.steps?.[0]?.chatBlueprintId) {
        dispatch(chatGPTReducer.selectBlueprint(chatApp?.wizard?.steps?.[0]?.chatBlueprintId));
      }
      if (chatApp?.wizard?.name) {
        dispatch(updateReportLabelAndContentGenerationCollection("new", chatApp?.wizard?.name));
      }
      dispatch(updateDashboardLayout("new", { value: "INFO", label: "Benchmark View" }));
    });
  };
}

export function createFocusedDataset(chart) {
  return async (dispatch, getState) => {
    let {
      metadata: { properties },
      title
    } = chart;

    const nextId = getCurrentNextId(getState());

    const datasetId = getDatasetId(getState(), nextId);

    if (getLinkedOriginalDatasetId(getState(), nextId) === undefined) {
      dispatch(updateLinkedOriginalDatasetId(nextId, datasetId));
    }

    let originalNextId = nextId === "new" ? await dispatch(saveNext(nextId, undefined, false)) : nextId;

    const linkedComparisonProjects = getLinkedComparisonProjects(getState(), originalNextId);

    if (
      Object.keys(linkedComparisonProjects ?? {}).length > 0 &&
      linkedComparisonProjects["@_Original_@"] != originalNextId
    ) {
      const foundPair = Object.entries(linkedComparisonProjects).find(([key, nextId]) => nextId == originalNextId);

      if (foundPair !== undefined) {
        title = `${foundPair[0]} and ${title}`;
        originalNextId = linkedComparisonProjects["@_Original_@"] ?? originalNextId;
      }
    }

    const retIsLinkedComparisonCreating = {
      ...(getIsLinkedComparisonCreating(getState(), originalNextId) ?? {}),
      [title]: true
    };

    dispatch(updateIsLinkedComparisonCreating(originalNextId, retIsLinkedComparisonCreating));

    toast(<div>{"Creating Focus What's Changed for " + title}</div>, {
      type: toast.TYPE.SUCCESS,
      position: toast.POSITION.TOP_CENTER,
      autoClose: 8000
    });

    const dataset = homeReducer.getDataset(getState(), datasetId);

    const relationBuilder = builderFromDataset(dataset).filter(buildFilterExpression(properties));
    const relationObj = relationBuilder.build();

    // Setting name
    const name = dataset?.name + "_focused_" + title;
    // create dataset
    let newDataset;
    try {
      newDataset = await dispatch(relationReducer.copyAndTransform(datasetId, name, relationObj));
      if (!newDataset) {
        throw new Error("There was an error creating the dataset");
      }
    } catch (e) {
      console.log(e);
      throw e;
    }

    //return await dispatch(waitForDatasetComparison(originalNextId, 10002, title));
    return await dispatch(waitForDatasetComparison(originalNextId, newDataset?.id, title));
  };
}

export function waitForDatasetComparison(originalNextId, newDatasetId, title) {
  return async (dispatch, getState) => {
    const dataset = homeReducer.getDataset(getState(), newDatasetId);

    const isCreatingFocusedDataset = globalReducer.getIsCreatingFocusedDataset(getState());

    if (dataset?.status_name === "ERROR") {
      return dispatch(errorLinkedComparisonProjects(originalNextId, newDatasetId, title));
    }
    if (dataset?.status_name !== "DONE" || isCreatingFocusedDataset === true) {
      return delay(1500).then(() => dispatch(waitForDatasetComparison(originalNextId, newDatasetId, title)));
    } else {
      return dispatch(saveLinkedComparisonProjects(originalNextId, newDatasetId, title));
    }
  };
}

export function removeFocusedDataset(chart) {
  return async (dispatch, getState) => {
    try {
      let { title } = chart;

      let currentNextId = getCurrentNextId(getState());
      let linkedComparisonProjects = getLinkedComparisonProjects(getState(), currentNextId) ?? {};

      // If we're currently in a focused project, hop to the original project map first.
      if (
        Object.keys(linkedComparisonProjects).length > 0 &&
        linkedComparisonProjects["@_Original_@"] !== undefined &&
        linkedComparisonProjects["@_Original_@"] !== currentNextId
      ) {
        currentNextId = linkedComparisonProjects["@_Original_@"];
        linkedComparisonProjects = getLinkedComparisonProjects(getState(), currentNextId) ?? linkedComparisonProjects;
      }

      if (Object.keys(linkedComparisonProjects).length === 0) {
        return Promise.resolve();
      }

      // Normalize title if this chart is from a focused project opened via pair naming.
      const foundPair = Object.entries(linkedComparisonProjects).find(([k, nId]) => {
        if (k === "@_Original_@") return false;
        const dId = getDatasetId(getState(), nId);
        const currDatasetId = getDatasetId(getState(), currentNextId);
        return dId === currDatasetId;
      });
      if (foundPair !== undefined && foundPair[0] !== title && !title?.startsWith(`${foundPair[0]} and `)) {
        title = `${foundPair[0]} and ${title}`;
      }

      const focusedNextId = linkedComparisonProjects?.[title];
      if (focusedNextId === undefined) {
        return Promise.resolve();
      }

      const newLinkedComparisonProjects = { ...linkedComparisonProjects };
      delete newLinkedComparisonProjects[title];

      // Always keep original pointer so comparison remains anchored.
      if (newLinkedComparisonProjects["@_Original_@"] === undefined) {
        newLinkedComparisonProjects["@_Original_@"] = currentNextId;
      }

      // Update all remaining linked projects to remove the focused mapping.
      for (const k of Object.keys(newLinkedComparisonProjects)) {
        const nId = newLinkedComparisonProjects[k];
        dispatch(updateLinkedComparisonProjects(nId, newLinkedComparisonProjects));
        await dispatch(saveNext(nId, undefined, false, true));
      }

      const focusedDatasetId = getDatasetId(getState(), focusedNextId);
      const focusedProjectId = getProjectId(getState(), focusedNextId);

      // If user is currently on removed focused project, route back to original.
      if (getCurrentNextId(getState()) === focusedNextId) {
        dispatch(updateCurrentNextId(currentNextId));
      }

      if (focusedProjectId !== undefined) {
        await dispatch(projectReducer.handleDelete(focusedProjectId, true));
      }

      await ReportAPI.deleteReport(focusedNextId);
      dispatch(reportReducer.localDeleteReport(focusedNextId));
      dispatch(nextTransformReducer.updateTransform(focusedNextId, undefined));
      dispatch(nextModelsReducer.updateModels(focusedNextId, undefined));

      if (focusedDatasetId !== undefined && !isNaN(Number(focusedDatasetId))) {
        DatasetAPI.deleteDataset(Number(focusedDatasetId)).catch((e) => {
          console.log("removeFocusedDataset dataset delete error", e);
        });
      }

      toast(<div>{"Focused What's Changed for " + title + " has been permanently removed."}</div>, {
        type: toast.TYPE.SUCCESS,
        position: toast.POSITION.TOP_CENTER,
        autoClose: 8000
      });

      openComparisonProject(currentNextId);

      return Promise.resolve();
    } catch (e) {
      console.log("removeFocusedDataset error", e);
      toast(<div>{"There was an error removing your focused project. Please try again."}</div>, {
        type: toast.TYPE.ERROR,
        position: toast.POSITION.TOP_CENTER,
        autoClose: 8000
      });
      throw e;
    }
  };
}

export function errorLinkedComparisonProjects(originalNextId, newDatasetId, title) {
  return async (dispatch, getState) => {
    const retIsLinkedComparisonCreating = {
      ...(getIsLinkedComparisonCreating(getState(), originalNextId) ?? {}),
      [title]: false
    };

    return dispatch(updateIsLinkedComparisonCreating(originalNextId, retIsLinkedComparisonCreating));
  };
}

export function saveLinkedComparisonProjects(originalNextId, newDatasetId, title) {
  return async (dispatch, getState) => {
    dispatch(globalReducer.updateIsCreatingFocusedDataset(true));

    const comparisonOptions = await getComparisonOptions(getState(), originalNextId);

    const createNextId = "new";

    const newDataset = homeReducer.getDataset(getState(), newDatasetId);

    const outcomeValue = {
      label: newDataset?.target_value?.[0],
      value: newDataset?.target_value?.[0]
    };

    const oldNewNext = getNext(getState(), "new");

    await dispatch(init(createNextId, newDatasetId));
    const awaitOpen = await dispatch(
      openExploration(newDatasetId, outcomeValue, comparisonOptions, 0, false, undefined, undefined, true)
    );

    dispatch(updateSavedNextId(createNextId, undefined));

    const originalDatasetId = getDatasetId(getState(), originalNextId);

    dispatch(updateLinkedOriginalDatasetId(createNextId, originalDatasetId));

    // Save hidden charts into the focused deep dive
    const hiddenCharts = getHiddenCharts(getState(), originalNextId);
    dispatch(updateHiddenCharts(createNextId, hiddenCharts));

    const focusedNext = await dispatch(saveNext(createNextId, undefined, false, true));
    console.log("focusedNext? ", focusedNext);

    const retIsLinkedComparisonCreating = {
      ...(getIsLinkedComparisonCreating(getState(), originalNextId) ?? {}),
      [title]: false
    };

    dispatch(updateIsLinkedComparisonCreating(originalNextId, retIsLinkedComparisonCreating));

    const originalLinkedComparisonProjects = getLinkedComparisonProjects(getState(), originalNextId);

    console.log("originalLinkedComparisonProjects originalNextId", originalLinkedComparisonProjects, originalNextId);

    const retOriginalLinkedComparisonProjects = {
      ...(originalLinkedComparisonProjects ?? { ["@_Original_@"]: originalNextId }),
      [title]: focusedNext
    };

    for (const k of Object.keys(retOriginalLinkedComparisonProjects)) {
      const retNextId = retOriginalLinkedComparisonProjects[k];

      dispatch(updateLinkedComparisonProjects(retNextId, retOriginalLinkedComparisonProjects));
      await dispatch(saveNext(retNextId, undefined, false, true));
    }

    toast(
      <div onClick={() => dispatch(helperOpenComparisonProject(focusedNext))}>
        {"Focus What's Changed for " + title + " has been created! Click here to navigate to the project."}
      </div>,
      {
        type: toast.TYPE.SUCCESS,
        position: toast.POSITION.TOP_CENTER,
        autoClose: 15000
      }
    );

    dispatch(updateCurrentNextId(originalNextId));

    if (oldNewNext !== undefined) {
      dispatch(updateNext("new", oldNewNext));
    }

    return dispatch(globalReducer.updateIsCreatingFocusedDataset(false));
  };
}

export function helperOpenComparisonProject(nextId) {
  return async (dispatch, getState) => {
    const currentNextId = getCurrentNextId(getState());
    const currentActiveTab = getActiveTab(getState(), currentNextId);

    const next = getNext(getState(), nextId) ?? {};

    if (Object.keys(next).length === 0) {
      await dispatch(reportReducer.fetchReport(nextId));
    }

    if (currentActiveTab === "CHATGPT") {
      const nDatasetId = getDatasetId(getState(), nextId);
      return dispatch(updateDatasetId(currentNextId, nDatasetId));
    } else {
      return dispatch(openComparisonProject(nextId));
    }
  };
}

export function openComparisonProject(nextId, isSkipUpdateActiveTab = false, forceActiveTab = undefined) {
  return async (dispatch, getState) => {
    const currentNextId = getCurrentNextId(getState());
    const currentActiveTab = getActiveTab(getState(), currentNextId);

    dispatch(globalReducer.updateIsOpeningComparison(true));

    // Can't open a project while another one is creating
    const isCreatingFocusedDataset = globalReducer.getIsCreatingFocusedDataset(getState());
    if (isCreatingFocusedDataset === true) {
      return setTimeout(() => dispatch(openComparisonProject(nextId)), 1000);
    }

    let next = getNext(getState(), nextId) ?? {};

    if (Object.keys(next).length === 0) {
      await dispatch(reportReducer.fetchReport(nextId));
      next = getNext(getState(), nextId) ?? {};
    }

    const nextTransform = nextTransformReducer.getTransform(getState(), nextId) ?? {};

    if (Object.keys(nextTransform).length === 0 || Object.keys(next?.hexMap ?? {}).length === 0 || true) {
      await dispatch(init(nextId, next?.datasetId, false, undefined, false, false, undefined, undefined, false, true));
    }

    const nDatasetId =
      next?.datasetId ?? getDatasetId(getState(), nextId) ?? getLinkedOriginalDatasetId(getState(), nextId);

    await dispatch(push("/next/" + nDatasetId + "/" + nextId));

    dispatch(updateCurrentNextId(nextId));

    if (forceActiveTab) {
      await dispatch(updateActiveTab(nextId, forceActiveTab, true));
    } else if (isSkipUpdateActiveTab !== true) {
      await dispatch(updateActiveTab(nextId, currentActiveTab, true));
    }

    dispatch(globalReducer.updateIsOpeningComparison(false));

    return Promise.resolve();
  };
}

// Function for switching between a what's changed/optimize project
// Resets state like a NextWrapper unmount, then a nextInit().
// Used in NextHeaderTabs.
export function switchProjectInChat(
  currentReportInfo,
  newReportInfo,
  uiState,
  includePreviousReportId = false,
  scrollTo = undefined
) {
  return (dispatch, getState) => {
    dispatch(updateNext(currentReportInfo?.reportId, undefined));
    dispatch(globalReducer.updateIsSkipNextInit(undefined));
    dispatch(updateCurrentNextId("new"));
    dispatch(setupReducer.resetSetupToDefault("new"));
    dispatch(chatGPTReducer.resetGPT());
    dispatch(globalReducer.updateIsSkipChatGPTInit(undefined));
    dispatch(globalReducer.updateIsSkipChatGPTReset(undefined));
    dispatch(chatAppReducer.resetChatApp());
    dispatch(
      push(
        "/next/" + newReportInfo?.datasetId + "/" + newReportInfo?.reportId,
        includePreviousReportId
          ? {
              previousReportData: currentReportInfo
            }
          : undefined
      )
    );
    dispatch(
      init(
        newReportInfo?.reportId,
        newReportInfo?.datasetId,
        true,
        undefined,
        undefined,
        undefined,
        undefined,
        uiState,
        undefined,
        undefined,
        undefined,
        undefined,
        true,
        undefined,
        scrollTo ? scrollTo : undefined
      )
    );
  };
}

export default nextReducer;
